var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _rect, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2729,
    height: 2703,
    viewBox: "0 0 2729 2703",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.365 1624.87L378.365 1590.37L388.865 1575.37L439.365 1605.37L429.365 1624.87Z",
    fill: "#FE763B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6771 2482.77C51.3146 2479.64 47.6623 2478.2 44.5354 2479.57C41.4092 2480.93 39.9736 2484.58 41.3363 2487.71C42.6988 2490.83 46.3511 2492.27 49.478 2490.91C52.604 2489.54 54.0396 2485.89 52.6771 2482.77V2482.77Z",
    fill: "#A1A1A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8133 2460.3L52.5738 2474.25C52.0526 2474.58 51.8496 2475.24 52.0962 2475.81L57.3324 2487.82C57.578 2488.38 58.1968 2488.69 58.7895 2488.53L84.3952 2481.81C84.7461 2481.72 85.039 2481.48 85.1964 2481.15C85.3548 2480.82 85.3619 2480.44 85.2166 2480.11L81.4985 2471.58L91.2166 2467.34C91.8454 2467.07 92.1325 2466.33 91.8574 2465.7C91.5823 2465.07 90.849 2464.78 90.2202 2465.05L80.5012 2469.29L76.7833 2460.76C76.7813 2460.75 76.779 2460.75 76.7769 2460.74C76.5013 2460.11 75.7685 2459.82 75.1396 2460.1C75.0172 2460.15 74.9075 2460.22 74.8128 2460.31L74.8133 2460.3Z",
    fill: "#A1A1A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8528 2519.88C67.4903 2516.76 63.838 2515.32 60.7112 2516.68C57.5849 2518.05 56.1494 2521.7 57.5121 2524.83C58.8746 2527.95 62.5269 2529.39 65.6538 2528.02C68.78 2526.66 70.2156 2523.01 68.8528 2519.88Z",
    fill: "#A1A1A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6955 2509.3L75.1342 2528.66C75.2798 2529 75.5632 2529.25 75.9107 2529.36C76.2581 2529.47 76.6341 2529.42 76.9408 2529.22L99.2911 2515.04C99.8093 2514.71 100.009 2514.05 99.763 2513.49L97.6704 2508.68L107.39 2504.45C108.019 2504.17 108.306 2503.44 108.03 2502.81C107.755 2502.18 107.021 2501.89 106.393 2502.16L96.6733 2506.4L94.5241 2501.47C94.2772 2500.9 93.6554 2500.6 93.0598 2500.76L67.5101 2507.6C67.1606 2507.69 66.8701 2507.94 66.713 2508.26C66.557 2508.59 66.5504 2508.97 66.6956 2509.3L66.6955 2509.3Z",
    fill: "#A1A1A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2001 2505.75C49.4484 2506.32 50.1529 2506.56 50.7747 2506.29L99.0419 2485.25C99.6632 2484.98 99.9661 2484.3 99.7179 2483.73C99.4698 2483.16 98.7645 2482.92 98.1433 2483.19L49.876 2504.23C49.2548 2504.5 48.952 2505.18 49.2001 2505.75Z",
    fill: "#A1A1A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.101 1665.12L565.638 1690.63L561.908 1681.35L625.372 1655.84L629.101 1665.12Z",
    fill: "#A2A2A2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M780.679 1437.5L714.356 1464.16L710.627 1454.88L776.949 1428.22L780.679 1437.5Z",
    fill: "#A2A2A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M712.069 1465.08L647.462 1491.04L643.732 1481.77L708.34 1455.8L712.069 1465.08Z",
    fill: "#A2A2A2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.94 1465.52L725.617 1492.17L721.888 1482.89L788.21 1456.24L791.94 1465.52Z",
    fill: "#A2A2A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M723.33 1493.09L658.723 1519.06L654.993 1509.78L719.6 1483.81L723.33 1493.09Z",
    fill: "#A2A2A2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.199 1493.53L736.877 1520.19L733.147 1510.91L799.47 1484.25L803.199 1493.53Z",
    fill: "#A2A2A2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.591 1521.11L669.983 1547.08L666.254 1537.8L730.861 1511.83L734.591 1521.11Z",
    fill: "#A2A2A2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.46 1521.55L748.138 1548.2L744.408 1538.93L810.731 1512.27L814.46 1521.55Z",
    fill: "#A2A2A2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.85 1549.12L681.243 1575.09L677.514 1565.81L742.121 1539.84L745.85 1549.12Z",
    fill: "#A2A2A2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825.721 1549.56L759.398 1576.22L755.669 1566.94L821.991 1540.28L825.721 1549.56Z",
    fill: "#A2A2A2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M757.111 1577.14L692.504 1603.11L688.774 1593.83L753.382 1567.86L757.111 1577.14Z",
    fill: "#A2A2A2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M836.981 1577.58L770.658 1604.24L766.929 1594.96L833.251 1568.3L836.981 1577.58Z",
    fill: "#A2A2A2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M768.372 1605.15L703.765 1631.12L700.035 1621.84L764.642 1595.88L768.372 1605.15Z",
    fill: "#A2A2A2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.241 1605.59L781.919 1632.25L778.189 1622.97L844.512 1596.32L848.241 1605.59Z",
    fill: "#A2A2A2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.632 1633.17L715.024 1659.14L711.295 1649.86L775.902 1623.89L779.632 1633.17Z",
    fill: "#A2A2A2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M859.502 1633.61L793.18 1660.27L789.45 1650.99L855.773 1624.33L859.502 1633.61Z",
    fill: "#A2A2A2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.892 1661.19L726.285 1687.15L722.556 1677.88L787.163 1651.91L790.892 1661.19Z",
    fill: "#A2A2A2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M870.762 1661.63L804.439 1688.28L800.71 1679L867.032 1652.35L870.762 1661.63Z",
    fill: "#A2A2A2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M802.153 1689.2L737.546 1715.17L733.816 1705.89L798.424 1679.92L802.153 1689.2Z",
    fill: "#A2A2A2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M882.023 1689.64L815.7 1716.3L811.971 1707.02L878.293 1680.36L882.023 1689.64Z",
    fill: "#A2A2A2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.414 1717.22L748.807 1743.18L745.077 1733.91L809.684 1707.94L813.414 1717.22Z",
    fill: "#A2A2A2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.283 1717.65L826.961 1744.31L823.231 1735.03L889.554 1708.37L893.283 1717.65Z",
    fill: "#A2A2A2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M824.674 1745.23L760.066 1771.2L756.337 1761.92L820.944 1735.95L824.674 1745.23Z",
    fill: "#A2A2A2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.544 1745.67L838.222 1772.33L834.492 1763.05L900.815 1736.39L904.544 1745.67Z",
    fill: "#A2A2A2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.934 1773.25L771.327 1799.22L767.598 1789.94L832.205 1763.97L835.934 1773.25Z",
    fill: "#A2A2A2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M915.804 1773.68L849.481 1800.34L845.752 1791.06L912.074 1764.41L915.804 1773.68Z",
    fill: "#A2A2A2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.195 1801.26L782.588 1827.23L778.858 1817.95L843.466 1791.99L847.195 1801.26Z",
    fill: "#A2A2A2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.065 1801.7L860.742 1828.36L857.013 1819.08L923.335 1792.42L927.065 1801.7Z",
    fill: "#A2A2A2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.455 1829.28L793.848 1855.24L790.118 1845.96L854.725 1820L858.455 1829.28Z",
    fill: "#A2A2A2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M938.324 1829.71L872.002 1856.37L868.272 1847.09L934.595 1820.44L938.324 1829.71Z",
    fill: "#A2A2A2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M869.716 1857.29L805.108 1883.26L801.379 1873.98L865.986 1848.01L869.716 1857.29Z",
    fill: "#A2A2A2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949.585 1857.73L883.263 1884.39L879.533 1875.11L945.856 1848.45L949.585 1857.73Z",
    fill: "#A2A2A2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M880.976 1885.31L816.369 1911.27L812.64 1902L877.247 1876.03L880.976 1885.31Z",
    fill: "#A2A2A2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M960.846 1885.75L894.523 1912.4L890.794 1903.12L957.116 1876.47L960.846 1885.75Z",
    fill: "#A2A2A2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.237 1913.33L827.63 1939.29L823.9 1930.02L888.508 1904.05L892.237 1913.33Z",
    fill: "#A2A2A2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.107 1913.76L905.784 1940.42L902.055 1931.14L968.377 1904.48L972.107 1913.76Z",
    fill: "#A2A2A2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M903.497 1941.34L838.89 1967.31L835.16 1958.03L899.767 1932.06L903.497 1941.34Z",
    fill: "#A2A2A2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.367 1941.78L917.045 1968.43L913.315 1959.16L979.638 1932.5L983.367 1941.78Z",
    fill: "#A2A2A2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.758 1969.35L850.15 1995.32L846.421 1986.04L911.028 1960.07L914.758 1969.35Z",
    fill: "#A2A2A2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.627 1969.79L928.305 1996.45L924.575 1987.17L990.898 1960.51L994.627 1969.79Z",
    fill: "#A2A2A2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M926.018 1997.37L861.411 2023.34L857.682 2014.06L922.289 1988.09L926.018 1997.37Z",
    fill: "#A2A2A2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005.89 1997.81L939.565 2024.47L935.836 2015.19L1002.16 1988.53L1005.89 1997.81Z",
    fill: "#A2A2A2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.278 2025.38L872.671 2051.35L868.941 2042.07L933.549 2016.11L937.278 2025.38Z",
    fill: "#A2A2A2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.825 1126.74L839.361 1152.25L835.632 1142.97L899.096 1117.46L902.825 1126.74Z",
    fill: "#A2A2A2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1079.45 958.13L1015.41 983.868L1011.68 974.59L1075.72 948.852L1079.45 958.13Z",
    fill: "#A2A2A2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.52 787.337L1192.49 813.075L1188.76 803.797L1252.79 778.059L1256.52 787.337Z",
    fill: "#A2A2A2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1469.1 703.224L1405.06 728.962L1401.33 719.684L1465.37 693.945L1469.1 703.224Z",
    fill: "#A2A2A2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1400.49 730.802L1336.45 756.54L1332.72 747.262L1396.76 721.524L1400.49 730.802Z",
    fill: "#A2A2A2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1480.59 731.81L1416.55 757.548L1412.82 748.27L1476.86 722.531L1480.59 731.81Z",
    fill: "#A2A2A2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1411.98 759.388L1347.94 785.126L1344.21 775.848L1408.25 750.109L1411.98 759.388Z",
    fill: "#A2A2A2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1491.85 759.829L1427.81 785.568L1424.08 776.289L1488.12 750.551L1491.85 759.829Z",
    fill: "#A2A2A2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.24 787.404L1359.2 813.142L1355.47 803.863L1419.51 778.125L1423.24 787.404Z",
    fill: "#A2A2A2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1503.11 787.841L1439.07 813.579L1435.34 804.301L1499.38 778.563L1503.11 787.841Z",
    fill: "#A2A2A2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1434.5 815.419L1370.46 841.157L1366.73 831.879L1430.77 806.141L1434.5 815.419Z",
    fill: "#A2A2A2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1514.37 815.857L1450.33 841.595L1446.6 832.316L1510.64 806.578L1514.37 815.857Z",
    fill: "#A2A2A2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1445.76 843.435L1381.72 869.173L1378 859.895L1442.03 834.156L1445.76 843.435Z",
    fill: "#A2A2A2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1525.86 844.447L1461.82 870.185L1458.09 860.906L1522.13 835.168L1525.86 844.447Z",
    fill: "#A2A2A2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1457.25 872.021L1393.21 897.759L1389.49 888.48L1453.52 862.742L1457.25 872.021Z",
    fill: "#A2A2A2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1537.12 872.462L1473.08 898.2L1469.35 888.922L1533.39 863.184L1537.12 872.462Z",
    fill: "#A2A2A2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1468.51 900.036L1404.47 925.775L1400.75 916.496L1464.78 890.758L1468.51 900.036Z",
    fill: "#A2A2A2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1548.38 900.478L1484.34 926.216L1480.62 916.938L1544.65 891.199L1548.38 900.478Z",
    fill: "#A2A2A2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1479.77 928.052L1415.74 953.79L1412.01 944.512L1476.04 918.774L1479.77 928.052Z",
    fill: "#A2A2A2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1559.64 928.493L1495.61 954.232L1491.88 944.953L1555.91 919.215L1559.64 928.493Z",
    fill: "#A2A2A2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1491.03 956.068L1427 981.806L1423.27 972.527L1487.3 946.789L1491.03 956.068Z",
    fill: "#A2A2A2"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1570.9 956.509L1506.87 982.247L1503.14 972.969L1567.17 947.231L1570.9 956.509Z",
    fill: "#A2A2A2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1502.29 984.083L1438.26 1009.82L1434.53 1000.54L1498.56 974.805L1502.29 984.083Z",
    fill: "#A2A2A2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1582.39 985.095L1518.36 1010.83L1514.63 1001.55L1578.66 975.816L1582.39 985.095Z",
    fill: "#A2A2A2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1513.78 1012.67L1449.75 1038.41L1446.02 1029.13L1510.05 1003.39L1513.78 1012.67Z",
    fill: "#A2A2A2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1593.65 1013.11L1529.62 1038.85L1525.89 1029.57L1589.92 1003.83L1593.65 1013.11Z",
    fill: "#A2A2A2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1525.04 1040.69L1461.01 1066.43L1457.28 1057.15L1521.31 1031.41L1525.04 1040.69Z",
    fill: "#A2A2A2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1604.91 1041.13L1540.88 1066.86L1537.15 1057.59L1601.18 1031.85L1604.91 1041.13Z",
    fill: "#A2A2A2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1536.3 1068.7L1472.27 1094.44L1468.54 1085.16L1532.57 1059.43L1536.3 1068.7Z",
    fill: "#A2A2A2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1616.17 1069.14L1552.14 1094.88L1548.41 1085.6L1612.44 1059.86L1616.17 1069.14Z",
    fill: "#A2A2A2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1547.56 1096.72L1483.53 1122.46L1479.8 1113.18L1543.83 1087.44L1547.56 1096.72Z",
    fill: "#A2A2A2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1627.66 1097.73L1563.63 1123.47L1559.9 1114.19L1623.93 1088.45L1627.66 1097.73Z",
    fill: "#A2A2A2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1559.05 1125.31L1495.02 1151.04L1491.29 1141.77L1555.32 1116.03L1559.05 1125.31Z",
    fill: "#A2A2A2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1638.92 1125.74L1574.89 1151.48L1571.16 1142.2L1635.19 1116.46L1638.92 1125.74Z",
    fill: "#A2A2A2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1570.31 1153.32L1506.28 1179.06L1502.55 1169.78L1566.59 1144.04L1570.31 1153.32Z",
    fill: "#A2A2A2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1650.18 1153.76L1586.15 1179.5L1582.42 1170.22L1646.45 1144.48L1650.18 1153.76Z",
    fill: "#A2A2A2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1581.57 1181.34L1517.54 1207.08L1513.81 1197.8L1577.85 1172.06L1581.57 1181.34Z",
    fill: "#A2A2A2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1661.44 1181.77L1597.41 1207.51L1593.68 1198.23L1657.72 1172.5L1661.44 1181.77Z",
    fill: "#A2A2A2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1592.84 1209.35L1528.8 1235.09L1525.07 1225.81L1589.11 1200.07L1592.84 1209.35Z",
    fill: "#A2A2A2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1672.71 1209.79L1608.67 1235.53L1604.94 1226.25L1668.98 1200.51L1672.71 1209.79Z",
    fill: "#A2A2A2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1604.1 1237.37L1540.06 1263.11L1536.33 1253.83L1600.37 1228.09L1604.1 1237.37Z",
    fill: "#A2A2A2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1684.2 1238.38L1620.16 1264.11L1616.43 1254.84L1680.47 1229.1L1684.2 1238.38Z",
    fill: "#A2A2A2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1615.59 1265.95L1551.55 1291.69L1547.82 1282.41L1611.86 1256.68L1615.59 1265.95Z",
    fill: "#A2A2A2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1695.46 1266.4L1631.42 1292.13L1627.69 1282.86L1691.73 1257.12L1695.46 1266.4Z",
    fill: "#A2A2A2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1626.85 1293.97L1562.81 1319.71L1559.08 1310.43L1623.12 1284.69L1626.85 1293.97Z",
    fill: "#A2A2A2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1706.72 1294.41L1642.68 1320.15L1638.95 1310.87L1702.99 1285.13L1706.72 1294.41Z",
    fill: "#A2A2A2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1638.11 1321.99L1574.07 1347.72L1570.34 1338.45L1634.38 1312.71L1638.11 1321.99Z",
    fill: "#A2A2A2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1717.98 1322.43L1653.94 1348.17L1650.21 1338.89L1714.25 1313.15L1717.98 1322.43Z",
    fill: "#A2A2A2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1649.37 1350L1585.33 1375.74L1581.6 1366.46L1645.64 1340.72L1649.37 1350Z",
    fill: "#A2A2A2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1729.47 1351.01L1665.43 1376.75L1661.7 1367.47L1725.74 1341.73L1729.47 1351.01Z",
    fill: "#A2A2A2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1660.86 1378.59L1596.82 1404.33L1593.09 1395.05L1657.13 1369.31L1660.86 1378.59Z",
    fill: "#A2A2A2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1740.73 1379.03L1676.69 1404.77L1672.96 1395.49L1737 1369.75L1740.73 1379.03Z",
    fill: "#A2A2A2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1672.12 1406.6L1608.08 1432.34L1604.35 1423.06L1668.39 1397.32L1672.12 1406.6Z",
    fill: "#A2A2A2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1751.99 1407.04L1687.95 1432.78L1684.22 1423.5L1748.26 1397.77L1751.99 1407.04Z",
    fill: "#A2A2A2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1683.38 1434.62L1619.34 1460.36L1615.61 1451.08L1679.65 1425.34L1683.38 1434.62Z",
    fill: "#A2A2A2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1763.25 1435.06L1699.21 1460.8L1695.48 1451.52L1759.52 1425.78L1763.25 1435.06Z",
    fill: "#A2A2A2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1694.64 1462.63L1630.6 1488.37L1626.87 1479.09L1690.91 1453.36L1694.64 1462.63Z",
    fill: "#A2A2A2"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1774.51 1463.08L1710.47 1488.81L1706.74 1479.54L1770.78 1453.8L1774.51 1463.08Z",
    fill: "#A2A2A2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.9 1490.65L1641.86 1516.39L1638.13 1507.11L1702.17 1481.37L1705.9 1490.65Z",
    fill: "#A2A2A2"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1786 1491.66L1721.96 1517.4L1718.23 1508.12L1782.27 1482.38L1786 1491.66Z",
    fill: "#A2A2A2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1717.39 1519.24L1653.35 1544.97L1649.62 1535.7L1713.66 1509.96L1717.39 1519.24Z",
    fill: "#A2A2A2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1797.26 1519.68L1733.22 1545.42L1729.49 1536.14L1793.53 1510.4L1797.26 1519.68Z",
    fill: "#A2A2A2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1728.65 1547.25L1664.61 1572.99L1660.88 1563.71L1724.92 1537.97L1728.65 1547.25Z",
    fill: "#A2A2A2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1808.52 1547.69L1744.48 1573.43L1740.75 1564.15L1804.79 1538.41L1808.52 1547.69Z",
    fill: "#A2A2A2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1739.91 1575.27L1675.87 1601.01L1672.15 1591.73L1736.18 1565.99L1739.91 1575.27Z",
    fill: "#A2A2A2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1819.78 1575.71L1755.75 1601.45L1752.02 1592.17L1816.05 1566.43L1819.78 1575.71Z",
    fill: "#A2A2A2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1751.17 1603.28L1687.14 1629.02L1683.41 1619.74L1747.44 1594L1751.17 1603.28Z",
    fill: "#A2A2A2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1831.27 1604.29L1767.24 1630.03L1763.51 1620.75L1827.54 1595.02L1831.27 1604.29Z",
    fill: "#A2A2A2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1762.66 1631.87L1698.63 1657.61L1694.9 1648.33L1758.93 1622.59L1762.66 1631.87Z",
    fill: "#A2A2A2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1842.53 1632.31L1778.5 1658.05L1774.77 1648.77L1838.8 1623.03L1842.53 1632.31Z",
    fill: "#A2A2A2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1773.92 1659.89L1709.89 1685.63L1706.16 1676.35L1770.19 1650.61L1773.92 1659.89Z",
    fill: "#A2A2A2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1853.79 1660.33L1789.76 1686.06L1786.03 1676.79L1850.06 1651.05L1853.79 1660.33Z",
    fill: "#A2A2A2"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1785.18 1687.9L1721.15 1713.64L1717.42 1704.36L1781.45 1678.63L1785.18 1687.9Z",
    fill: "#A2A2A2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1457.26 675.439L1393.23 701.177L1389.5 691.898L1453.54 666.16L1457.26 675.439Z",
    fill: "#A2A2A2"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1388.66 703.017L1324.62 728.755L1320.89 719.477L1384.93 693.738L1388.66 703.017Z",
    fill: "#A2A2A2"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1445.43 647.654L1381.4 673.392L1377.67 664.113L1441.7 638.375L1445.43 647.654Z",
    fill: "#A2A2A2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1635.14 504.99L1567.1 532.337L1563.38 523.059L1631.41 495.712L1635.14 504.99Z",
    fill: "#A2A2A2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1833.48 392.066L1767.73 418.493L1764 409.215L1829.75 382.787L1833.48 392.066Z",
    fill: "#A2A2A2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2034.57 279.363L1968.82 305.79L1965.09 296.512L2030.84 270.084L2034.57 279.363Z",
    fill: "#A2A2A2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2178.31 222.253L2112.56 248.681L2108.83 239.402L2174.58 212.975L2178.31 222.253Z",
    fill: "#A2A2A2"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2189.57 250.269L2123.82 276.697L2120.09 267.418L2185.84 240.99L2189.57 250.269Z",
    fill: "#A2A2A2"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2200.83 278.285L2135.08 304.712L2131.35 295.434L2197.1 269.006L2200.83 278.285Z",
    fill: "#A2A2A2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2212.32 306.874L2146.57 333.302L2142.84 324.023L2208.59 297.596L2212.32 306.874Z",
    fill: "#A2A2A2"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2223.58 334.89L2157.83 361.318L2154.1 352.039L2219.85 325.611L2223.58 334.89Z",
    fill: "#A2A2A2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2234.84 362.902L2169.09 389.329L2165.36 380.051L2231.11 353.623L2234.84 362.902Z",
    fill: "#A2A2A2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2246.1 390.921L2180.35 417.349L2176.62 408.07L2242.37 381.643L2246.1 390.921Z",
    fill: "#A2A2A2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2257.59 419.507L2191.84 445.935L2188.11 436.656L2253.86 410.229L2257.59 419.507Z",
    fill: "#A2A2A2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2268.85 447.523L2203.1 473.95L2199.37 464.672L2265.12 438.244L2268.85 447.523Z",
    fill: "#A2A2A2"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2280.11 475.538L2214.36 501.966L2210.63 492.688L2276.38 466.26L2280.11 475.538Z",
    fill: "#A2A2A2"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2291.37 503.554L2225.62 529.982L2221.89 520.703L2287.64 494.276L2291.37 503.554Z",
    fill: "#A2A2A2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2302.63 531.57L2236.88 557.997L2233.15 548.719L2298.9 522.291L2302.63 531.57Z",
    fill: "#A2A2A2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2314.12 560.156L2248.37 586.583L2244.64 577.305L2310.39 550.877L2314.12 560.156Z",
    fill: "#A2A2A2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2325.38 588.171L2259.63 614.599L2255.9 605.32L2321.65 578.893L2325.38 588.171Z",
    fill: "#A2A2A2"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2336.64 616.187L2270.89 642.614L2267.16 633.336L2332.91 606.908L2336.64 616.187Z",
    fill: "#A2A2A2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2347.9 644.203L2282.15 670.63L2278.42 661.352L2344.17 634.924L2347.9 644.203Z",
    fill: "#A2A2A2"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2359.16 672.218L2293.41 698.646L2289.68 689.367L2355.43 662.94L2359.16 672.218Z",
    fill: "#A2A2A2"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2370.65 700.804L2304.9 727.232L2301.17 717.953L2366.92 691.526L2370.65 700.804Z",
    fill: "#A2A2A2"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2381.91 728.82L2316.16 755.247L2312.43 745.969L2378.19 719.541L2381.91 728.82Z",
    fill: "#A2A2A2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2393.17 756.835L2327.42 783.263L2323.69 773.984L2389.45 747.557L2393.17 756.835Z",
    fill: "#A2A2A2"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2404.44 784.851L2338.68 811.279L2334.96 802L2400.71 775.572L2404.44 784.851Z",
    fill: "#A2A2A2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2415.93 813.441L2350.17 839.868L2346.45 830.59L2412.2 804.162L2415.93 813.441Z",
    fill: "#A2A2A2"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2427.19 841.456L2361.43 867.884L2357.71 858.605L2423.46 832.178L2427.19 841.456Z",
    fill: "#A2A2A2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2438.45 869.468L2372.7 895.896L2368.97 886.617L2434.72 860.19L2438.45 869.468Z",
    fill: "#A2A2A2"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2449.71 897.484L2383.96 923.911L2380.23 914.633L2445.98 888.205L2449.71 897.484Z",
    fill: "#A2A2A2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.97 925.499L2395.22 951.927L2391.49 942.648L2457.24 916.221L2460.97 925.499Z",
    fill: "#A2A2A2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2472.46 954.089L2406.71 980.517L2402.98 971.238L2468.73 944.811L2472.46 954.089Z",
    fill: "#A2A2A2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2483.72 982.105L2417.97 1008.53L2414.24 999.254L2479.99 972.826L2483.72 982.105Z",
    fill: "#A2A2A2"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2494.98 1010.12L2429.23 1036.55L2425.5 1027.27L2491.25 1000.84L2494.98 1010.12Z",
    fill: "#A2A2A2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2506.24 1038.14L2440.49 1064.56L2436.76 1055.29L2502.51 1028.86L2506.24 1038.14Z",
    fill: "#A2A2A2"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2517.5 1066.15L2451.75 1092.58L2448.02 1083.3L2513.77 1056.87L2517.5 1066.15Z",
    fill: "#A2A2A2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2528.99 1094.74L2463.24 1121.17L2459.51 1111.89L2525.26 1085.46L2528.99 1094.74Z",
    fill: "#A2A2A2"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2540.25 1122.75L2474.5 1149.18L2470.77 1139.9L2536.52 1113.47L2540.25 1122.75Z",
    fill: "#A2A2A2"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2551.51 1150.77L2485.76 1177.2L2482.03 1167.92L2547.78 1141.49L2551.51 1150.77Z",
    fill: "#A2A2A2"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2562.77 1178.78L2497.02 1205.21L2493.29 1195.93L2559.04 1169.51L2562.77 1178.78Z",
    fill: "#A2A2A2"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2574.26 1207.37L2508.51 1233.8L2504.78 1224.52L2570.53 1198.09L2574.26 1207.37Z",
    fill: "#A2A2A2"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2585.52 1235.39L2519.77 1261.81L2516.04 1252.54L2581.79 1226.11L2585.52 1235.39Z",
    fill: "#A2A2A2"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2596.78 1263.4L2531.03 1289.83L2527.3 1280.55L2593.05 1254.12L2596.78 1263.4Z",
    fill: "#A2A2A2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2608.04 1291.42L2542.29 1317.84L2538.56 1308.57L2604.31 1282.14L2608.04 1291.42Z",
    fill: "#A2A2A2"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2619.3 1319.43L2553.55 1345.86L2549.82 1336.58L2615.57 1310.15L2619.3 1319.43Z",
    fill: "#A2A2A2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2630.79 1348.02L2565.04 1374.45L2561.31 1365.17L2627.06 1338.74L2630.79 1348.02Z",
    fill: "#A2A2A2"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2642.05 1376.03L2576.3 1402.46L2572.57 1393.18L2638.32 1366.76L2642.05 1376.03Z",
    fill: "#A2A2A2"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2653.31 1404.05L2587.56 1430.48L2583.83 1421.2L2649.58 1394.77L2653.31 1404.05Z",
    fill: "#A2A2A2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1965.39 307.171L1899.64 333.599L1895.91 324.32L1961.66 297.893L1965.39 307.171Z",
    fill: "#A2A2A2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2045.83 307.378L1980.08 333.806L1976.35 324.527L2042.1 298.1L2045.83 307.378Z",
    fill: "#A2A2A2"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1976.65 335.187L1910.9 361.614L1907.17 352.336L1972.92 325.908L1976.65 335.187Z",
    fill: "#A2A2A2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2057.09 335.394L1991.34 361.822L1987.61 352.543L2053.36 326.115L2057.09 335.394Z",
    fill: "#A2A2A2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1987.91 363.203L1922.16 389.63L1918.43 380.352L1984.18 353.924L1987.91 363.203Z",
    fill: "#A2A2A2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2068.35 363.41L2002.6 389.837L1998.87 380.559L2064.62 354.131L2068.35 363.41Z",
    fill: "#A2A2A2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1999.17 391.218L1933.42 417.646L1929.69 408.367L1995.44 381.94L1999.17 391.218Z",
    fill: "#A2A2A2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2079.61 391.425L2013.86 417.853L2010.13 408.574L2075.88 382.147L2079.61 391.425Z",
    fill: "#A2A2A2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2010.43 419.234L1944.68 445.661L1940.95 436.383L2006.7 409.955L2010.43 419.234Z",
    fill: "#A2A2A2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2091.1 420.011L2025.35 446.439L2021.62 437.16L2087.37 410.733L2091.1 420.011Z",
    fill: "#A2A2A2"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2021.92 447.82L1956.17 474.247L1952.44 464.969L2018.19 438.541L2021.92 447.82Z",
    fill: "#A2A2A2"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2102.36 448.027L2036.61 474.454L2032.88 465.176L2098.63 438.748L2102.36 448.027Z",
    fill: "#A2A2A2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2033.18 475.835L1967.43 502.263L1963.7 492.984L2029.45 466.557L2033.18 475.835Z",
    fill: "#A2A2A2"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2113.62 476.042L2047.87 502.47L2044.14 493.191L2109.89 466.764L2113.62 476.042Z",
    fill: "#A2A2A2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2044.44 503.851L1978.69 530.279L1974.96 521L2040.71 494.572L2044.44 503.851Z",
    fill: "#A2A2A2"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2124.88 504.058L2059.13 530.486L2055.4 521.207L2121.15 494.779L2124.88 504.058Z",
    fill: "#A2A2A2"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2055.7 531.867L1989.95 558.294L1986.22 549.016L2051.97 522.588L2055.7 531.867Z",
    fill: "#A2A2A2"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2136.14 532.074L2070.39 558.501L2066.66 549.223L2132.41 522.795L2136.14 532.074Z",
    fill: "#A2A2A2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2066.96 559.882L2001.21 586.31L1997.48 577.031L2063.23 550.604L2066.96 559.882Z",
    fill: "#A2A2A2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2147.4 560.089L2081.65 586.517L2077.92 577.238L2143.67 550.811L2147.4 560.089Z",
    fill: "#A2A2A2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2078.22 587.898L2012.47 614.325L2008.74 605.047L2074.49 578.619L2078.22 587.898Z",
    fill: "#A2A2A2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2158.66 588.105L2092.91 614.532L2089.18 605.254L2154.93 578.826L2158.66 588.105Z",
    fill: "#A2A2A2"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2089.48 615.913L2023.73 642.341L2020 633.062L2085.75 606.635L2089.48 615.913Z",
    fill: "#A2A2A2"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2169.92 616.12L2104.17 642.548L2100.44 633.27L2166.2 606.842L2169.92 616.12Z",
    fill: "#A2A2A2"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2100.74 643.929L2034.99 670.357L2031.26 661.078L2097.01 634.651L2100.74 643.929Z",
    fill: "#A2A2A2"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2181.41 644.71L2115.66 671.138L2111.93 661.859L2177.69 635.432L2181.41 644.71Z",
    fill: "#A2A2A2"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2112.23 672.515L2046.48 698.943L2042.75 689.664L2108.5 663.236L2112.23 672.515Z",
    fill: "#A2A2A2"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2192.68 672.726L2126.92 699.154L2123.2 689.875L2188.95 663.447L2192.68 672.726Z",
    fill: "#A2A2A2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2123.49 700.531L2057.74 726.958L2054.01 717.68L2119.76 691.252L2123.49 700.531Z",
    fill: "#A2A2A2"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2203.94 700.742L2138.18 727.169L2134.46 717.891L2200.21 691.463L2203.94 700.742Z",
    fill: "#A2A2A2"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2134.75 728.546L2069 754.974L2065.27 745.695L2131.03 719.268L2134.75 728.546Z",
    fill: "#A2A2A2"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2215.2 728.757L2149.45 755.185L2145.72 745.906L2211.47 719.479L2215.2 728.757Z",
    fill: "#A2A2A2"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2146.02 756.562L2080.26 782.989L2076.54 773.711L2142.29 747.283L2146.02 756.562Z",
    fill: "#A2A2A2"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2226.46 756.773L2160.71 783.2L2156.98 773.922L2222.73 747.494L2226.46 756.773Z",
    fill: "#A2A2A2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2157.28 784.578L2091.52 811.005L2087.79 801.727L2153.55 775.299L2157.28 784.578Z",
    fill: "#A2A2A2"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2237.72 784.788L2171.97 811.216L2168.24 801.938L2233.99 775.51L2237.72 784.788Z",
    fill: "#A2A2A2"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2168.54 812.593L2102.79 839.021L2099.06 829.742L2164.81 803.315L2168.54 812.593Z",
    fill: "#A2A2A2"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2248.98 812.8L2183.23 839.228L2179.5 829.949L2245.25 803.522L2248.98 812.8Z",
    fill: "#A2A2A2"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2179.8 840.609L2114.05 867.036L2110.32 857.758L2176.07 831.33L2179.8 840.609Z",
    fill: "#A2A2A2"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2260.24 840.816L2194.49 867.243L2190.76 857.965L2256.51 831.537L2260.24 840.816Z",
    fill: "#A2A2A2"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2191.06 868.624L2125.31 895.052L2121.58 885.773L2187.33 859.346L2191.06 868.624Z",
    fill: "#A2A2A2"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2271.73 869.406L2205.98 895.833L2202.25 886.555L2268 860.127L2271.73 869.406Z",
    fill: "#A2A2A2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2202.55 897.21L2136.8 923.638L2133.07 914.359L2198.82 887.932L2202.55 897.21Z",
    fill: "#A2A2A2"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2282.99 897.421L2217.24 923.849L2213.51 914.57L2279.26 888.143L2282.99 897.421Z",
    fill: "#A2A2A2"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2213.81 925.226L2148.06 951.654L2144.33 942.375L2210.08 915.947L2213.81 925.226Z",
    fill: "#A2A2A2"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2294.25 925.437L2228.5 951.864L2224.77 942.586L2290.52 916.158L2294.25 925.437Z",
    fill: "#A2A2A2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2225.07 953.242L2159.32 979.669L2155.59 970.391L2221.34 943.963L2225.07 953.242Z",
    fill: "#A2A2A2"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2305.51 953.453L2239.76 979.88L2236.03 970.602L2301.78 944.174L2305.51 953.453Z",
    fill: "#A2A2A2"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2236.33 981.257L2170.58 1007.68L2166.85 998.406L2232.6 971.979L2236.33 981.257Z",
    fill: "#A2A2A2"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2316.77 981.468L2251.02 1007.9L2247.29 998.617L2313.04 972.19L2316.77 981.468Z",
    fill: "#A2A2A2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2247.59 1009.27L2181.84 1035.7L2178.11 1026.42L2243.86 999.994L2247.59 1009.27Z",
    fill: "#A2A2A2"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2328.03 1009.48L2262.28 1035.91L2258.55 1026.63L2324.3 1000.21L2328.03 1009.48Z",
    fill: "#A2A2A2"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2258.85 1037.29L2193.1 1063.72L2189.37 1054.44L2255.12 1028.01L2258.85 1037.29Z",
    fill: "#A2A2A2"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2339.29 1037.5L2273.54 1063.93L2269.81 1054.65L2335.56 1028.22L2339.29 1037.5Z",
    fill: "#A2A2A2"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2270.11 1065.3L2204.36 1091.73L2200.63 1082.45L2266.38 1056.03L2270.11 1065.3Z",
    fill: "#A2A2A2"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2350.55 1065.52L2284.8 1091.94L2281.07 1082.66L2346.82 1056.24L2350.55 1065.52Z",
    fill: "#A2A2A2"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2281.37 1093.32L2215.62 1119.75L2211.89 1110.47L2277.64 1084.04L2281.37 1093.32Z",
    fill: "#A2A2A2"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2362.04 1094.1L2296.29 1120.53L2292.56 1111.25L2358.31 1084.82L2362.04 1094.1Z",
    fill: "#A2A2A2"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2292.86 1121.91L2227.11 1148.33L2223.38 1139.05L2289.13 1112.63L2292.86 1121.91Z",
    fill: "#A2A2A2"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2373.3 1122.12L2307.55 1148.54L2303.82 1139.27L2369.57 1112.84L2373.3 1122.12Z",
    fill: "#A2A2A2"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2304.12 1149.92L2238.37 1176.35L2234.64 1167.07L2300.39 1140.64L2304.12 1149.92Z",
    fill: "#A2A2A2"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2384.56 1150.13L2318.81 1176.56L2315.08 1167.28L2380.83 1140.85L2384.56 1150.13Z",
    fill: "#A2A2A2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2315.38 1177.94L2249.63 1204.36L2245.9 1195.09L2311.65 1168.66L2315.38 1177.94Z",
    fill: "#A2A2A2"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2395.82 1178.15L2330.07 1204.58L2326.34 1195.3L2392.09 1168.87L2395.82 1178.15Z",
    fill: "#A2A2A2"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2326.64 1205.95L2260.89 1232.38L2257.16 1223.1L2322.91 1196.67L2326.64 1205.95Z",
    fill: "#A2A2A2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2407.08 1206.16L2341.33 1232.59L2337.6 1223.31L2403.35 1196.88L2407.08 1206.16Z",
    fill: "#A2A2A2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2337.9 1233.97L2272.15 1260.4L2268.42 1251.12L2334.17 1224.69L2337.9 1233.97Z",
    fill: "#A2A2A2"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2418.34 1234.18L2352.59 1260.61L2348.86 1251.33L2414.61 1224.9L2418.34 1234.18Z",
    fill: "#A2A2A2"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2349.16 1261.98L2283.41 1288.41L2279.68 1279.13L2345.43 1252.71L2349.16 1261.98Z",
    fill: "#A2A2A2"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2429.61 1262.19L2363.85 1288.62L2360.12 1279.34L2425.88 1252.92L2429.61 1262.19Z",
    fill: "#A2A2A2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2360.42 1290L2294.67 1316.43L2290.94 1307.15L2356.69 1280.72L2360.42 1290Z",
    fill: "#A2A2A2"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2440.86 1290.21L2375.11 1316.64L2371.38 1307.36L2437.14 1280.93L2440.86 1290.21Z",
    fill: "#A2A2A2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2371.68 1318.02L2305.93 1344.44L2302.2 1335.16L2367.95 1308.74L2371.68 1318.02Z",
    fill: "#A2A2A2"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2452.36 1318.8L2386.6 1345.22L2382.88 1335.95L2448.63 1309.52L2452.36 1318.8Z",
    fill: "#A2A2A2"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2383.17 1346.6L2317.42 1373.03L2313.69 1363.75L2379.44 1337.32L2383.17 1346.6Z",
    fill: "#A2A2A2"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2463.62 1346.81L2397.87 1373.24L2394.14 1363.96L2459.89 1337.53L2463.62 1346.81Z",
    fill: "#A2A2A2"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2394.43 1374.62L2328.68 1401.04L2324.95 1391.77L2390.7 1365.34L2394.43 1374.62Z",
    fill: "#A2A2A2"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2474.88 1374.83L2409.12 1401.26L2405.4 1391.98L2471.15 1365.55L2474.88 1374.83Z",
    fill: "#A2A2A2"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2405.69 1402.63L2339.94 1429.06L2336.21 1419.78L2401.97 1393.35L2405.69 1402.63Z",
    fill: "#A2A2A2"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2486.14 1402.84L2420.39 1429.27L2416.66 1419.99L2482.41 1393.56L2486.14 1402.84Z",
    fill: "#A2A2A2"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2417.53 1430.42L2351.78 1456.85L2348.05 1447.57L2413.8 1421.14L2417.53 1430.42Z",
    fill: "#A2A2A2"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1766.59 418.953L1700.84 445.38L1697.11 436.102L1762.86 409.674L1766.59 418.953Z",
    fill: "#A2A2A2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1844.74 420.081L1778.99 446.509L1775.26 437.23L1841.01 410.803L1844.74 420.081Z",
    fill: "#A2A2A2"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1777.85 446.968L1712.1 473.396L1708.37 464.117L1774.12 437.69L1777.85 446.968Z",
    fill: "#A2A2A2"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1856 448.097L1790.25 474.525L1786.52 465.246L1852.27 438.818L1856 448.097Z",
    fill: "#A2A2A2"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1789.11 474.984L1723.36 501.411L1719.63 492.133L1785.38 465.705L1789.11 474.984Z",
    fill: "#A2A2A2"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1867.26 476.113L1801.51 502.54L1797.78 493.262L1863.53 466.834L1867.26 476.113Z",
    fill: "#A2A2A2"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1800.37 502.999L1734.62 529.427L1730.89 520.148L1796.64 493.721L1800.37 502.999Z",
    fill: "#A2A2A2"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1878.75 504.699L1813 531.126L1809.27 521.848L1875.02 495.42L1878.75 504.699Z",
    fill: "#A2A2A2"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1811.86 531.585L1746.11 558.013L1742.38 548.734L1808.13 522.307L1811.86 531.585Z",
    fill: "#A2A2A2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1890.01 532.714L1824.26 559.142L1820.53 549.863L1886.28 523.436L1890.01 532.714Z",
    fill: "#A2A2A2"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1823.12 559.601L1757.37 586.029L1753.64 576.75L1819.39 550.322L1823.12 559.601Z",
    fill: "#A2A2A2"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1901.28 560.73L1835.52 587.157L1831.79 577.879L1897.55 551.451L1901.28 560.73Z",
    fill: "#A2A2A2"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1834.38 587.617L1768.63 614.044L1764.9 604.766L1830.65 578.338L1834.38 587.617Z",
    fill: "#A2A2A2"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1912.53 588.745L1846.78 615.173L1843.05 605.895L1908.81 579.467L1912.53 588.745Z",
    fill: "#A2A2A2"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1845.64 615.632L1779.89 642.06L1776.16 632.781L1841.91 606.354L1845.64 615.632Z",
    fill: "#A2A2A2"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1923.8 616.761L1858.04 643.189L1854.32 633.91L1920.07 607.483L1923.8 616.761Z",
    fill: "#A2A2A2"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1856.9 643.648L1791.15 670.075L1787.42 660.797L1853.17 634.369L1856.9 643.648Z",
    fill: "#A2A2A2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1935.06 644.777L1869.31 671.204L1865.58 661.926L1931.33 635.498L1935.06 644.777Z",
    fill: "#A2A2A2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1868.16 671.663L1802.41 698.091L1798.68 688.812L1864.43 662.385L1868.16 671.663Z",
    fill: "#A2A2A2"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1946.55 673.363L1880.8 699.79L1877.07 690.512L1942.82 664.084L1946.55 673.363Z",
    fill: "#A2A2A2"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1879.65 700.253L1813.9 726.681L1810.17 717.402L1875.92 690.975L1879.65 700.253Z",
    fill: "#A2A2A2"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1957.81 701.378L1892.06 727.806L1888.33 718.527L1954.08 692.1L1957.81 701.378Z",
    fill: "#A2A2A2"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1890.91 728.265L1825.16 754.693L1821.43 745.414L1887.18 718.986L1890.91 728.265Z",
    fill: "#A2A2A2"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1969.07 729.394L1903.32 755.822L1899.59 746.543L1965.34 720.115L1969.07 729.394Z",
    fill: "#A2A2A2"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1902.17 756.285L1836.42 782.712L1832.69 773.434L1898.44 747.006L1902.17 756.285Z",
    fill: "#A2A2A2"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1980.33 757.41L1914.58 783.837L1910.85 774.559L1976.6 748.131L1980.33 757.41Z",
    fill: "#A2A2A2"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1913.43 784.296L1847.68 810.724L1843.95 801.445L1909.7 775.018L1913.43 784.296Z",
    fill: "#A2A2A2"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1991.59 785.425L1925.84 811.853L1922.11 802.574L1987.86 776.147L1991.59 785.425Z",
    fill: "#A2A2A2"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1924.69 812.312L1858.94 838.739L1855.21 829.461L1920.96 803.033L1924.69 812.312Z",
    fill: "#A2A2A2"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2002.85 813.441L1937.1 839.868L1933.37 830.59L1999.12 804.162L2002.85 813.441Z",
    fill: "#A2A2A2"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1935.95 840.328L1870.2 866.755L1866.47 857.477L1932.23 831.049L1935.95 840.328Z",
    fill: "#A2A2A2"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2014.11 841.456L1948.36 867.884L1944.63 858.605L2010.38 832.178L2014.11 841.456Z",
    fill: "#A2A2A2"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1947.21 868.343L1881.46 894.771L1877.73 885.492L1943.49 859.065L1947.21 868.343Z",
    fill: "#A2A2A2"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2025.6 870.046L1959.85 896.474L1956.12 887.195L2021.87 860.768L2025.6 870.046Z",
    fill: "#A2A2A2"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1958.71 896.933L1892.95 923.361L1889.23 914.082L1954.98 887.654L1958.71 896.933Z",
    fill: "#A2A2A2"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2036.86 898.062L1971.11 924.489L1967.38 915.211L2033.13 888.783L2036.86 898.062Z",
    fill: "#A2A2A2"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1969.97 924.949L1904.21 951.376L1900.49 942.098L1966.24 915.67L1969.97 924.949Z",
    fill: "#A2A2A2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2048.12 926.074L1982.37 952.501L1978.64 943.223L2044.39 916.795L2048.12 926.074Z",
    fill: "#A2A2A2"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1981.23 952.964L1915.48 979.392L1911.75 970.113L1977.5 943.686L1981.23 952.964Z",
    fill: "#A2A2A2"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2059.38 954.089L1993.63 980.517L1989.9 971.238L2055.65 944.811L2059.38 954.089Z",
    fill: "#A2A2A2"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1992.49 980.976L1926.74 1007.4L1923.01 998.125L1988.76 971.697L1992.49 980.976Z",
    fill: "#A2A2A2"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2070.64 982.105L2004.89 1008.53L2001.16 999.254L2066.91 972.826L2070.64 982.105Z",
    fill: "#A2A2A2"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2003.75 1009L1938 1035.42L1934.27 1026.14L2000.02 999.717L2003.75 1009Z",
    fill: "#A2A2A2"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2081.9 1010.12L2016.15 1036.55L2012.42 1027.27L2078.17 1000.84L2081.9 1010.12Z",
    fill: "#A2A2A2"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2015.01 1037.01L1949.26 1063.43L1945.53 1054.16L2011.28 1027.73L2015.01 1037.01Z",
    fill: "#A2A2A2"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2093.39 1038.71L2027.64 1065.14L2023.91 1055.86L2089.66 1029.43L2093.39 1038.71Z",
    fill: "#A2A2A2"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2026.5 1065.6L1960.75 1092.02L1957.02 1082.75L2022.77 1056.32L2026.5 1065.6Z",
    fill: "#A2A2A2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2104.65 1066.73L2038.9 1093.15L2035.17 1083.88L2100.92 1057.45L2104.65 1066.73Z",
    fill: "#A2A2A2"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2037.76 1093.61L1972.01 1120.04L1968.28 1110.76L2034.03 1084.33L2037.76 1093.61Z",
    fill: "#A2A2A2"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2115.91 1094.74L2050.16 1121.17L2046.43 1111.89L2112.18 1085.46L2115.91 1094.74Z",
    fill: "#A2A2A2"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2049.02 1121.63L1983.27 1148.06L1979.54 1138.78L2045.29 1112.35L2049.02 1121.63Z",
    fill: "#A2A2A2"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2127.17 1122.76L2061.42 1149.18L2057.69 1139.91L2123.44 1113.48L2127.17 1122.76Z",
    fill: "#A2A2A2"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2060.28 1149.64L1994.53 1176.07L1990.8 1166.79L2056.55 1140.37L2060.28 1149.64Z",
    fill: "#A2A2A2"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2138.43 1150.77L2072.68 1177.2L2068.95 1167.92L2134.7 1141.49L2138.43 1150.77Z",
    fill: "#A2A2A2"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2071.54 1177.66L2005.79 1204.09L2002.06 1194.81L2067.81 1168.38L2071.54 1177.66Z",
    fill: "#A2A2A2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2149.69 1178.79L2083.94 1205.22L2080.21 1195.94L2145.96 1169.51L2149.69 1178.79Z",
    fill: "#A2A2A2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2082.8 1205.68L2017.05 1232.1L2013.32 1222.82L2079.07 1196.4L2082.8 1205.68Z",
    fill: "#A2A2A2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2160.95 1206.8L2095.2 1233.23L2091.47 1223.95L2157.23 1197.52L2160.95 1206.8Z",
    fill: "#A2A2A2"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2094.06 1233.69L2028.31 1260.12L2024.58 1250.84L2090.33 1224.41L2094.06 1233.69Z",
    fill: "#A2A2A2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2172.44 1235.39L2106.69 1261.82L2102.96 1252.54L2168.72 1226.11L2172.44 1235.39Z",
    fill: "#A2A2A2"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2105.55 1262.28L2039.8 1288.7L2036.07 1279.43L2101.82 1253L2105.55 1262.28Z",
    fill: "#A2A2A2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2183.71 1263.41L2117.95 1289.83L2114.23 1280.55L2179.98 1254.13L2183.71 1263.41Z",
    fill: "#A2A2A2"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2116.81 1290.29L2051.06 1316.72L2047.33 1307.44L2113.08 1281.01L2116.81 1290.29Z",
    fill: "#A2A2A2"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2194.97 1291.42L2129.21 1317.85L2125.49 1308.57L2191.24 1282.14L2194.97 1291.42Z",
    fill: "#A2A2A2"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2128.07 1318.31L2062.32 1344.74L2058.59 1335.46L2124.34 1309.03L2128.07 1318.31Z",
    fill: "#A2A2A2"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2206.23 1319.44L2140.48 1345.86L2136.75 1336.59L2202.5 1310.16L2206.23 1319.44Z",
    fill: "#A2A2A2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2139.33 1346.32L2073.58 1372.75L2069.85 1363.47L2135.6 1337.05L2139.33 1346.32Z",
    fill: "#A2A2A2"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2217.49 1347.45L2151.74 1373.88L2148.01 1364.6L2213.76 1338.17L2217.49 1347.45Z",
    fill: "#A2A2A2"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2150.59 1374.34L2084.84 1400.77L2081.11 1391.49L2146.86 1365.06L2150.59 1374.34Z",
    fill: "#A2A2A2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2228.75 1375.47L2163 1401.9L2159.27 1392.62L2225.02 1366.19L2228.75 1375.47Z",
    fill: "#A2A2A2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2161.85 1402.35L2096.1 1428.78L2092.37 1419.5L2158.12 1393.08L2161.85 1402.35Z",
    fill: "#A2A2A2"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2240.24 1404.05L2174.49 1430.48L2170.76 1421.2L2236.51 1394.78L2240.24 1404.05Z",
    fill: "#A2A2A2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2173.34 1430.94L2107.59 1457.37L2103.86 1448.09L2169.61 1421.66L2173.34 1430.94Z",
    fill: "#A2A2A2"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2251.5 1432.07L2185.75 1458.5L2182.02 1449.22L2247.77 1422.79L2251.5 1432.07Z",
    fill: "#A2A2A2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2184.6 1458.96L2118.85 1485.38L2115.12 1476.11L2180.87 1449.68L2184.6 1458.96Z",
    fill: "#A2A2A2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2262.76 1460.09L2197.01 1486.51L2193.28 1477.23L2259.03 1450.81L2262.76 1460.09Z",
    fill: "#A2A2A2"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2195.86 1486.97L2130.11 1513.4L2126.38 1504.12L2192.13 1477.69L2195.86 1486.97Z",
    fill: "#A2A2A2"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2274.02 1488.1L2208.27 1514.53L2204.54 1505.25L2270.29 1478.82L2274.02 1488.1Z",
    fill: "#A2A2A2"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2207.12 1514.99L2141.37 1541.42L2137.64 1532.14L2203.4 1505.71L2207.12 1514.99Z",
    fill: "#A2A2A2"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1646.4 533.006L1578.36 560.353L1574.63 551.074L1642.67 523.727L1646.4 533.006Z",
    fill: "#A2A2A2"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1577.22 560.815L1509.18 588.161L1505.45 578.883L1573.49 551.536L1577.22 560.815Z",
    fill: "#A2A2A2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1657.66 561.022L1589.62 588.368L1585.9 579.09L1653.93 551.743L1657.66 561.022Z",
    fill: "#A2A2A2"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1588.48 588.83L1520.44 616.177L1516.71 606.898L1584.75 579.552L1588.48 588.83Z",
    fill: "#A2A2A2"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1668.92 589.037L1600.89 616.384L1597.16 607.105L1665.19 579.759L1668.92 589.037Z",
    fill: "#A2A2A2"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1599.74 616.846L1531.7 644.193L1527.97 634.914L1596.01 607.567L1599.74 616.846Z",
    fill: "#A2A2A2"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1680.41 617.623L1612.38 644.97L1608.65 635.691L1676.68 608.345L1680.41 617.623Z",
    fill: "#A2A2A2"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1611.23 645.432L1543.19 672.779L1539.46 663.5L1607.5 636.153L1611.23 645.432Z",
    fill: "#A2A2A2"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1691.67 645.639L1623.64 672.986L1619.91 663.707L1687.94 636.36L1691.67 645.639Z",
    fill: "#A2A2A2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1622.49 673.447L1554.45 700.794L1550.73 691.516L1618.76 664.169L1622.49 673.447Z",
    fill: "#A2A2A2"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1702.93 673.654L1634.9 701.001L1631.17 691.723L1699.2 664.376L1702.93 673.654Z",
    fill: "#A2A2A2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1633.75 701.463L1565.72 728.81L1561.99 719.531L1630.02 692.184L1633.75 701.463Z",
    fill: "#A2A2A2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1714.19 701.67L1646.16 729.017L1642.43 719.738L1710.47 692.391L1714.19 701.67Z",
    fill: "#A2A2A2"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1645.01 729.479L1576.98 756.825L1573.25 747.547L1641.28 720.2L1645.01 729.479Z",
    fill: "#A2A2A2"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1725.46 729.686L1657.42 757.032L1653.69 747.754L1721.73 720.407L1725.46 729.686Z",
    fill: "#A2A2A2"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1656.27 757.494L1588.24 784.841L1584.51 775.562L1652.54 748.216L1656.27 757.494Z",
    fill: "#A2A2A2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1736.72 757.701L1668.68 785.048L1664.95 775.77L1732.99 748.423L1736.72 757.701Z",
    fill: "#A2A2A2"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1667.53 785.51L1599.5 812.857L1595.77 803.578L1663.81 776.231L1667.53 785.51Z",
    fill: "#A2A2A2"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1747.98 785.717L1679.94 813.064L1676.21 803.785L1744.25 776.438L1747.98 785.717Z",
    fill: "#A2A2A2"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1678.8 813.525L1610.76 840.872L1607.03 831.594L1675.07 804.247L1678.8 813.525Z",
    fill: "#A2A2A2"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1759.24 813.733L1691.2 841.079L1687.47 831.801L1755.51 804.454L1759.24 813.733Z",
    fill: "#A2A2A2"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1690.06 841.541L1622.02 868.888L1618.29 859.609L1686.33 832.263L1690.06 841.541Z",
    fill: "#A2A2A2"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1770.73 842.322L1702.69 869.669L1698.96 860.391L1767 833.044L1770.73 842.322Z",
    fill: "#A2A2A2"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1701.55 870.127L1633.51 897.474L1629.78 888.195L1697.82 860.848L1701.55 870.127Z",
    fill: "#A2A2A2"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1781.99 870.338L1713.95 897.685L1710.22 888.406L1778.26 861.059L1781.99 870.338Z",
    fill: "#A2A2A2"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1712.81 898.143L1644.77 925.489L1641.04 916.211L1709.08 888.864L1712.81 898.143Z",
    fill: "#A2A2A2"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1793.25 898.354L1725.21 925.7L1721.48 916.422L1789.52 889.075L1793.25 898.354Z",
    fill: "#A2A2A2"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1724.07 926.158L1656.03 953.505L1652.3 944.227L1720.34 916.88L1724.07 926.158Z",
    fill: "#A2A2A2"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1804.51 926.365L1736.47 953.712L1732.74 944.434L1800.78 917.087L1804.51 926.365Z",
    fill: "#A2A2A2"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1735.33 954.174L1667.29 981.521L1663.56 972.242L1731.6 944.895L1735.33 954.174Z",
    fill: "#A2A2A2"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1815.77 954.385L1747.73 981.732L1744 972.453L1812.04 945.106L1815.77 954.385Z",
    fill: "#A2A2A2"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1746.59 982.19L1678.55 1009.54L1674.82 1000.26L1742.86 972.911L1746.59 982.19Z",
    fill: "#A2A2A2"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1827.03 982.4L1758.99 1009.75L1755.26 1000.47L1823.3 973.122L1827.03 982.4Z",
    fill: "#A2A2A2"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1757.85 1010.21L1689.81 1037.55L1686.08 1028.27L1754.12 1000.93L1757.85 1010.21Z",
    fill: "#A2A2A2"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1838.29 1010.41L1770.25 1037.76L1766.52 1028.48L1834.56 1001.13L1838.29 1010.41Z",
    fill: "#A2A2A2"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1769.11 1038.22L1701.07 1065.57L1697.34 1056.29L1765.38 1028.94L1769.11 1038.22Z",
    fill: "#A2A2A2"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1849.55 1038.43L1781.51 1065.77L1777.78 1056.5L1845.82 1029.15L1849.55 1038.43Z",
    fill: "#A2A2A2"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1780.37 1066.24L1712.33 1093.58L1708.6 1084.3L1776.64 1056.96L1780.37 1066.24Z",
    fill: "#A2A2A2"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1861.04 1067.02L1793 1094.36L1789.27 1085.09L1857.31 1057.74L1861.04 1067.02Z",
    fill: "#A2A2A2"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1791.86 1094.82L1723.82 1122.17L1720.09 1112.89L1788.13 1085.54L1791.86 1094.82Z",
    fill: "#A2A2A2"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1872.3 1095.03L1804.26 1122.38L1800.53 1113.1L1868.57 1085.75L1872.3 1095.03Z",
    fill: "#A2A2A2"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1803.12 1122.84L1735.08 1150.18L1731.35 1140.91L1799.39 1113.56L1803.12 1122.84Z",
    fill: "#A2A2A2"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1883.56 1123.05L1815.52 1150.4L1811.79 1141.12L1879.83 1113.77L1883.56 1123.05Z",
    fill: "#A2A2A2"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1814.38 1150.85L1746.34 1178.2L1742.61 1168.92L1810.65 1141.58L1814.38 1150.85Z",
    fill: "#A2A2A2"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1894.82 1151.06L1826.78 1178.41L1823.05 1169.13L1891.09 1141.79L1894.82 1151.06Z",
    fill: "#A2A2A2"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1825.64 1178.87L1757.6 1206.22L1753.87 1196.94L1821.91 1169.59L1825.64 1178.87Z",
    fill: "#A2A2A2"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1906.08 1179.08L1838.04 1206.43L1834.32 1197.15L1902.35 1169.8L1906.08 1179.08Z",
    fill: "#A2A2A2"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1836.9 1206.88L1768.86 1234.23L1765.13 1224.95L1833.17 1197.61L1836.9 1206.88Z",
    fill: "#A2A2A2"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1917.34 1207.1L1849.31 1234.44L1845.58 1225.16L1913.61 1197.82L1917.34 1207.1Z",
    fill: "#A2A2A2"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1848.16 1234.9L1780.12 1262.25L1776.39 1252.97L1844.43 1225.62L1848.16 1234.9Z",
    fill: "#A2A2A2"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1928.6 1235.11L1860.57 1262.46L1856.84 1253.18L1924.87 1225.83L1928.6 1235.11Z",
    fill: "#A2A2A2"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1859.42 1262.92L1791.38 1290.26L1787.66 1280.98L1855.69 1253.64L1859.42 1262.92Z",
    fill: "#A2A2A2"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1940.09 1263.7L1872.06 1291.04L1868.33 1281.77L1936.36 1254.42L1940.09 1263.7Z",
    fill: "#A2A2A2"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1870.91 1291.5L1802.87 1318.85L1799.15 1309.57L1867.18 1282.22L1870.91 1291.5Z",
    fill: "#A2A2A2"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1951.35 1291.71L1883.32 1319.06L1879.59 1309.78L1947.62 1282.43L1951.35 1291.71Z",
    fill: "#A2A2A2"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1882.17 1319.52L1814.14 1346.86L1810.41 1337.59L1878.44 1310.24L1882.17 1319.52Z",
    fill: "#A2A2A2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1962.61 1319.73L1894.58 1347.08L1890.85 1337.8L1958.89 1310.45L1962.61 1319.73Z",
    fill: "#A2A2A2"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1893.43 1347.53L1825.4 1374.88L1821.67 1365.6L1889.7 1338.25L1893.43 1347.53Z",
    fill: "#A2A2A2"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1973.87 1347.74L1905.84 1375.09L1902.11 1365.81L1970.15 1338.47L1973.87 1347.74Z",
    fill: "#A2A2A2"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1904.69 1375.55L1836.66 1402.9L1832.93 1393.62L1900.96 1366.27L1904.69 1375.55Z",
    fill: "#A2A2A2"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1985.14 1375.76L1917.1 1403.11L1913.37 1393.83L1981.41 1366.48L1985.14 1375.76Z",
    fill: "#A2A2A2"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1915.95 1403.56L1847.92 1430.91L1844.19 1421.63L1912.22 1394.29L1915.95 1403.56Z",
    fill: "#A2A2A2"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1996.4 1403.78L1928.36 1431.12L1924.63 1421.84L1992.67 1394.5L1996.4 1403.78Z",
    fill: "#A2A2A2"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1927.21 1431.58L1859.18 1458.93L1855.45 1449.65L1923.48 1422.3L1927.21 1431.58Z",
    fill: "#A2A2A2"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2007.66 1431.79L1939.62 1459.14L1935.89 1449.86L2003.93 1422.51L2007.66 1431.79Z",
    fill: "#A2A2A2"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1938.48 1459.6L1870.44 1486.94L1866.71 1477.66L1934.75 1450.32L1938.48 1459.6Z",
    fill: "#A2A2A2"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2018.92 1459.81L1950.88 1487.15L1947.15 1477.88L2015.19 1450.53L2018.92 1459.81Z",
    fill: "#A2A2A2"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1949.74 1487.61L1881.7 1514.96L1877.97 1505.68L1946.01 1478.33L1949.74 1487.61Z",
    fill: "#A2A2A2"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2030.41 1488.39L1962.37 1515.74L1958.64 1506.46L2026.68 1479.11L2030.41 1488.39Z",
    fill: "#A2A2A2"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1961.23 1516.2L1893.19 1543.54L1889.46 1534.27L1957.5 1506.92L1961.23 1516.2Z",
    fill: "#A2A2A2"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2041.67 1516.41L1973.63 1543.76L1969.9 1534.48L2037.94 1507.13L2041.67 1516.41Z",
    fill: "#A2A2A2"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1972.49 1544.21L1904.45 1571.56L1900.72 1562.28L1968.76 1534.93L1972.49 1544.21Z",
    fill: "#A2A2A2"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2052.93 1544.42L1984.89 1571.77L1981.16 1562.49L2049.2 1535.15L2052.93 1544.42Z",
    fill: "#A2A2A2"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1983.75 1572.23L1915.71 1599.58L1911.98 1590.3L1980.02 1562.95L1983.75 1572.23Z",
    fill: "#A2A2A2"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2064.19 1572.44L1996.15 1599.79L1992.42 1590.51L2060.46 1563.16L2064.19 1572.44Z",
    fill: "#A2A2A2"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1995.01 1600.24L1926.97 1627.59L1923.24 1618.31L1991.28 1590.97L1995.01 1600.24Z",
    fill: "#A2A2A2"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1376.82 675.228L1312.79 700.966L1309.06 691.688L1373.09 665.949L1376.82 675.228Z",
    fill: "#A2A2A2"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.78 815.353L1203.75 841.091L1200.02 831.812L1264.05 806.074L1267.78 815.353Z",
    fill: "#A2A2A2"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1199.17 842.931L1135.14 868.669L1131.41 859.391L1195.44 833.652L1199.17 842.931Z",
    fill: "#A2A2A2"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1279.27 843.943L1215.24 869.681L1211.51 860.402L1275.54 834.664L1279.27 843.943Z",
    fill: "#A2A2A2"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.66 871.517L1146.63 897.255L1142.9 887.977L1206.93 862.238L1210.66 871.517Z",
    fill: "#A2A2A2"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1290.53 871.958L1226.5 897.697L1222.77 888.418L1286.8 862.68L1290.53 871.958Z",
    fill: "#A2A2A2"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1221.92 899.533L1157.89 925.271L1154.16 915.992L1218.19 890.254L1221.92 899.533Z",
    fill: "#A2A2A2"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1301.79 899.974L1237.76 925.712L1234.03 916.434L1298.06 890.695L1301.79 899.974Z",
    fill: "#A2A2A2"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1233.18 927.548L1169.15 953.286L1165.42 944.008L1229.45 918.27L1233.18 927.548Z",
    fill: "#A2A2A2"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.05 927.99L1249.02 953.728L1245.29 944.449L1309.32 918.711L1313.05 927.99Z",
    fill: "#A2A2A2"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1244.44 955.564L1180.41 981.302L1176.68 972.023L1240.71 946.285L1244.44 955.564Z",
    fill: "#A2A2A2"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.54 956.576L1260.51 982.314L1256.78 973.035L1320.81 947.297L1324.54 956.576Z",
    fill: "#A2A2A2"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1255.93 984.154L1191.9 1009.89L1188.17 1000.61L1252.2 974.875L1255.93 984.154Z",
    fill: "#A2A2A2"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.8 984.591L1271.77 1010.33L1268.04 1001.05L1332.07 975.313L1335.8 984.591Z",
    fill: "#A2A2A2"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.19 1012.17L1203.16 1037.9L1199.43 1028.62L1263.46 1002.89L1267.19 1012.17Z",
    fill: "#A2A2A2"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1347.06 1012.61L1283.03 1038.34L1279.3 1029.07L1343.33 1003.33L1347.06 1012.61Z",
    fill: "#A2A2A2"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1278.45 1040.18L1214.42 1065.92L1210.69 1056.64L1274.72 1030.91L1278.45 1040.18Z",
    fill: "#A2A2A2"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1358.55 1041.19L1294.52 1066.93L1290.79 1057.65L1354.82 1031.91L1358.55 1041.19Z",
    fill: "#A2A2A2"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.94 1068.77L1225.91 1094.51L1222.18 1085.23L1286.22 1059.49L1289.94 1068.77Z",
    fill: "#A2A2A2"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1369.81 1069.21L1305.78 1094.95L1302.05 1085.67L1366.09 1059.93L1369.81 1069.21Z",
    fill: "#A2A2A2"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1301.2 1096.79L1237.17 1122.52L1233.44 1113.25L1297.47 1087.51L1301.2 1096.79Z",
    fill: "#A2A2A2"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1381.07 1097.22L1317.04 1122.96L1313.31 1113.68L1377.35 1087.95L1381.07 1097.22Z",
    fill: "#A2A2A2"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.47 1124.8L1248.43 1150.54L1244.7 1141.26L1308.74 1115.52L1312.47 1124.8Z",
    fill: "#A2A2A2"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1392.56 1125.81L1328.53 1151.55L1324.8 1142.27L1388.84 1116.53L1392.56 1125.81Z",
    fill: "#A2A2A2"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1323.96 1153.39L1259.92 1179.13L1256.19 1169.85L1320.23 1144.11L1323.96 1153.39Z",
    fill: "#A2A2A2"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.83 1153.83L1339.79 1179.57L1336.06 1170.29L1400.1 1144.55L1403.83 1153.83Z",
    fill: "#A2A2A2"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1335.22 1181.4L1271.18 1207.14L1267.45 1197.86L1331.49 1172.13L1335.22 1181.4Z",
    fill: "#A2A2A2"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1415.09 1181.84L1351.05 1207.58L1347.32 1198.3L1411.36 1172.56L1415.09 1181.84Z",
    fill: "#A2A2A2"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1346.48 1209.42L1282.44 1235.16L1278.71 1225.88L1342.75 1200.14L1346.48 1209.42Z",
    fill: "#A2A2A2"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1426.35 1209.86L1362.31 1235.59L1358.58 1226.32L1422.62 1200.58L1426.35 1209.86Z",
    fill: "#A2A2A2"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1357.74 1237.43L1293.7 1263.17L1289.97 1253.89L1354.01 1228.16L1357.74 1237.43Z",
    fill: "#A2A2A2"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.84 1238.45L1373.8 1264.18L1370.07 1254.91L1434.11 1229.17L1437.84 1238.45Z",
    fill: "#A2A2A2"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1369.23 1266.02L1305.19 1291.76L1301.46 1282.48L1365.5 1256.75L1369.23 1266.02Z",
    fill: "#A2A2A2"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1449.1 1266.46L1385.06 1292.2L1381.33 1282.92L1445.37 1257.18L1449.1 1266.46Z",
    fill: "#A2A2A2"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1380.49 1294.04L1316.45 1319.78L1312.72 1310.5L1376.76 1284.76L1380.49 1294.04Z",
    fill: "#A2A2A2"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1460.36 1294.48L1396.32 1320.22L1392.59 1310.94L1456.63 1285.2L1460.36 1294.48Z",
    fill: "#A2A2A2"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.75 1322.05L1327.71 1347.79L1323.98 1338.51L1388.02 1312.77L1391.75 1322.05Z",
    fill: "#A2A2A2"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1471.85 1323.06L1407.81 1348.8L1404.08 1339.52L1468.12 1313.79L1471.85 1323.06Z",
    fill: "#A2A2A2"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.24 1350.64L1339.2 1376.38L1335.47 1367.1L1399.51 1341.36L1403.24 1350.64Z",
    fill: "#A2A2A2"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1483.11 1351.08L1419.07 1376.82L1415.34 1367.54L1479.38 1341.8L1483.11 1351.08Z",
    fill: "#A2A2A2"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1414.5 1378.66L1350.46 1404.4L1346.73 1395.12L1410.77 1369.38L1414.5 1378.66Z",
    fill: "#A2A2A2"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1494.37 1379.1L1430.33 1404.83L1426.6 1395.55L1490.64 1369.82L1494.37 1379.1Z",
    fill: "#A2A2A2"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1425.76 1406.67L1361.72 1432.41L1357.99 1423.13L1422.03 1397.39L1425.76 1406.67Z",
    fill: "#A2A2A2"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1505.63 1407.11L1441.59 1432.85L1437.86 1423.57L1501.9 1397.83L1505.63 1407.11Z",
    fill: "#A2A2A2"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.02 1434.69L1372.98 1460.43L1369.25 1451.15L1433.29 1425.41L1437.02 1434.69Z",
    fill: "#A2A2A2"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1517.12 1435.7L1453.08 1461.43L1449.35 1452.16L1513.39 1426.42L1517.12 1435.7Z",
    fill: "#A2A2A2"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1448.51 1463.27L1384.47 1489.01L1380.75 1479.73L1444.78 1454L1448.51 1463.27Z",
    fill: "#A2A2A2"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1528.38 1463.71L1464.34 1489.45L1460.62 1480.17L1524.65 1454.43L1528.38 1463.71Z",
    fill: "#A2A2A2"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1459.77 1491.29L1395.74 1517.03L1392.01 1507.75L1456.04 1482.01L1459.77 1491.29Z",
    fill: "#A2A2A2"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1539.64 1491.73L1475.61 1517.47L1471.88 1508.19L1535.91 1482.45L1539.64 1491.73Z",
    fill: "#A2A2A2"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1471.03 1519.31L1407 1545.04L1403.27 1535.77L1467.3 1510.03L1471.03 1519.31Z",
    fill: "#A2A2A2"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1551.13 1520.32L1487.1 1546.06L1483.37 1536.78L1547.4 1511.04L1551.13 1520.32Z",
    fill: "#A2A2A2"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1482.52 1547.89L1418.49 1573.63L1414.76 1564.35L1478.79 1538.61L1482.52 1547.89Z",
    fill: "#A2A2A2"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1562.39 1548.33L1498.36 1574.07L1494.63 1564.79L1558.66 1539.05L1562.39 1548.33Z",
    fill: "#A2A2A2"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1493.78 1575.91L1429.75 1601.65L1426.02 1592.37L1490.05 1566.63L1493.78 1575.91Z",
    fill: "#A2A2A2"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1573.65 1576.35L1509.62 1602.09L1505.89 1592.81L1569.92 1567.07L1573.65 1576.35Z",
    fill: "#A2A2A2"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1505.04 1603.92L1441.01 1629.66L1437.28 1620.38L1501.31 1594.64L1505.04 1603.92Z",
    fill: "#A2A2A2"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1585.14 1604.93L1521.11 1630.67L1517.38 1621.39L1581.41 1595.66L1585.14 1604.93Z",
    fill: "#A2A2A2"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1516.53 1632.51L1452.5 1658.25L1448.77 1648.97L1512.8 1623.23L1516.53 1632.51Z",
    fill: "#A2A2A2"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1596.4 1632.95L1532.37 1658.69L1528.64 1649.41L1592.67 1623.67L1596.4 1632.95Z",
    fill: "#A2A2A2"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1527.79 1660.52L1463.76 1686.26L1460.03 1676.98L1524.06 1651.25L1527.79 1660.52Z",
    fill: "#A2A2A2"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1607.66 1660.97L1543.63 1686.7L1539.9 1677.43L1603.93 1651.69L1607.66 1660.97Z",
    fill: "#A2A2A2"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1539.05 1688.54L1475.02 1714.28L1471.29 1705L1535.32 1679.26L1539.05 1688.54Z",
    fill: "#A2A2A2"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1618.92 1688.98L1554.89 1714.72L1551.16 1705.44L1615.19 1679.7L1618.92 1688.98Z",
    fill: "#A2A2A2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1550.31 1716.56L1486.28 1742.29L1482.55 1733.02L1546.58 1707.28L1550.31 1716.56Z",
    fill: "#A2A2A2"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1630.41 1717.57L1566.38 1743.31L1562.65 1734.03L1626.68 1708.29L1630.41 1717.57Z",
    fill: "#A2A2A2"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1561.8 1745.15L1497.77 1770.88L1494.04 1761.61L1558.07 1735.87L1561.8 1745.15Z",
    fill: "#A2A2A2"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1641.67 1745.58L1577.64 1771.32L1573.91 1762.04L1637.94 1736.3L1641.67 1745.58Z",
    fill: "#A2A2A2"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1573.06 1773.16L1509.03 1798.9L1505.3 1789.62L1569.34 1763.88L1573.06 1773.16Z",
    fill: "#A2A2A2"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.84 985.704L947.373 1011.21L943.644 1001.93L1007.11 976.425L1010.84 985.704Z",
    fill: "#A2A2A2"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1090.71 986.145L1027.24 1011.65L1023.51 1002.38L1086.98 976.867L1090.71 986.145Z",
    fill: "#A2A2A2"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1022.67 1013.49L958.633 1039.23L954.903 1029.95L1018.94 1004.21L1022.67 1013.49Z",
    fill: "#A2A2A2"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1101.97 1014.16L1038.5 1039.67L1034.77 1030.39L1098.24 1004.88L1101.97 1014.16Z",
    fill: "#A2A2A2"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1033.93 1041.51L969.893 1067.24L966.164 1057.96L1030.2 1032.23L1033.93 1041.51Z",
    fill: "#A2A2A2"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1113.46 1042.75L1049.99 1068.26L1046.26 1058.98L1109.73 1033.47L1113.46 1042.75Z",
    fill: "#A2A2A2"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1045.42 1070.1L981.384 1095.83L977.654 1086.55L1041.69 1060.82L1045.42 1070.1Z",
    fill: "#A2A2A2"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.72 1070.76L1061.25 1096.27L1057.52 1086.99L1120.99 1061.48L1124.72 1070.76Z",
    fill: "#A2A2A2"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056.68 1098.11L992.644 1123.85L988.915 1114.57L1052.95 1088.83L1056.68 1098.11Z",
    fill: "#A2A2A2"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1135.98 1098.78L1072.51 1124.29L1068.78 1115.01L1132.25 1089.5L1135.98 1098.78Z",
    fill: "#A2A2A2"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1067.94 1126.13L1003.9 1151.86L1000.17 1142.59L1064.21 1116.85L1067.94 1126.13Z",
    fill: "#A2A2A2"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.24 1126.79L1083.77 1152.3L1080.04 1143.02L1143.51 1117.52L1147.24 1126.79Z",
    fill: "#A2A2A2"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1079.2 1154.14L1015.16 1179.88L1011.44 1170.6L1075.47 1144.86L1079.2 1154.14Z",
    fill: "#A2A2A2"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1158.73 1155.38L1095.26 1180.89L1091.54 1171.61L1155 1146.1L1158.73 1155.38Z",
    fill: "#A2A2A2"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1090.69 1182.73L1026.66 1208.47L1022.93 1199.19L1086.96 1173.45L1090.69 1182.73Z",
    fill: "#A2A2A2"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1169.99 1183.4L1106.53 1208.9L1102.8 1199.62L1166.26 1174.12L1169.99 1183.4Z",
    fill: "#A2A2A2"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1101.95 1210.74L1037.92 1236.48L1034.19 1227.2L1098.22 1201.46L1101.95 1210.74Z",
    fill: "#A2A2A2"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.25 1211.41L1117.79 1236.92L1114.06 1227.64L1177.52 1202.13L1181.25 1211.41Z",
    fill: "#A2A2A2"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1113.21 1238.76L1049.18 1264.5L1045.45 1255.22L1109.48 1229.48L1113.21 1238.76Z",
    fill: "#A2A2A2"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1192.51 1239.43L1129.05 1264.93L1125.32 1255.66L1188.78 1230.15L1192.51 1239.43Z",
    fill: "#A2A2A2"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.47 1266.77L1060.44 1292.51L1056.71 1283.23L1120.74 1257.5L1124.47 1266.77Z",
    fill: "#A2A2A2"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.77 1267.44L1140.31 1292.95L1136.58 1283.67L1200.04 1258.16L1203.77 1267.44Z",
    fill: "#A2A2A2"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1135.73 1294.79L1071.7 1320.53L1067.97 1311.25L1132 1285.51L1135.73 1294.79Z",
    fill: "#A2A2A2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1215.26 1296.03L1151.8 1321.54L1148.07 1312.26L1211.53 1286.75L1215.26 1296.03Z",
    fill: "#A2A2A2"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1147.22 1323.38L1083.19 1349.11L1079.46 1339.84L1143.49 1314.1L1147.22 1323.38Z",
    fill: "#A2A2A2"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.52 1324.05L1163.06 1349.56L1159.33 1340.28L1222.79 1314.77L1226.52 1324.05Z",
    fill: "#A2A2A2"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1158.48 1351.39L1094.45 1377.13L1090.72 1367.85L1154.75 1342.11L1158.48 1351.39Z",
    fill: "#A2A2A2"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.78 1352.06L1174.32 1377.57L1170.59 1368.29L1234.05 1342.78L1237.78 1352.06Z",
    fill: "#A2A2A2"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1169.74 1379.41L1105.71 1405.15L1101.98 1395.87L1166.01 1370.13L1169.74 1379.41Z",
    fill: "#A2A2A2"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.04 1380.08L1185.58 1405.59L1181.85 1396.31L1245.31 1370.8L1249.04 1380.08Z",
    fill: "#A2A2A2"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181 1407.42L1116.97 1433.16L1113.24 1423.88L1177.27 1398.14L1181 1407.42Z",
    fill: "#A2A2A2"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.53 1408.66L1197.07 1434.17L1193.34 1424.89L1256.8 1399.39L1260.53 1408.66Z",
    fill: "#A2A2A2"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1192.49 1436.01L1128.46 1461.75L1124.73 1452.47L1188.76 1426.73L1192.49 1436.01Z",
    fill: "#A2A2A2"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.79 1436.68L1208.33 1462.19L1204.6 1452.91L1268.06 1427.4L1271.79 1436.68Z",
    fill: "#A2A2A2"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.76 1464.02L1139.72 1489.76L1135.99 1480.48L1200.03 1454.75L1203.76 1464.02Z",
    fill: "#A2A2A2"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1283.05 1464.7L1219.59 1490.2L1215.86 1480.93L1279.32 1455.42L1283.05 1464.7Z",
    fill: "#A2A2A2"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1215.02 1492.04L1150.98 1517.78L1147.25 1508.5L1211.29 1482.76L1215.02 1492.04Z",
    fill: "#A2A2A2"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1294.31 1492.71L1230.85 1518.22L1227.12 1508.94L1290.58 1483.43L1294.31 1492.71Z",
    fill: "#A2A2A2"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.28 1520.06L1162.24 1545.79L1158.51 1536.52L1222.55 1510.78L1226.28 1520.06Z",
    fill: "#A2A2A2"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.8 1521.3L1242.34 1546.81L1238.61 1537.53L1302.07 1512.02L1305.8 1521.3Z",
    fill: "#A2A2A2"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.77 1548.65L1173.73 1574.38L1170 1565.11L1234.04 1539.37L1237.77 1548.65Z",
    fill: "#A2A2A2"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.06 1549.31L1253.6 1574.82L1249.87 1565.54L1313.33 1540.03L1317.06 1549.31Z",
    fill: "#A2A2A2"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.03 1576.66L1184.99 1602.4L1181.26 1593.12L1245.3 1567.38L1249.03 1576.66Z",
    fill: "#A2A2A2"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1328.32 1577.33L1264.86 1602.84L1261.13 1593.56L1324.59 1568.05L1328.32 1577.33Z",
    fill: "#A2A2A2"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.29 1604.68L1196.25 1630.42L1192.52 1621.14L1256.56 1595.4L1260.29 1604.68Z",
    fill: "#A2A2A2"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.58 1605.34L1276.12 1630.85L1272.39 1621.57L1335.86 1596.07L1339.58 1605.34Z",
    fill: "#A2A2A2"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.55 1632.69L1207.51 1658.43L1203.78 1649.15L1267.82 1623.41L1271.55 1632.69Z",
    fill: "#A2A2A2"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1350.85 1633.36L1287.38 1658.87L1283.65 1649.59L1347.12 1624.08L1350.85 1633.36Z",
    fill: "#A2A2A2"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.81 1660.71L1218.77 1686.45L1215.04 1677.17L1279.08 1651.43L1282.81 1660.71Z",
    fill: "#A2A2A2"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1362.34 1661.95L1298.87 1687.45L1295.14 1678.18L1358.61 1652.67L1362.34 1661.95Z",
    fill: "#A2A2A2"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1294.3 1689.29L1230.26 1715.03L1226.53 1705.75L1290.57 1680.02L1294.3 1689.29Z",
    fill: "#A2A2A2"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1373.6 1689.96L1310.13 1715.47L1306.4 1706.19L1369.87 1680.68L1373.6 1689.96Z",
    fill: "#A2A2A2"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.56 1717.31L1241.52 1743.05L1237.79 1733.77L1301.83 1708.03L1305.56 1717.31Z",
    fill: "#A2A2A2"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1384.86 1717.98L1321.39 1743.49L1317.66 1734.21L1381.13 1708.7L1384.86 1717.98Z",
    fill: "#A2A2A2"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1316.82 1745.33L1252.78 1771.06L1249.05 1761.79L1313.09 1736.05L1316.82 1745.33Z",
    fill: "#A2A2A2"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1396.12 1745.99L1332.65 1771.5L1328.92 1762.22L1392.39 1736.71L1396.12 1745.99Z",
    fill: "#A2A2A2"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1328.08 1773.34L1264.04 1799.08L1260.31 1789.8L1324.35 1764.06L1328.08 1773.34Z",
    fill: "#A2A2A2"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1407.61 1774.58L1344.14 1800.09L1340.41 1790.81L1403.88 1765.3L1407.61 1774.58Z",
    fill: "#A2A2A2"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.57 1801.93L1275.53 1827.67L1271.8 1818.39L1335.84 1792.65L1339.57 1801.93Z",
    fill: "#A2A2A2"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1418.87 1802.59L1355.4 1828.1L1351.67 1818.82L1415.14 1793.32L1418.87 1802.59Z",
    fill: "#A2A2A2"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1350.83 1829.94L1286.79 1855.68L1283.07 1846.4L1347.1 1820.66L1350.83 1829.94Z",
    fill: "#A2A2A2"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1430.13 1830.61L1366.66 1856.12L1362.94 1846.84L1426.4 1821.33L1430.13 1830.61Z",
    fill: "#A2A2A2"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1362.09 1857.96L1298.06 1883.7L1294.33 1874.42L1358.36 1848.68L1362.09 1857.96Z",
    fill: "#A2A2A2"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.216 1154.32L770.752 1179.83L767.022 1170.55L830.486 1145.04L834.216 1154.32Z",
    fill: "#A2A2A2"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.085 1154.76L850.621 1180.27L846.892 1170.99L910.355 1145.48L914.085 1154.76Z",
    fill: "#A2A2A2"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M845.475 1182.34L782.012 1207.84L778.282 1198.57L841.746 1173.06L845.475 1182.34Z",
    fill: "#A2A2A2"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M925.345 1182.77L861.882 1208.28L858.152 1199L921.616 1173.5L925.345 1182.77Z",
    fill: "#A2A2A2"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M856.736 1210.35L793.272 1235.86L789.543 1226.58L853.007 1201.07L856.736 1210.35Z",
    fill: "#A2A2A2"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M936.606 1210.79L873.142 1236.3L869.413 1227.02L932.877 1201.51L936.606 1210.79Z",
    fill: "#A2A2A2"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.997 1238.37L804.533 1263.88L800.804 1254.6L864.267 1229.09L867.997 1238.37Z",
    fill: "#A2A2A2"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M947.866 1238.81L884.402 1264.31L880.673 1255.04L944.137 1229.53L947.866 1238.81Z",
    fill: "#A2A2A2"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.257 1266.38L815.793 1291.89L812.063 1282.61L875.527 1257.1L879.257 1266.38Z",
    fill: "#A2A2A2"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.127 1266.82L895.663 1292.33L891.934 1283.05L955.397 1257.54L959.127 1266.82Z",
    fill: "#A2A2A2"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M890.517 1294.4L827.054 1319.91L823.324 1310.63L886.788 1285.12L890.517 1294.4Z",
    fill: "#A2A2A2"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M970.387 1294.84L906.924 1320.34L903.194 1311.07L966.658 1285.56L970.387 1294.84Z",
    fill: "#A2A2A2"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.778 1322.41L838.314 1347.92L834.585 1338.64L898.049 1313.14L901.778 1322.41Z",
    fill: "#A2A2A2"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.647 1322.85L918.183 1348.36L914.454 1339.08L977.918 1313.57L981.647 1322.85Z",
    fill: "#A2A2A2"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.038 1350.43L849.574 1375.94L845.845 1366.66L909.308 1341.15L913.038 1350.43Z",
    fill: "#A2A2A2"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.137 1351.44L929.674 1376.95L925.944 1367.67L989.408 1342.16L993.137 1351.44Z",
    fill: "#A2A2A2"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M924.529 1379.02L861.065 1404.52L857.336 1395.25L920.8 1369.74L924.529 1379.02Z",
    fill: "#A2A2A2"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1004.4 1379.45L940.934 1404.96L937.205 1395.68L1000.67 1370.18L1004.4 1379.45Z",
    fill: "#A2A2A2"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M935.789 1407.03L872.325 1432.54L868.596 1423.26L932.059 1397.75L935.789 1407.03Z",
    fill: "#A2A2A2"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1015.66 1407.47L952.195 1432.98L948.466 1423.7L1011.93 1398.19L1015.66 1407.47Z",
    fill: "#A2A2A2"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M947.05 1435.05L883.586 1460.56L879.856 1451.28L943.32 1425.77L947.05 1435.05Z",
    fill: "#A2A2A2"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1026.92 1435.49L963.456 1460.99L959.727 1451.71L1023.19 1426.21L1026.92 1435.49Z",
    fill: "#A2A2A2"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.31 1463.06L894.847 1488.57L891.117 1479.29L954.581 1453.78L958.31 1463.06Z",
    fill: "#A2A2A2"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1038.18 1463.5L974.717 1489.01L970.987 1479.73L1034.45 1454.22L1038.18 1463.5Z",
    fill: "#A2A2A2"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M969.57 1491.08L906.106 1516.59L902.377 1507.31L965.841 1481.8L969.57 1491.08Z",
    fill: "#A2A2A2"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1049.44 1491.52L985.976 1517.02L982.247 1507.75L1045.71 1482.24L1049.44 1491.52Z",
    fill: "#A2A2A2"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M980.831 1519.09L917.367 1544.6L913.638 1535.32L977.101 1509.82L980.831 1519.09Z",
    fill: "#A2A2A2"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1060.7 1519.53L997.237 1545.04L993.508 1535.76L1056.97 1510.25L1060.7 1519.53Z",
    fill: "#A2A2A2"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M992.092 1547.11L928.628 1572.62L924.898 1563.34L988.362 1537.83L992.092 1547.11Z",
    fill: "#A2A2A2"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1071.96 1547.55L1008.5 1573.06L1004.77 1563.78L1068.23 1538.27L1071.96 1547.55Z",
    fill: "#A2A2A2"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.35 1575.13L939.888 1600.63L936.158 1591.36L999.622 1565.85L1003.35 1575.13Z",
    fill: "#A2A2A2"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1083.22 1575.56L1019.76 1601.07L1016.03 1591.79L1079.49 1566.28L1083.22 1575.56Z",
    fill: "#A2A2A2"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1014.61 1603.14L951.148 1628.65L947.419 1619.37L1010.88 1593.86L1014.61 1603.14Z",
    fill: "#A2A2A2"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1094.48 1603.58L1031.02 1629.09L1027.29 1619.81L1090.75 1594.3L1094.48 1603.58Z",
    fill: "#A2A2A2"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1025.87 1631.16L962.409 1656.67L958.68 1647.39L1022.14 1621.88L1025.87 1631.16Z",
    fill: "#A2A2A2"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1105.74 1631.59L1042.28 1657.1L1038.55 1647.82L1102.01 1622.32L1105.74 1631.59Z",
    fill: "#A2A2A2"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1037.13 1659.17L973.67 1684.68L969.94 1675.4L1033.4 1649.89L1037.13 1659.17Z",
    fill: "#A2A2A2"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1117 1659.61L1053.54 1685.12L1049.81 1675.84L1113.27 1650.33L1117 1659.61Z",
    fill: "#A2A2A2"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1048.39 1687.19L984.93 1712.7L981.2 1703.42L1044.66 1677.91L1048.39 1687.19Z",
    fill: "#A2A2A2"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1128.26 1687.63L1064.8 1713.13L1061.07 1703.86L1124.53 1678.35L1128.26 1687.63Z",
    fill: "#A2A2A2"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1059.65 1715.2L996.19 1740.71L992.461 1731.43L1055.92 1705.93L1059.65 1715.2Z",
    fill: "#A2A2A2"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1139.52 1715.64L1076.06 1741.15L1072.33 1731.87L1135.79 1706.36L1139.52 1715.64Z",
    fill: "#A2A2A2"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.91 1743.22L1007.45 1768.73L1003.72 1759.45L1067.18 1733.94L1070.91 1743.22Z",
    fill: "#A2A2A2"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.01 1744.23L1087.55 1769.74L1083.82 1760.46L1147.29 1734.95L1151.01 1744.23Z",
    fill: "#A2A2A2"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1082.41 1771.81L1018.94 1797.31L1015.21 1788.04L1078.68 1762.53L1082.41 1771.81Z",
    fill: "#A2A2A2"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1162.28 1772.24L1098.81 1797.75L1095.08 1788.47L1158.55 1762.96L1162.28 1772.24Z",
    fill: "#A2A2A2"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1093.66 1799.82L1030.2 1825.33L1026.47 1816.05L1089.94 1790.54L1093.66 1799.82Z",
    fill: "#A2A2A2"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1173.53 1800.26L1110.07 1825.77L1106.34 1816.49L1169.81 1790.98L1173.53 1800.26Z",
    fill: "#A2A2A2"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.93 1827.84L1041.46 1853.34L1037.73 1844.07L1101.2 1818.56L1104.93 1827.84Z",
    fill: "#A2A2A2"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1184.8 1828.27L1121.33 1853.78L1117.6 1844.5L1181.07 1819L1184.8 1828.27Z",
    fill: "#A2A2A2"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1116.19 1855.85L1052.72 1881.36L1048.99 1872.08L1112.46 1846.57L1116.19 1855.85Z",
    fill: "#A2A2A2"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.06 1856.29L1132.59 1881.8L1128.86 1872.52L1192.33 1847.01L1196.06 1856.29Z",
    fill: "#A2A2A2"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1127.45 1883.87L1063.98 1909.38L1060.25 1900.1L1123.72 1874.59L1127.45 1883.87Z",
    fill: "#A2A2A2"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1207.32 1884.31L1143.85 1909.81L1140.12 1900.54L1203.59 1875.03L1207.32 1884.31Z",
    fill: "#A2A2A2"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1138.71 1911.88L1075.24 1937.39L1071.51 1928.11L1134.98 1902.6L1138.71 1911.88Z",
    fill: "#A2A2A2"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1218.58 1912.32L1155.11 1937.83L1151.38 1928.55L1214.85 1903.04L1218.58 1912.32Z",
    fill: "#A2A2A2"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.97 1939.9L1086.5 1965.41L1082.77 1956.13L1146.24 1930.62L1149.97 1939.9Z",
    fill: "#A2A2A2"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.361 1693.13L576.897 1718.64L573.168 1709.36L636.632 1683.85L640.361 1693.13Z",
    fill: "#A2A2A2"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.752 1720.71L508.288 1746.22L504.559 1736.94L568.022 1711.43L571.752 1720.71Z",
    fill: "#A2A2A2"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.392 1720.57L587.929 1746.08L584.199 1736.8L647.663 1711.3L651.392 1720.57Z",
    fill: "#A2A2A2"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.783 1748.15L519.319 1773.66L515.59 1764.38L579.054 1738.87L582.783 1748.15Z",
    fill: "#A2A2A2"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M662.653 1748.59L599.189 1774.1L595.46 1764.82L658.924 1739.31L662.653 1748.59Z",
    fill: "#A2A2A2"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.043 1776.17L530.579 1801.68L526.85 1792.4L590.313 1766.89L594.043 1776.17Z",
    fill: "#A2A2A2"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.683 1776.04L610.22 1801.54L606.49 1792.27L669.954 1766.76L673.683 1776.04Z",
    fill: "#A2A2A2"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.074 1803.61L541.61 1829.12L537.881 1819.84L601.345 1794.33L605.074 1803.61Z",
    fill: "#A2A2A2"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.943 1804.05L621.479 1829.56L617.75 1820.28L681.214 1794.77L684.943 1804.05Z",
    fill: "#A2A2A2"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.334 1831.63L552.87 1857.13L549.141 1847.86L612.604 1822.35L616.334 1831.63Z",
    fill: "#A2A2A2"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.974 1831.49L632.511 1857L628.781 1847.72L692.245 1822.21L695.974 1831.49Z",
    fill: "#A2A2A2"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.365 1859.07L563.901 1884.58L560.172 1875.3L623.636 1849.79L627.365 1859.07Z",
    fill: "#A2A2A2"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.235 1859.51L643.771 1885.02L640.042 1875.74L703.506 1850.23L707.235 1859.51Z",
    fill: "#A2A2A2"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.625 1887.09L575.161 1912.59L571.432 1903.32L634.895 1877.81L638.625 1887.09Z",
    fill: "#A2A2A2"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.495 1887.52L655.031 1913.03L651.302 1903.75L714.765 1878.25L718.495 1887.52Z",
    fill: "#A2A2A2"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.886 1915.1L586.422 1940.61L582.692 1931.33L646.156 1905.82L649.886 1915.1Z",
    fill: "#A2A2A2"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.756 1915.54L666.292 1941.05L662.562 1931.77L726.026 1906.26L729.756 1915.54Z",
    fill: "#A2A2A2"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.146 1943.12L597.683 1968.63L593.953 1959.35L657.417 1933.84L661.146 1943.12Z",
    fill: "#A2A2A2"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.786 1942.99L677.322 1968.49L673.593 1959.21L737.056 1933.71L740.786 1942.99Z",
    fill: "#A2A2A2"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.177 1970.56L608.713 1996.07L604.983 1986.79L668.447 1961.28L672.177 1970.56Z",
    fill: "#A2A2A2"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M752.047 1971L688.583 1996.51L684.854 1987.23L748.317 1961.72L752.047 1971Z",
    fill: "#A2A2A2"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.437 1998.57L619.974 2024.08L616.244 2014.8L679.708 1989.3L683.437 1998.57Z",
    fill: "#A2A2A2"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M763.077 1998.44L699.613 2023.95L695.884 2014.67L759.348 1989.16L763.077 1998.44Z",
    fill: "#A2A2A2"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694.468 2026.02L631.004 2051.53L627.274 2042.25L690.738 2016.74L694.468 2026.02Z",
    fill: "#A2A2A2"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M774.338 2026.46L710.874 2051.97L707.145 2042.69L770.608 2017.18L774.338 2026.46Z",
    fill: "#A2A2A2"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.728 2054.04L642.265 2079.54L638.535 2070.27L701.999 2044.76L705.728 2054.04Z",
    fill: "#A2A2A2"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.369 2053.9L721.905 2079.41L718.176 2070.13L781.64 2044.62L785.369 2053.9Z",
    fill: "#A2A2A2"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M716.76 2081.48L653.296 2106.99L649.566 2097.71L713.03 2072.2L716.76 2081.48Z",
    fill: "#A2A2A2"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.629 2081.92L733.165 2107.43L729.436 2098.15L792.899 2072.64L796.629 2081.92Z",
    fill: "#A2A2A2"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.019 2109.49L664.556 2135L660.826 2125.72L724.29 2100.21L728.019 2109.49Z",
    fill: "#A2A2A2"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.837 2108.38L556.85 1690.43L566.128 1686.7L734.116 2104.65L724.837 2108.38Z",
    fill: "#A2A2A2"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.668 2024.04L708.194 1460.58L717.473 1456.85L943.946 2020.31L934.668 2024.04Z",
    fill: "#A2A2A2"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.9 1939.07L828.85 1147.77L838.128 1144.04L1156.18 1935.34L1146.9 1939.07Z",
    fill: "#A2A2A2"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1359.59 1856.89L1008.68 983.84L1017.96 980.11L1368.87 1853.17L1359.59 1856.89Z",
    fill: "#A2A2A2"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1571.71 1771.64L1185.53 812.48L1194.8 808.746L1580.99 1767.9L1571.71 1771.64Z",
    fill: "#A2A2A2"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1781.55 1687.29L1373.18 671.305L1382.46 667.576L1790.83 1683.56L1781.55 1687.29Z",
    fill: "#A2A2A2"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1989.09 1600.55L1559.23 531.108L1568.51 527.378L1998.37 1596.82L1989.09 1600.55Z",
    fill: "#A2A2A2"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2202.35 1514.83L1741.02 367.061L1750.29 363.332L2211.63 1511.1L2202.35 1514.83Z",
    fill: "#A2A2A2"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2413.9 1429.81L1951.48 279.342L1960.76 275.613L2423.17 1426.08L2413.9 1429.81Z",
    fill: "#A2A2A2"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.25 1555.01L617.096 1631.75L555.348 1656.57L568.561 1689.45L493.818 1719.49L486.126 1700.35L586.25 1555.01ZM497.407 1701.61L499.367 1706.48L555.554 1683.9L542.34 1651.02L604.088 1626.21L583.918 1576.02L497.407 1701.61Z",
    fill: "#A2A2A2"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.732 2003.54L453.267 2030.66L449.537 2021.38L517.003 1994.26L520.732 2003.54Z",
    fill: "#A2A2A2"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.694 2030.89L390.374 2055.93L386.645 2046.66L448.965 2021.61L452.694 2030.89Z",
    fill: "#A2A2A2"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.073 2029.27L463.607 2056.38L459.878 2047.11L527.344 2019.99L531.073 2029.27Z",
    fill: "#A2A2A2"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.036 2056.61L397.285 2083.04L393.556 2073.76L459.306 2047.33L463.036 2056.61Z",
    fill: "#A2A2A2"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.334 2057.28L474.868 2084.4L471.139 2075.12L538.605 2048L542.334 2057.28Z",
    fill: "#A2A2A2"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.297 2084.63L408.546 2111.06L404.816 2101.78L470.567 2075.35L474.297 2084.63Z",
    fill: "#A2A2A2"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.594 2085.3L486.128 2112.42L482.398 2103.14L549.864 2076.02L553.594 2085.3Z",
    fill: "#A2A2A2"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.556 2112.64L419.806 2139.07L416.076 2129.79L481.827 2103.37L485.556 2112.64Z",
    fill: "#A2A2A2"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.625 2112.74L497.159 2139.86L493.43 2130.58L560.896 2103.46L564.625 2112.74Z",
    fill: "#A2A2A2"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.588 2140.09L430.837 2166.52L427.107 2157.24L492.858 2130.81L496.588 2140.09Z",
    fill: "#A2A2A2"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.886 2140.76L508.42 2167.88L504.69 2158.6L572.156 2131.48L575.886 2140.76Z",
    fill: "#A2A2A2"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.848 2168.1L442.098 2194.53L438.368 2185.25L504.119 2158.83L507.848 2168.1Z",
    fill: "#A2A2A2"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.146 2168.77L519.68 2195.89L515.95 2186.61L583.416 2159.5L587.146 2168.77Z",
    fill: "#A2A2A2"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.238 2389.94L68.8215 2366.11L73.0264 2357.04L124.443 2380.87L120.238 2389.94Z",
    fill: "#A2A2A2"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.529 2365.2L84.1125 2341.37L88.3174 2332.3L139.734 2356.13L135.529 2365.2Z",
    fill: "#A2A2A2"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.578 2334.86L95.1613 2311.03L99.3662 2301.96L150.783 2325.79L146.578 2334.86Z",
    fill: "#A2A2A2"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.599 2306.83L96.9917 2279.12L101.093 2270L162.7 2297.71L158.599 2306.83Z",
    fill: "#A2A2A2"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.971 2279.8L111.364 2252.1L115.465 2242.98L177.072 2270.68L172.971 2279.8Z",
    fill: "#A2A2A2"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.343 2252.77L125.736 2225.07L129.837 2215.95L191.444 2243.65L187.343 2252.77Z",
    fill: "#A2A2A2"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.914 2225.4L139.307 2197.7L143.408 2188.58L205.015 2216.28L200.914 2225.4Z",
    fill: "#A2A2A2"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.827 2197.23L153.22 2169.53L157.321 2160.41L218.929 2188.11L214.827 2197.23Z",
    fill: "#A2A2A2"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.399 2169.86L166.791 2142.16L170.893 2133.04L232.5 2160.74L228.399 2169.86Z",
    fill: "#A2A2A2"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.82 2143.04L178.356 2114.87L182.578 2105.81L243.042 2133.97L238.82 2143.04Z",
    fill: "#A2A2A2"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.169 2116.81L195.706 2088.64L199.928 2079.58L260.392 2107.74L256.169 2116.81Z",
    fill: "#A2A2A2"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.51 2088.86L209.046 2060.7L213.269 2051.64L273.732 2079.8L269.51 2088.86Z",
    fill: "#A2A2A2"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.412 2061.77L222.005 2032.11L226.532 2023.2L284.939 2052.85L280.412 2061.77Z",
    fill: "#A2A2A2"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.116 2035.81L238.996 2005.24L243.78 1996.46L299.9 2027.03L295.116 2035.81Z",
    fill: "#A2A2A2"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.52 2009.7L254.401 1979.13L259.185 1970.34L315.304 2000.92L310.52 2009.7Z",
    fill: "#A2A2A2"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.352 1983.81L269.233 1953.24L274.017 1944.46L330.136 1975.03L325.352 1983.81Z",
    fill: "#A2A2A2"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.011 1955.87L285.892 1925.29L290.676 1916.51L346.795 1947.08L342.011 1955.87Z",
    fill: "#A2A2A2"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.439 1928.96L298.32 1898.38L303.104 1889.6L359.223 1920.17L354.439 1928.96Z",
    fill: "#A2A2A2"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.885 2416.96L218.002 2484.43L208.724 2488.16L181.607 2420.69L190.885 2416.96Z",
    fill: "#A2A2A2"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.901 2405.7L246.018 2473.17L236.739 2476.89L209.622 2409.43L218.901 2405.7Z",
    fill: "#A2A2A2"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.916 2394.44L274.033 2461.9L264.755 2465.63L237.638 2398.17L246.916 2394.44Z",
    fill: "#A2A2A2"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.932 2383.18L302.049 2450.65L292.771 2454.38L265.653 2386.91L274.932 2383.18Z",
    fill: "#A2A2A2"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.948 2371.92L330.065 2439.38L320.786 2443.11L293.669 2375.65L302.948 2371.92Z",
    fill: "#A2A2A2"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.962 2360.66L358.079 2428.12L348.801 2431.85L321.684 2364.39L330.962 2360.66Z",
    fill: "#A2A2A2"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.978 2349.4L386.095 2416.86L376.816 2420.59L349.699 2353.13L358.978 2349.4Z",
    fill: "#A2A2A2"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.994 2338.14L414.111 2405.6L404.832 2409.33L377.715 2341.87L386.994 2338.14Z",
    fill: "#A2A2A2"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.009 2326.87L442.126 2394.34L432.848 2398.07L405.731 2330.6L415.009 2326.87Z",
    fill: "#A2A2A2"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.025 2315.62L470.142 2383.08L460.863 2386.81L433.746 2319.35L443.025 2315.62Z",
    fill: "#A2A2A2"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.04 2304.36L498.157 2371.82L488.879 2375.55L461.762 2308.08L471.04 2304.36Z",
    fill: "#A2A2A2"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.056 2293.09L526.173 2360.56L516.895 2364.29L489.777 2296.82L499.056 2293.09Z",
    fill: "#A2A2A2"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.072 2281.84L554.189 2349.3L544.91 2353.03L517.793 2285.57L527.072 2281.84Z",
    fill: "#A2A2A2"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.087 2270.57L582.204 2338.04L572.926 2341.77L545.809 2274.3L555.087 2270.57Z",
    fill: "#A2A2A2"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.102 2259.31L610.219 2326.78L600.94 2330.51L573.823 2263.04L583.102 2259.31Z",
    fill: "#A2A2A2"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.118 2248.05L638.235 2315.52L628.956 2319.25L601.839 2251.78L611.118 2248.05Z",
    fill: "#A2A2A2"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.133 2236.79L666.25 2304.26L656.972 2307.99L629.855 2240.52L639.133 2236.79Z",
    fill: "#A2A2A2"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.149 2225.53L694.266 2293L684.987 2296.73L657.87 2229.26L667.149 2225.53Z",
    fill: "#A2A2A2"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.164 2214.27L722.281 2281.74L713.003 2285.47L685.886 2218L695.164 2214.27Z",
    fill: "#A2A2A2"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M723.18 2203.01L750.297 2270.48L741.019 2274.21L713.902 2206.74L723.18 2203.01Z",
    fill: "#A2A2A2"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.196 2191.75L778.313 2259.22L769.034 2262.95L741.917 2195.48L751.196 2191.75Z",
    fill: "#A2A2A2"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.211 2180.49L806.328 2247.96L797.05 2251.69L769.933 2184.22L779.211 2180.49Z",
    fill: "#A2A2A2"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M807.226 2169.23L834.343 2236.7L825.064 2240.43L797.947 2172.96L807.226 2169.23Z",
    fill: "#A2A2A2"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.242 2157.97L862.359 2225.43L853.08 2229.16L825.963 2161.7L835.242 2157.97Z",
    fill: "#A2A2A2"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.257 2146.71L890.374 2214.18L881.096 2217.91L853.979 2150.44L863.257 2146.71Z",
    fill: "#A2A2A2"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891.273 2135.45L918.39 2202.92L909.111 2206.64L881.994 2139.18L891.273 2135.45Z",
    fill: "#A2A2A2"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.288 2124.19L946.406 2191.65L937.127 2195.38L910.01 2127.92L919.288 2124.19Z",
    fill: "#A2A2A2"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M947.304 2112.93L974.421 2180.39L965.143 2184.12L938.026 2116.66L947.304 2112.93Z",
    fill: "#A2A2A2"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M975.32 2101.67L1002.44 2169.13L993.158 2172.86L966.041 2105.4L975.32 2101.67Z",
    fill: "#A2A2A2"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.34 2090.41L1030.45 2157.87L1021.17 2161.6L994.057 2094.14L1003.34 2090.41Z",
    fill: "#A2A2A2"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1031.35 2079.14L1058.47 2146.61L1049.19 2150.34L1022.07 2082.87L1031.35 2079.14Z",
    fill: "#A2A2A2"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1130.49 2036.64L1157.6 2104.11L1148.33 2107.84L1121.21 2040.37L1130.49 2036.64Z",
    fill: "#A2A2A2"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.79 2026.07L1183.9 2093.54L1174.63 2097.27L1147.51 2029.8L1156.79 2026.07Z",
    fill: "#A2A2A2"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.09 2013.89L1214.21 2081.36L1204.93 2085.09L1177.81 2017.62L1187.09 2013.89Z",
    fill: "#A2A2A2"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1217.39 2001.71L1244.51 2069.18L1235.23 2072.91L1208.11 2005.44L1217.39 2001.71Z",
    fill: "#A2A2A2"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1243.12 1991.37L1270.24 2058.84L1260.96 2062.57L1233.84 1995.1L1243.12 1991.37Z",
    fill: "#A2A2A2"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.28 1979.65L1299.4 2047.12L1290.12 2050.85L1263 1983.38L1272.28 1979.65Z",
    fill: "#A2A2A2"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1298.01 1969.31L1325.13 2036.77L1315.85 2040.5L1288.73 1973.04L1298.01 1969.31Z",
    fill: "#A2A2A2"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1329.45 1956.67L1356.57 2024.14L1347.29 2027.87L1320.18 1960.4L1329.45 1956.67Z",
    fill: "#A2A2A2"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.75 1946.1L1382.87 2013.57L1373.59 2017.3L1346.48 1949.83L1355.75 1946.1Z",
    fill: "#A2A2A2"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1387.2 1933.46L1414.32 2000.93L1405.04 2004.66L1377.92 1937.19L1387.2 1933.46Z",
    fill: "#A2A2A2"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1413.5 1922.89L1440.62 1990.36L1431.34 1994.09L1404.22 1926.62L1413.5 1922.89Z",
    fill: "#A2A2A2"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1443.23 1910.94L1470.35 1978.41L1461.07 1982.14L1433.95 1914.67L1443.23 1910.94Z",
    fill: "#A2A2A2"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1468.96 1900.6L1496.08 1968.06L1486.8 1971.79L1459.68 1904.33L1468.96 1900.6Z",
    fill: "#A2A2A2"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1497.55 1889.11L1524.66 1956.58L1515.39 1960.3L1488.27 1892.84L1497.55 1889.11Z",
    fill: "#A2A2A2"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1523.85 1878.54L1550.97 1946L1541.69 1949.73L1514.57 1882.27L1523.85 1878.54Z",
    fill: "#A2A2A2"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1555.29 1865.9L1582.41 1933.36L1573.13 1937.09L1546.01 1869.63L1555.29 1865.9Z",
    fill: "#A2A2A2"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1581.59 1855.33L1608.71 1922.79L1599.43 1926.52L1572.32 1859.06L1581.59 1855.33Z",
    fill: "#A2A2A2"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1607.32 1844.98L1634.44 1912.45L1625.16 1916.18L1598.04 1848.71L1607.32 1844.98Z",
    fill: "#A2A2A2"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1638.77 1832.35L1665.89 1899.81L1656.61 1903.54L1629.49 1836.08L1638.77 1832.35Z",
    fill: "#A2A2A2"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1665.64 1821.55L1692.76 1889.01L1683.48 1892.74L1656.36 1825.28L1665.64 1821.55Z",
    fill: "#A2A2A2"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1695.37 1809.59L1722.49 1877.06L1713.21 1880.79L1686.09 1813.32L1695.37 1809.59Z",
    fill: "#A2A2A2"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1722.81 1798.57L1749.93 1866.03L1740.65 1869.76L1713.54 1802.3L1722.81 1798.57Z",
    fill: "#A2A2A2"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1749.12 1787.99L1776.23 1855.46L1766.95 1859.19L1739.84 1791.72L1749.12 1787.99Z",
    fill: "#A2A2A2"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1779.99 1775.59L1807.11 1843.05L1797.83 1846.78L1770.71 1779.32L1779.99 1775.59Z",
    fill: "#A2A2A2"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1806.86 1764.78L1833.98 1832.25L1824.7 1835.98L1797.58 1768.51L1806.86 1764.78Z",
    fill: "#A2A2A2"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1834.88 1753.52L1861.99 1820.99L1852.72 1824.72L1825.6 1757.25L1834.88 1753.52Z",
    fill: "#A2A2A2"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1864.61 1741.57L1891.72 1809.04L1882.45 1812.77L1855.33 1745.3L1864.61 1741.57Z",
    fill: "#A2A2A2"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1890.34 1731.23L1917.45 1798.7L1908.17 1802.43L1881.06 1734.96L1890.34 1731.23Z",
    fill: "#A2A2A2"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1918.35 1719.97L1945.47 1787.44L1936.19 1791.17L1909.07 1723.7L1918.35 1719.97Z",
    fill: "#A2A2A2"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1945.8 1708.94L1972.91 1776.41L1963.63 1780.14L1936.52 1712.67L1945.8 1708.94Z",
    fill: "#A2A2A2"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1975.53 1696.99L2002.64 1764.46L1993.37 1768.19L1966.25 1700.72L1975.53 1696.99Z",
    fill: "#A2A2A2"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2003.54 1685.73L2030.66 1753.2L2021.38 1756.93L1994.26 1689.46L2003.54 1685.73Z",
    fill: "#A2A2A2"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2028.13 1675.85L2055.24 1743.31L2045.97 1747.04L2018.85 1679.58L2028.13 1675.85Z",
    fill: "#A2A2A2"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2061.29 1662.52L2088.41 1729.99L2079.13 1733.71L2052.01 1666.25L2061.29 1662.52Z",
    fill: "#A2A2A2"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2087.59 1651.95L2114.71 1719.42L2105.43 1723.14L2078.31 1655.68L2087.59 1651.95Z",
    fill: "#A2A2A2"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2185.36 1612.65L2212.47 1680.12L2203.2 1683.85L2176.08 1616.38L2185.36 1612.65Z",
    fill: "#A2A2A2"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2214.52 1600.93L2241.63 1668.4L2232.35 1672.13L2205.24 1604.66L2214.52 1600.93Z",
    fill: "#A2A2A2"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2243.68 1589.21L2270.79 1656.68L2261.51 1660.41L2234.4 1592.94L2243.68 1589.21Z",
    fill: "#A2A2A2"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2272.83 1577.49L2299.95 1644.96L2290.67 1648.69L2263.56 1581.22L2272.83 1577.49Z",
    fill: "#A2A2A2"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2300.85 1566.23L2327.97 1633.7L2318.69 1637.43L2291.57 1569.96L2300.85 1566.23Z",
    fill: "#A2A2A2"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2327.15 1555.66L2354.27 1623.13L2344.99 1626.86L2317.87 1559.39L2327.15 1555.66Z",
    fill: "#A2A2A2"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2353.45 1545.09L2380.57 1612.56L2371.29 1616.29L2344.17 1548.82L2353.45 1545.09Z",
    fill: "#A2A2A2"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2379.75 1534.52L2406.87 1601.99L2397.59 1605.71L2370.47 1538.25L2379.75 1534.52Z",
    fill: "#A2A2A2"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2406.62 1523.72L2433.74 1591.18L2424.46 1594.91L2397.34 1527.45L2406.62 1523.72Z",
    fill: "#A2A2A2"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2437.5 1511.31L2464.61 1578.77L2455.33 1582.5L2428.22 1515.04L2437.5 1511.31Z",
    fill: "#A2A2A2"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2468.37 1498.9L2495.49 1566.36L2486.21 1570.09L2459.09 1502.63L2468.37 1498.9Z",
    fill: "#A2A2A2"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2499.25 1486.49L2526.36 1553.95L2517.08 1557.68L2489.97 1490.22L2499.25 1486.49Z",
    fill: "#A2A2A2"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2527.26 1475.23L2554.38 1542.7L2545.1 1546.43L2517.98 1478.96L2527.26 1475.23Z",
    fill: "#A2A2A2"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2555.28 1463.97L2582.39 1531.43L2573.12 1535.16L2546 1467.7L2555.28 1463.97Z",
    fill: "#A2A2A2"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M2664.31 1428.11L2580.55 1461.78L2607.27 1529.07L2691.32 1495.29L2664.31 1428.11Z",
    fill: "#D9D9D9"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2574.07 1458.99L2667.09 1421.61L2697.82 1498.06L2604.47 1535.58L2574.07 1458.99ZM2587.04 1464.56L2610.06 1522.56L2684.81 1492.52L2661.54 1434.61L2587.04 1464.56Z",
    fill: "#A2A2A2"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.108 2196.12L453.357 2222.55L449.628 2213.27L515.379 2186.84L519.108 2196.12Z",
    fill: "#A2A2A2"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.749 2196.2L446.588 2028.27L455.873 2024.56L523.034 2192.48L513.749 2196.2Z",
    fill: "#A2A2A2"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.378 1890.53L510.324 1972.5L446.362 1998.54L458.608 2029.84L385.908 2059.06L379.753 2043.74L477.378 1890.53ZM390.948 2044.78L391.458 2046.05L445.685 2024.25L433.455 1993L497.333 1966.99L475.356 1912.31L390.948 2044.78Z",
    fill: "#A2A2A2"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M749.875 1352.41L772.113 1407.74L708.649 1433.24L719.386 1459.96L645.406 1492.72L639.338 1477.63L749.875 1352.41ZM651.313 1479.17L706.506 1454.73L695.989 1428.56L651.313 1479.17ZM697.366 1427L759.105 1402.19L746.643 1371.18L697.366 1427Z",
    fill: "#A2A2A2"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.934 1047.25L896.71 1101.43L832.674 1127.17L842.285 1151.08L768.971 1180.54L762.002 1163.21L874.934 1047.25ZM773.709 1165.52L774.52 1167.54L829.277 1145.53L819.666 1121.62L883.702 1095.88L871.383 1065.23L773.709 1165.52Z",
    fill: "#A2A2A2"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.37 878.914L1069.46 930.396L1006.04 954.59L1017.93 984.181L946.051 1013.07L936.098 988.308L1051.37 878.914ZM947.91 990.884L951.6 1000.06L1004.92 978.632L992.962 948.875L1056.79 924.524L1047.05 896.796L947.91 990.884Z",
    fill: "#A2A2A2"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1231.92 722.639L1248.12 762.945L1186.39 787.757L1196.92 813.954L1123.59 843.428L1114.66 821.214L1231.92 722.639ZM1126.64 824.207L1129.14 830.42L1183.91 808.405L1174.19 784.231L1126.64 824.207ZM1179.55 779.728L1235.11 757.395L1227.79 739.176L1179.55 779.728Z",
    fill: "#A2A2A2"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1419.4 574.44L1437.21 618.747L1374.32 644.026L1385.23 671.184L1311.06 700.996L1298.73 670.313L1419.4 574.44ZM1310.79 673.503L1316.61 687.988L1372.23 665.635L1361.31 638.477L1424.2 613.198L1415.12 590.611L1310.79 673.503Z",
    fill: "#A2A2A2"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1610.68 440.631L1625.66 477.921L1559.63 504.463L1571 532.765L1498.55 561.887L1484.5 526.937L1610.68 440.631ZM1496.77 530.658L1504.1 548.879L1558 527.215L1546.62 498.914L1612.66 472.371L1606.04 455.917L1496.77 530.658Z",
    fill: "#A2A2A2"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1809.28 322.581L1825.89 363.904L1687.4 419.569L1677.56 395.098L1809.28 322.581ZM1690.14 399.587L1692.95 406.561L1812.88 358.355L1804.21 336.786L1690.14 399.587Z",
    fill: "#A2A2A2"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2014.74 223.246L2026.35 252.119L1886.71 308.244L1876.95 283.964L2014.74 223.246ZM1889.84 289.213L1892.26 295.236L2013.34 246.57L2009.32 236.564L1889.84 289.213Z",
    fill: "#A2A2A2"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.027 2431.42L12.4454 2467.43L48.4514 2557.01L138.033 2521L102.027 2431.42ZM0.738281 2462.43L43.4571 2568.72L149.74 2526L107.021 2419.71L0.738281 2462.43Z",
    fill: "#A2A2A2"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2111.35 1717.85L1381.51 2011.2L1377.78 2001.92L2107.62 1708.58L2111.35 1717.85Z",
    fill: "#A2A2A2"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.06 2107.1L2119.88 1713.28L2127.74 1732.85L1432.66 2012.23L1158.91 2154.01L1140.06 2107.1ZM1153.07 2112.65L1164.09 2140.07L1428.48 2003.13L2114.73 1727.3L2114.33 1726.29L1153.07 2112.65Z",
    fill: "#A2A2A2"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2603.05 1518.55L2201.87 1681.14L2198.11 1671.87L2599.3 1509.28L2603.05 1518.55Z",
    fill: "#A2A2A2"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2725.82 1484.49L2206.68 1693.15L2202.95 1683.87L2722.09 1475.21L2725.82 1484.49Z",
    fill: "#A2A2A2"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2232.47 279.359C2240.96 275.947 2245.08 266.299 2241.67 257.809C2238.25 249.319 2228.61 245.203 2220.12 248.616C2211.63 252.028 2207.51 261.676 2210.92 270.166C2214.33 278.656 2223.98 282.772 2232.47 279.359ZM2234.34 283.999C2245.39 279.556 2250.75 266.996 2246.31 255.944C2241.86 244.892 2229.3 239.534 2218.25 243.976C2207.2 248.418 2201.84 260.979 2206.28 272.031C2210.73 283.082 2223.29 288.441 2234.34 283.999Z",
    fill: "#A2A2A2"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2232.47 279.359C2240.96 275.947 2245.08 266.299 2241.67 257.809C2238.25 249.319 2228.61 245.203 2220.12 248.616C2211.63 252.028 2207.51 261.676 2210.92 270.166C2214.33 278.656 2223.98 282.772 2232.47 279.359ZM2234.34 283.999C2245.39 279.556 2250.75 266.996 2246.31 255.944C2241.86 244.892 2229.3 239.534 2218.25 243.976C2207.2 248.418 2201.84 260.979 2206.28 272.031C2210.73 283.082 2223.29 288.441 2234.34 283.999Z",
    fill: "#A2A2A2"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2266.94 365.121C2275.43 361.709 2279.55 352.06 2276.14 343.571C2272.72 335.081 2263.08 330.965 2254.59 334.377C2246.1 337.79 2241.98 347.438 2245.39 355.928C2248.81 364.417 2258.45 368.533 2266.94 365.121ZM2268.81 369.76C2279.86 365.318 2285.22 352.758 2280.78 341.706C2276.33 330.654 2263.77 325.296 2252.72 329.738C2241.67 334.18 2236.31 346.741 2240.75 357.792C2245.2 368.844 2257.76 374.202 2268.81 369.76Z",
    fill: "#A2A2A2"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2301.41 450.883C2309.9 447.47 2314.02 437.822 2310.61 429.332C2307.2 420.843 2297.55 416.727 2289.06 420.139C2280.57 423.551 2276.45 433.2 2279.86 441.689C2283.28 450.179 2292.92 454.295 2301.41 450.883ZM2303.28 455.522C2314.33 451.08 2319.69 438.519 2315.25 427.468C2310.8 416.416 2298.24 411.058 2287.19 415.5C2276.14 419.942 2270.78 432.502 2275.22 443.554C2279.67 454.606 2292.23 459.964 2303.28 455.522Z",
    fill: "#A2A2A2"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2335.89 536.644C2344.38 533.232 2348.49 523.584 2345.08 515.094C2341.67 506.604 2332.02 502.488 2323.53 505.901C2315.04 509.313 2310.92 518.961 2314.34 527.451C2317.75 535.941 2327.4 540.057 2335.89 536.644ZM2337.75 541.284C2348.8 536.842 2354.16 524.281 2349.72 513.229C2345.28 502.178 2332.72 496.819 2321.66 501.261C2310.61 505.704 2305.25 518.264 2309.7 529.316C2314.14 540.368 2326.7 545.726 2337.75 541.284Z",
    fill: "#A2A2A2"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2370.36 622.406C2378.85 618.994 2382.96 609.345 2379.55 600.856C2376.14 592.366 2366.49 588.25 2358 591.662C2349.51 595.075 2345.39 604.723 2348.81 613.213C2352.22 621.702 2361.87 625.818 2370.36 622.406ZM2372.22 627.045C2383.27 622.603 2388.63 610.043 2384.19 598.991C2379.75 587.939 2367.19 582.581 2356.14 587.023C2345.08 591.465 2339.73 604.026 2344.17 615.077C2348.61 626.129 2361.17 631.488 2372.22 627.045Z",
    fill: "#A2A2A2"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2404.83 708.168C2413.32 704.756 2417.43 695.107 2414.02 686.618C2410.61 678.128 2400.96 674.012 2392.47 677.424C2383.98 680.837 2379.86 690.485 2383.28 698.975C2386.69 707.464 2396.34 711.58 2404.83 708.168ZM2406.69 712.807C2417.74 708.365 2423.1 695.805 2418.66 684.753C2414.22 673.701 2401.66 668.343 2390.61 672.785C2379.55 677.227 2374.2 689.787 2378.64 700.839C2383.08 711.891 2395.64 717.249 2406.69 712.807Z",
    fill: "#A2A2A2"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2437 788.215C2445.49 784.802 2449.61 775.154 2446.19 766.664C2442.78 758.175 2433.13 754.059 2424.64 757.471C2416.15 760.883 2412.04 770.532 2415.45 779.021C2418.86 787.511 2428.51 791.627 2437 788.215ZM2438.87 792.854C2449.92 788.412 2455.28 775.852 2450.83 764.8C2446.39 753.748 2433.83 748.39 2422.78 752.832C2411.73 757.274 2406.37 769.834 2410.81 780.886C2415.25 791.938 2427.81 797.296 2438.87 792.854Z",
    fill: "#A2A2A2"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2469.4 868.832C2477.89 865.42 2482.01 855.771 2478.6 847.282C2475.18 838.792 2465.54 834.676 2457.05 838.088C2448.56 841.501 2444.44 851.149 2447.85 859.639C2451.26 868.128 2460.91 872.244 2469.4 868.832ZM2471.27 873.471C2482.32 869.029 2487.68 856.469 2483.24 845.417C2478.79 834.365 2466.23 829.007 2455.18 833.449C2444.13 837.891 2438.77 850.451 2443.21 861.503C2447.66 872.555 2460.22 877.913 2471.27 873.471Z",
    fill: "#A2A2A2"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2503.18 952.875C2511.67 949.463 2515.79 939.814 2512.38 931.325C2508.96 922.835 2499.32 918.719 2490.83 922.131C2482.34 925.544 2478.22 935.192 2481.63 943.682C2485.05 952.171 2494.69 956.287 2503.18 952.875ZM2505.05 957.514C2516.1 953.072 2521.46 940.512 2517.02 929.46C2512.57 918.408 2500.01 913.05 2488.96 917.492C2477.91 921.934 2472.55 934.494 2476.99 945.546C2481.44 956.598 2494 961.956 2505.05 957.514Z",
    fill: "#A2A2A2"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2571.89 1123.83C2580.38 1120.42 2584.5 1110.77 2581.09 1102.28C2577.68 1093.79 2568.03 1089.67 2559.54 1093.08C2551.05 1096.5 2546.93 1106.15 2550.34 1114.63C2553.76 1123.12 2563.41 1127.24 2571.89 1123.83ZM2573.76 1128.47C2584.81 1124.03 2590.17 1111.46 2585.73 1100.41C2581.29 1089.36 2568.73 1084 2557.67 1088.45C2546.62 1092.89 2541.26 1105.45 2545.71 1116.5C2550.15 1127.55 2562.71 1132.91 2573.76 1128.47Z",
    fill: "#A2A2A2"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2605.68 1207.87C2614.17 1204.46 2618.28 1194.81 2614.87 1186.32C2611.46 1177.83 2601.81 1173.72 2593.32 1177.13C2584.83 1180.54 2580.71 1190.19 2584.13 1198.68C2587.54 1207.17 2597.19 1211.29 2605.68 1207.87ZM2607.54 1212.51C2618.59 1208.07 2623.95 1195.51 2619.51 1184.46C2615.07 1173.41 2602.51 1168.05 2591.46 1172.49C2580.4 1176.93 2575.05 1189.49 2579.49 1200.55C2583.93 1211.6 2596.49 1216.96 2607.54 1212.51Z",
    fill: "#A2A2A2"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2639.46 1291.92C2647.95 1288.51 2652.06 1278.86 2648.65 1270.37C2645.24 1261.88 2635.59 1257.77 2627.1 1261.18C2618.61 1264.59 2614.5 1274.24 2617.91 1282.73C2621.32 1291.22 2630.97 1295.33 2639.46 1291.92ZM2641.32 1296.56C2652.37 1292.12 2657.73 1279.56 2653.29 1268.51C2648.85 1257.45 2636.29 1252.1 2625.24 1256.54C2614.18 1260.98 2608.83 1273.54 2613.27 1284.59C2617.71 1295.64 2630.27 1301 2641.32 1296.56Z",
    fill: "#A2A2A2"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2673.24 1375.97C2681.73 1372.56 2685.85 1362.91 2682.43 1354.42C2679.02 1345.93 2669.37 1341.81 2660.88 1345.22C2652.39 1348.64 2648.28 1358.29 2651.69 1366.78C2655.1 1375.26 2664.75 1379.38 2673.24 1375.97ZM2675.1 1380.61C2686.16 1376.17 2691.51 1363.61 2687.07 1352.55C2682.63 1341.5 2670.07 1336.14 2659.02 1340.59C2647.97 1345.03 2642.61 1357.59 2647.05 1368.64C2651.49 1379.69 2664.05 1385.05 2675.1 1380.61Z",
    fill: "#A2A2A2"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2707.02 1460.02C2715.51 1456.6 2719.63 1446.95 2716.21 1438.47C2712.8 1429.98 2703.15 1425.86 2694.66 1429.27C2686.17 1432.68 2682.06 1442.33 2685.47 1450.82C2688.88 1459.31 2698.53 1463.43 2707.02 1460.02ZM2708.89 1464.65C2719.94 1460.21 2725.3 1447.65 2720.85 1436.6C2716.41 1425.55 2703.85 1420.19 2692.8 1424.63C2681.75 1429.07 2676.39 1441.64 2680.83 1452.69C2685.27 1463.74 2697.83 1469.1 2708.89 1464.65Z",
    fill: "#A2A2A2"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2111.8 191.172C2108.85 192.356 2106.33 194.401 2104.56 197.04C2101.67 201.374 2101.1 206.858 2103.04 211.695L2103.45 212.714L2168.34 186.631L2693.1 1492.21L2719.59 1481.56C2720.87 1481.05 2721.49 1479.59 2720.98 1478.31L2201.75 186.504C2201.25 185.248 2200.41 184.153 2199.34 183.334L2198.45 182.659C2190.09 176.29 2180.35 171.963 2170.02 170.022L2168.35 169.709C2166.95 169.445 2165.5 169.588 2164.17 170.121L2111.8 191.172ZM2100.41 194.261C2102.73 190.785 2106.05 188.092 2109.93 186.532L2162.3 165.482C2164.51 164.593 2166.93 164.355 2169.27 164.795L2170.94 165.108C2182.04 167.193 2192.5 171.84 2201.48 178.681L2202.37 179.355C2204.16 180.721 2205.55 182.547 2206.39 184.639L2725.62 1476.45C2727.16 1480.29 2725.3 1484.66 2721.46 1486.2L2690.33 1498.71L2165.57 193.135L2100.68 219.217L2098.4 213.56C2095.84 207.19 2096.59 199.967 2100.41 194.261Z",
    fill: "#A2A2A2"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2136.32 140.587C2138.87 141.659 2140.06 144.591 2138.99 147.136L2121.33 189.102C2120.26 191.647 2117.32 192.842 2114.78 191.771C2112.23 190.699 2111.04 187.768 2112.11 185.222L2129.78 143.256C2130.85 140.711 2133.78 139.516 2136.32 140.587Z",
    fill: "#A2A2A2"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2078.23 100.845C2077.14 103.38 2078.3 106.323 2080.84 107.418L2122.63 125.485C2125.17 126.581 2128.11 125.414 2129.21 122.88C2130.3 120.345 2129.14 117.402 2126.6 116.306L2084.81 98.2393C2082.27 97.1436 2079.33 98.3102 2078.23 100.845Z",
    fill: "#A2A2A2"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.901 2283.14L76.1957 2366.96L67.0355 2362.95L103.741 2279.13L112.901 2283.14Z",
    fill: "#A2A2A2"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.527 1850.1C323.525 1847.92 325.934 1846.75 328.266 1847.33L394.946 1863.69C396.417 1864.05 397.645 1865.06 398.286 1866.44C398.926 1867.81 398.909 1869.4 398.24 1870.76L380.507 1906.77C379.873 1908.06 378.716 1909.01 377.332 1909.39C375.947 1909.77 374.467 1909.53 373.269 1908.74L317.253 1871.82C315.195 1870.46 314.433 1867.8 315.458 1865.56L322.527 1850.1ZM329.9 1858.02L326.334 1865.82L374.039 1897.27L386.52 1871.92L329.9 1858.02Z",
    fill: "#A2A2A2"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.173 1821.86C327.193 1819.56 328.782 1817.57 331.022 1817.04L393.188 1802.35C394.635 1802.01 396.159 1802.33 397.346 1803.22C398.533 1804.11 399.261 1805.49 399.333 1806.98L400.815 1837.93C400.89 1839.51 400.21 1841.04 398.981 1842.04C397.752 1843.04 396.12 1843.4 394.583 1843.01L330.935 1826.75C328.705 1826.18 327.152 1824.16 327.173 1821.86ZM353.114 1822.1L390.502 1831.65L389.632 1813.46L353.114 1822.1Z",
    fill: "#A2A2A2"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.518 1637.46C338.23 1635.9 340.784 1635.73 342.695 1637.03L394.818 1672.53C396.454 1673.64 397.278 1675.61 396.922 1677.56L394.427 1691.18C394.031 1693.35 392.264 1695 390.077 1695.25L313.884 1703.96C311.289 1704.25 308.903 1702.5 308.407 1699.94C305.864 1686.78 310.461 1673.49 316.569 1662.67C322.725 1651.76 330.832 1642.63 336.518 1637.46ZM317.713 1693.45L385.259 1685.73L386.499 1678.96L340.423 1647.58C335.704 1652.37 329.866 1659.46 325.277 1667.58C320.535 1675.98 317.419 1684.97 317.713 1693.45Z",
    fill: "#A2A2A2"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.52 1723.16L318.691 1737L316.633 1727.21L382.462 1713.37L384.52 1723.16Z",
    fill: "#A2A2A2"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.035 1754.59L322.089 1766.49L320.314 1756.65L386.26 1744.75L388.035 1754.59Z",
    fill: "#A2A2A2"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.8 1782.78L324.77 1795.31L322.879 1785.49L387.909 1772.96L389.8 1782.78Z",
    fill: "#A2A2A2"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.749 1656.57L352.395 1621.3L357.838 1612.91L412.192 1648.18L406.749 1656.57Z",
    fill: "#A2A2A2"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.346 1632.53L366.068 1594.93L371.424 1586.48L430.702 1624.09L425.346 1632.53Z",
    fill: "#A2A2A2"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.922 1605.89L384.686 1572.57L389.921 1564.05L444.157 1597.37L438.922 1605.89Z",
    fill: "#A2A2A2"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.507 1581.3L402.721 1544.94L408.18 1536.57L463.966 1572.92L458.507 1581.3Z",
    fill: "#A2A2A2"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.363 1555.73L424.296 1519.54L430.003 1511.33L482.07 1547.51L476.363 1555.73Z",
    fill: "#A2A2A2"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.76 1531.43L445.273 1496.72L451.173 1488.65L498.661 1523.35L492.76 1531.43Z",
    fill: "#A2A2A2"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.329 1507.98L458.523 1473.27L464.163 1465.02L514.969 1499.72L509.329 1507.98Z",
    fill: "#A2A2A2"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.694 1435.57L534.898 1472.05L528.783 1479.97L481.579 1443.49L487.694 1435.57Z",
    fill: "#A2A2A2"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.658 1402.24L558.979 1450.67L552.46 1458.25L496.139 1409.83L502.658 1402.24Z",
    fill: "#A2A2A2"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.918 1374.05L578.158 1424.76L571.527 1432.25L514.287 1381.54L520.918 1374.05Z",
    fill: "#A2A2A2"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.144 1357.6L596.308 1401.45L589.8 1409.05L538.636 1365.19L545.144 1357.6Z",
    fill: "#A2A2A2"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.821 1341.22L616.051 1379.37L609.347 1386.79L567.118 1348.64L573.821 1341.22Z",
    fill: "#A2A2A2"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.327 1315.43C579.153 1313.42 581.183 1312.17 583.35 1312.35L648.867 1317.56C650.491 1317.69 651.949 1318.6 652.777 1320C653.605 1321.4 653.697 1323.12 653.026 1324.6L636.666 1360.73C636.02 1362.16 634.744 1363.2 633.218 1363.55C631.691 1363.89 630.091 1363.5 628.893 1362.5L579.735 1321.16C578.071 1319.76 577.502 1317.44 578.327 1315.43ZM598.121 1323.55L630.278 1350.6L640.981 1326.96L598.121 1323.55Z",
    fill: "#A2A2A2"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.095 1269.72C579.543 1267.09 581.176 1264.49 583.789 1263.84L648.127 1247.94C649.541 1247.59 651.036 1247.88 652.223 1248.72C653.41 1249.57 654.17 1250.88 654.305 1252.33L658.208 1294.26C658.354 1295.83 657.758 1297.37 656.598 1298.42C655.439 1299.48 653.851 1299.93 652.309 1299.64L586.951 1287.39C584.961 1287.02 583.393 1285.48 582.978 1283.5L580.095 1269.72ZM590.87 1272.39L592.081 1278.18L647.637 1288.59L644.887 1259.05L590.87 1272.39Z",
    fill: "#A2A2A2"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.529 1228.02L577.911 1247.35L575.045 1237.77L639.663 1218.44L642.529 1228.02Z",
    fill: "#A2A2A2"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M599.072 1117.11L645.376 1162.92C646.779 1164.31 647.234 1166.39 646.538 1168.24L635.773 1196.8C635.193 1198.34 633.894 1199.5 632.298 1199.89L571.906 1214.87L569.499 1205.16L627.342 1190.82L636.037 1167.75L592.039 1124.22L599.072 1117.11Z",
    fill: "#A2A2A2"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.9 1145.94L619.734 1108.82L626.707 1101.65L664.873 1138.77L657.9 1145.94Z",
    fill: "#A2A2A2"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M678.675 1121.64L642.572 1086.34L649.563 1079.19L685.666 1114.49L678.675 1121.64Z",
    fill: "#A2A2A2"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.035 1098.78L663.932 1063.48L670.922 1056.33L707.025 1091.63L700.035 1098.78Z",
    fill: "#A2A2A2"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.13 1072.77L684.027 1037.47L691.018 1030.32L727.121 1065.62L720.13 1072.77Z",
    fill: "#A2A2A2"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.524 1052.48L706.421 1017.18L713.412 1010.03L749.515 1045.33L742.524 1052.48Z",
    fill: "#A2A2A2"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M765.26 1031.39L729.157 996.088L736.148 988.938L772.251 1024.24L765.26 1031.39Z",
    fill: "#A2A2A2"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M786.846 1007.43L750.743 972.135L757.734 964.985L793.837 1000.28L786.846 1007.43Z",
    fill: "#A2A2A2"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.663 984.054L772.56 948.756L779.55 941.606L815.653 976.903L808.663 984.054Z",
    fill: "#A2A2A2"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M832.429 963.874L796.326 928.577L803.317 921.426L839.42 956.724L832.429 963.874Z",
    fill: "#A2A2A2"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.476 941.069L818.373 905.772L825.364 898.622L861.467 933.919L854.476 941.069Z",
    fill: "#A2A2A2"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M878.012 920.319L841.909 885.022L848.9 877.872L885.003 913.169L878.012 920.319Z",
    fill: "#A2A2A2"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.861 897.851L864.758 862.553L871.749 855.403L907.852 890.7L900.861 897.851Z",
    fill: "#A2A2A2"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.645 874.669L888.547 839.422L895.94 832.689L928.038 867.935L920.645 874.669Z",
    fill: "#A2A2A2"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M943.664 854.363L911.793 818.029L919.311 811.435L951.182 847.769L943.664 854.363Z",
    fill: "#A2A2A2"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.083 831.668L935.212 795.334L942.73 788.739L974.601 825.073L967.083 831.668Z",
    fill: "#A2A2A2"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.421 811.261L959.55 774.927L967.067 768.333L998.938 804.667L991.421 811.261Z",
    fill: "#A2A2A2"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1012.9 788.683L981.025 752.349L988.543 745.755L1020.41 782.089L1012.9 788.683Z",
    fill: "#A2A2A2"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1037.23 768.273L1005.36 731.939L1012.88 725.345L1044.75 761.679L1037.23 768.273Z",
    fill: "#A2A2A2"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.57 747.867L1029.7 711.533L1037.22 704.938L1069.09 741.273L1061.57 747.867Z",
    fill: "#A2A2A2"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1084.2 728.148L1052.33 691.814L1059.84 685.22L1091.71 721.554L1084.2 728.148Z",
    fill: "#A2A2A2"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1108.53 707.738L1076.66 671.404L1084.18 664.81L1116.05 701.144L1108.53 707.738Z",
    fill: "#A2A2A2"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.25 687.441L1102.38 651.107L1109.89 644.513L1141.76 680.847L1134.25 687.441Z",
    fill: "#A2A2A2"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1157.04 664.914L1125.51 627.778L1133.14 621.306L1164.66 658.441L1157.04 664.914Z",
    fill: "#A2A2A2"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.5 646.453L1149.97 609.317L1157.59 602.845L1189.12 639.981L1181.5 646.453Z",
    fill: "#A2A2A2"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.55 622.19L1173.57 585.62L1181.51 579.543L1209.49 616.113L1201.55 622.19Z",
    fill: "#A2A2A2"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.06 603.846L1196.08 567.276L1204.02 561.2L1232 597.769L1224.06 603.846Z",
    fill: "#A2A2A2"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1251.27 585.608L1223.29 549.038L1231.23 542.961L1259.21 579.531L1251.27 585.608Z",
    fill: "#A2A2A2"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.4 562.221L1248.42 525.651L1256.36 519.575L1284.34 556.144L1276.4 562.221Z",
    fill: "#A2A2A2"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1299.6 545.592L1271.62 509.022L1279.56 502.946L1307.54 539.515L1299.6 545.592Z",
    fill: "#A2A2A2"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1325.66 524.494L1297.67 487.925L1305.62 481.848L1333.6 518.418L1325.66 524.494Z",
    fill: "#A2A2A2"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1349.25 504.838L1325.22 470.664L1333.4 464.912L1357.43 499.086L1349.25 504.838Z",
    fill: "#A2A2A2"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1375.31 487.06L1351.28 452.887L1359.46 447.135L1383.49 481.308L1375.31 487.06Z",
    fill: "#A2A2A2"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1399.76 468.595L1375.73 434.422L1383.91 428.67L1407.94 462.843L1399.76 468.595Z",
    fill: "#A2A2A2"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1425.13 449.103L1401.1 414.93L1409.28 409.178L1433.31 443.351L1425.13 449.103Z",
    fill: "#A2A2A2"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1450.73 430.181L1426.7 396.008L1434.88 390.256L1458.91 424.429L1450.73 430.181Z",
    fill: "#A2A2A2"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1476.1 410.685L1452.07 376.512L1460.25 370.76L1484.28 404.933L1476.1 410.685Z",
    fill: "#A2A2A2"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1499.18 389.685L1477.85 358.082L1486.14 352.487L1507.47 384.09L1499.18 389.685Z",
    fill: "#A2A2A2"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1527.7 377.2L1501.83 338.453L1510.15 332.901L1536.02 371.648L1527.7 377.2Z",
    fill: "#A2A2A2"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1554.19 360.515L1529.87 323.139L1538.25 317.685L1562.57 355.061L1554.19 360.515Z",
    fill: "#A2A2A2"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1580.63 344.538L1555.74 305.732L1564.15 300.333L1589.05 339.139L1580.63 344.538Z",
    fill: "#A2A2A2"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1607.92 328.198L1582.85 288.133L1591.33 282.829L1616.4 322.893L1607.92 328.198Z",
    fill: "#A2A2A2"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1634.04 312.272L1608.63 269.691L1617.21 264.566L1642.63 307.147L1634.04 312.272Z",
    fill: "#A2A2A2"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1661.16 296.324L1637.29 255.114L1645.94 250.102L1669.81 291.312L1661.16 296.324Z",
    fill: "#A2A2A2"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1688.65 280.407L1664.15 240.113L1672.7 234.918L1697.2 275.213L1688.65 280.407Z",
    fill: "#A2A2A2"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1713.76 266.12L1690.86 224.85L1699.6 219.999L1722.5 261.268L1713.76 266.12Z",
    fill: "#A2A2A2"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1741.19 252.617L1719.09 210.03L1727.97 205.425L1750.06 248.011L1741.19 252.617Z",
    fill: "#A2A2A2"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1769.9 238.17L1749 192.778L1758.08 188.595L1778.98 233.988L1769.9 238.17Z",
    fill: "#A2A2A2"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1798.05 226.443L1776.34 177.39L1785.49 173.343L1807.2 222.396L1798.05 226.443Z",
    fill: "#A2A2A2"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1825.82 212.106L1805.72 162.078L1815 158.349L1835.1 208.376L1825.82 212.106Z",
    fill: "#A2A2A2"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1854.83 199.992L1832.38 149.911L1841.5 145.82L1863.96 195.901L1854.83 199.992Z",
    fill: "#A2A2A2"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1882.82 186.205L1861.91 134.176L1871.19 130.446L1892.1 182.475L1882.82 186.205Z",
    fill: "#A2A2A2"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1911.45 174.816L1889.4 123.247L1898.59 119.314L1920.65 170.884L1911.45 174.816Z",
    fill: "#A2A2A2"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1939.55 162.106L1917.54 108.191L1926.8 104.413L1948.81 158.328L1939.55 162.106Z",
    fill: "#A2A2A2"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1969.01 150.321L1946.32 96.3496L1955.54 92.4742L1978.23 146.445L1969.01 150.321Z",
    fill: "#A2A2A2"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1996.25 137.957L1973.73 81.9258L1983.01 78.1964L2005.53 134.227L1996.25 137.957Z",
    fill: "#A2A2A2"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2028.27 125.09L2005.06 67.3438L2014.34 63.6144L2037.55 121.361L2028.27 125.09Z",
    fill: "#A2A2A2"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1524.02 328.763C1641.44 259.741 1909.19 110.898 2043.43 65.9314L2040.26 56.4492C1904.82 101.817 1636.07 251.295 1518.88 320.184C1518.84 320.211 1518.79 320.239 1518.75 320.267C1161.43 546.106 758.749 952.328 602.089 1127.15L609.536 1133.83C766 959.221 1167.91 553.863 1524.02 328.763Z",
    fill: "#A2A2A2"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2128.23 9.27857L2037.33 45.8176L2033.6 36.5391L2124.5 9.2811e-06L2128.23 9.27857Z",
    fill: "#A2A2A2"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M2037.37 120.867L2018.87 74.8672L2039.87 66.3672L2059.37 112.367L2037.37 120.867Z",
    fill: "#6CDD59"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2040.13 65.7188L2060.03 112.647L2037.09 121.511L2018.21 74.5905L2040.13 65.7188ZM2019.51 75.1431L2037.64 120.223L2058.7 112.086L2039.6 67.0148L2019.51 75.1431Z",
    fill: "#6CDD59"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M1946.37 158.367L1927.87 112.367L1948.87 103.867L1968.37 149.867L1946.37 158.367Z",
    fill: "#6CDD59"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1949.13 103.219L1969.03 150.147L1946.09 159.011L1927.21 112.09L1949.13 103.219ZM1928.51 112.643L1946.64 157.723L1967.7 149.586L1948.6 104.515L1928.51 112.643Z",
    fill: "#6CDD59"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M1750.37 247.867L1731.87 212.868L1752.87 201.867L1769.87 238.367L1750.37 247.867Z",
    fill: "#6CDD59"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1753.1 201.182L1770.53 238.602L1750.15 248.529L1731.19 212.658L1753.1 201.182ZM1732.54 213.078L1750.58 247.207L1769.2 238.134L1752.63 202.554L1732.54 213.078Z",
    fill: "#6CDD59"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M1722.37 260.865L1704.37 227.865L1722.87 217.365L1740.87 252.365L1722.37 260.865Z",
    fill: "#6CDD59"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1723.07 216.673L1741.55 252.602L1722.15 261.515L1703.69 227.673L1723.07 216.673ZM1705.04 228.058L1722.58 260.217L1740.18 252.13L1722.66 218.058L1705.04 228.058Z",
    fill: "#6CDD59"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.37 424.867L1434.87 390.367L1452.37 376.367L1476.37 410.867L1458.37 424.867Z",
    fill: "#FF1717"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.37 442.867L1409.87 409.367L1426.87 396.367L1450.87 430.211L1433.37 442.867Z",
    fill: "#6CDD59"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.37 481.367L1359.37 447.367L1375.87 434.367L1399.87 468.867L1383.37 481.367Z",
    fill: "#6CDD59"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.37 518.367L1305.87 482.867L1323.87 468.867L1349.87 504.367L1333.37 518.367Z",
    fill: "#6CDD59"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.37 498.867L1333.87 465.367L1351.37 452.867L1375.37 486.867L1357.37 498.867Z",
    fill: "#6CDD59"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.37 539.367L1279.87 503.367L1298.37 488.867L1325.37 523.867L1307.37 539.367Z",
    fill: "#6CDD59"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.87 762.367L1015.37 728.367L1031.87 713.367L1061.87 747.367L1044.87 762.367Z",
    fill: "#6CDD59"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.37 782.367L991.865 749.867L1008.19 734.867L1037.37 768.367L1020.37 782.367Z",
    fill: "#6CDD59"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M950.865 847.867L922.365 814.867L938.865 799.367L967.365 831.367L950.865 847.867Z",
    fill: "#6CDD59"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M927.365 870.367L898.865 837.367L915.365 821.867L943.865 853.867L927.365 870.367Z",
    fill: "#6CDD59"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M884.865 913.367L851.865 881.367L868.365 865.867L900.865 897.867L884.865 913.367Z",
    fill: "#6CDD59"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M838.865 956.367L805.865 924.367L822.365 908.867L854.865 940.867L838.865 956.367Z",
    fill: "#6CDD59"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M816.518 977.867L784.865 947.551L800.692 932.867L831.865 963.183L816.518 977.867Z",
    fill: "#FF1717"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M749.365 1045.37L718.865 1015.55L734.692 1000.87L765.365 1031.37L749.365 1045.37Z",
    fill: "#6CDD59"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M726.365 1065.37L695.865 1035.55L711.692 1020.87L742.365 1051.37L726.365 1065.37Z",
    fill: "#6CDD59"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M706.365 1091.37L675.865 1061.55L691.365 1044.87L720.365 1072.87L706.365 1091.37Z",
    fill: "#6CDD59"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M576.865 1237.87L571.865 1214.87L633.865 1199.37L638.365 1219.87L576.865 1237.87Z",
    fill: "#6CDD59"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M508.811 1409.67L523.364 1389.37L571.865 1432.37L558.865 1450.87L508.811 1409.67Z",
    fill: "#6CDD59"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M529.365 1479.87L482.865 1444.37L466.865 1467.37L514.865 1499.87L529.365 1479.87Z",
    fill: "#6CDD59"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M327.865 1784.87L324.865 1765.87L384.365 1755.37L387.365 1773.37L327.865 1784.87Z",
    fill: "#6CDD59"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M330.365 1975.37L277.365 1945.87L288.865 1926.87L342.365 1955.37L330.365 1975.37Z",
    fill: "#6CDD59"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M1887.87 306.078L1952.25 278.868L1960.73 298.923L1896.34 326.133L1887.87 306.078Z",
    fill: "#EEEEEE"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M1897.87 334.078L1962.25 306.868L1970.73 326.923L1906.34 354.133L1897.87 334.078Z",
    fill: "#EEEEEE"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M1956.37 474.365L2019.25 447.865L2027.73 467.92L1963.87 493.365L1956.37 474.365Z",
    fill: "#6CDD59"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M1978.36 530.365L2042.25 503.865L2050.73 523.92L1986.37 549.365L1978.36 530.365Z",
    fill: "#EEEEEE"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M1932.87 418.078L1997.25 390.868L2005.73 410.923L1941.34 438.133L1932.87 418.078Z",
    fill: "#6CDD59"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M1989.34 557.453L2053.37 532.367L2060.87 551.367L1997.82 577.508L1989.34 557.453Z",
    fill: "#6CDD59"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M1961.35 277.873L2026.37 251.867L2030.69 270.091L1968.37 295.367L1961.35 277.873Z",
    fill: "#6CDD59"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M2016.87 416.684L2079.39 389.559L2087.37 410.865L2025.53 436.657L2016.87 416.684Z",
    fill: "#6CDD59"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M1970.87 304.504L2034.77 279.311L2042.75 299.566L1978.85 324.759L1970.87 304.504Z",
    fill: "#EEEEEE"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M2027.87 444.504L2091.08 419.582L2099.07 439.837L2035.85 464.759L2027.87 444.504Z",
    fill: "#6CDD59"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M1982.87 332.503L2045.87 307.365L2053.37 326.365L1990.85 352.758L1982.87 332.503Z",
    fill: "#6CDD59"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M1992.87 360.504L2056.87 335.366L2064.87 354.366L2000.85 380.759L1992.87 360.504Z",
    fill: "#6CDD59"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M2005.87 388.506L2068.37 363.368L2075.87 382.368L2013.85 408.761L2005.87 388.506Z",
    fill: "#6CDD59"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M2000.87 586.078L2065.25 558.868L2073.73 578.923L2009.34 606.133L2000.87 586.078Z",
    fill: "#D7D8D7"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M2057.05 726.578L2120.25 699.869L2128.73 719.924L2065.53 746.633L2057.05 726.578Z",
    fill: "#6CDD59"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M2012.37 614.369L2075.87 588.869L2083.89 607.856L2019.89 633.439L2012.37 614.369Z",
    fill: "#6CDD59"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M2068.9 754.641L2132.25 727.866L2140.73 747.921L2077.37 774.695L2068.9 754.641Z",
    fill: "#6CDD59"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M2023.86 642.367L2086.9 616.649L2094.79 635.318L2031.36 661.867L2023.86 642.367Z",
    fill: "#6CDD59"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M2034.87 670.368L2098.25 644.868L2106.73 664.923L2043.37 691.698L2034.87 670.368Z",
    fill: "#EEEEEE"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M2091.54 811.473L2155.46 785.108L2163.76 805.236L2099.84 831.6L2091.54 811.473Z",
    fill: "#EEEEEE"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M2073.81 557.141L2135.64 531.413L2144 551.514L2082.18 577.242L2073.81 557.141Z",
    fill: "#EEEEEE"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M2128.87 699.688L2192.99 671.869L2201.66 691.842L2137.53 719.661L2128.87 699.688Z",
    fill: "#EEEEEE"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M2084.87 584.504L2147.66 559.75L2155.64 580.005L2092.85 604.759L2084.87 584.504Z",
    fill: "#6CDD59"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M2138.87 725.508L2203.9 699.87L2211.88 720.125L2146.85 745.763L2138.87 725.508Z",
    fill: "#EEEEEE"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M2095.87 611.508L2158.57 586.788L2166.55 607.043L2103.85 631.763L2095.87 611.508Z",
    fill: "#EEEEEE"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M2150.87 753.508L2215.9 727.87L2223.88 748.125L2158.85 773.763L2150.87 753.508Z",
    fill: "#6CDD59"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M2106.87 640.504L2169.99 615.617L2177.98 635.871L2114.85 660.759L2106.87 640.504Z",
    fill: "#EEEEEE"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M2160.87 781.508L2225.9 755.87L2233.88 776.125L2168.85 801.763L2160.87 781.508Z",
    fill: "#6CDD59"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M2118.86 669.868L2180.82 643.368L2189.47 663.348L2127.24 690.292L2118.86 669.868Z",
    fill: "#6CDD59"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M2173.87 809.508L2237.64 784.366L2245.63 804.62L2181.85 829.763L2173.87 809.508Z",
    fill: "#EEEEEE"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M1688.87 418.078L1753.25 390.868L1761.73 410.923L1697.34 438.133L1688.87 418.078Z",
    fill: "#FF1717"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M1698.87 446.078L1763.25 418.868L1771.73 438.923L1707.34 466.133L1698.87 446.078Z",
    fill: "#FF1717"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M1753.87 588.078L1818.25 560.868L1826.73 580.923L1762.34 608.133L1753.87 588.078Z",
    fill: "#6CDD59"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M1775.87 644.078L1840.25 616.868L1848.73 636.923L1784.34 664.133L1775.87 644.078Z",
    fill: "#FF1717"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M1733.87 530.078L1798.25 502.868L1806.73 522.923L1742.34 550.133L1733.87 530.078Z",
    fill: "#6CDD59"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M1788.87 672.078L1853.25 644.868L1861.73 664.923L1797.34 692.133L1788.87 672.078Z",
    fill: "#6CDD59"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M1761.87 390.688L1825.99 362.869L1834.66 382.842L1770.53 410.661L1761.87 390.688Z",
    fill: "#6CDD59"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M1816.87 532.688L1880.99 504.869L1889.66 524.842L1825.53 552.661L1816.87 532.688Z",
    fill: "#6CDD59"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M1771.87 416.504L1836.9 390.867L1844.88 411.121L1779.85 436.759L1771.87 416.504Z",
    fill: "#FF1717"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M1826.87 558.504L1891.9 532.867L1899.88 553.121L1834.85 578.759L1826.87 558.504Z",
    fill: "#6CDD59"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M1783.87 444.504L1848.9 418.867L1856.88 439.121L1791.85 464.759L1783.87 444.504Z",
    fill: "#6CDD59"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M1793.87 472.504L1858.9 446.867L1866.88 467.121L1801.85 492.759L1793.87 472.504Z",
    fill: "#6CDD59"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M1806.87 500.504L1871.9 474.867L1879.88 495.121L1814.85 520.759L1806.87 500.504Z",
    fill: "#6CDD59"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M1856.87 839.078L1921.25 811.868L1929.73 831.923L1865.34 859.133L1856.87 839.078Z",
    fill: "#6CDD59"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M1811.87 728.078L1876.25 700.868L1884.73 720.923L1820.34 748.133L1811.87 728.078Z",
    fill: "#6CDD59"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M1866.87 867.078L1931.25 839.868L1939.73 859.923L1875.34 887.133L1866.87 867.078Z",
    fill: "#6CDD59"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M1821.87 756.078L1886.25 728.868L1894.73 748.923L1830.34 776.133L1821.87 756.078Z",
    fill: "#6CDD59"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.87 784.078L1898.25 756.868L1906.73 776.923L1842.34 804.133L1833.87 784.078Z",
    fill: "#EEEEEE"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.87 923.078L1953.25 895.868L1961.73 915.923L1897.34 943.133L1888.87 923.078Z",
    fill: "#EEEEEE"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.87 668.844L1937.35 641.868L1945.75 661.954L1881.27 688.929L1872.87 668.844Z",
    fill: "#FF1717"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M1929.87 810.365L1992.81 784.38L2001.47 804.354L1938.53 831.658L1929.87 810.365Z",
    fill: "#EEEEEE"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M1884.87 697.504L1949.9 671.867L1957.88 692.121L1892.85 717.759L1884.87 697.504Z",
    fill: "#6CDD59"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M1939.87 837.504L2003.25 812.517L2011.23 832.772L1947.85 857.759L1939.87 837.504Z",
    fill: "#EEEEEE"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M1894.87 726.504L1959.9 700.867L1967.88 721.121L1902.85 746.759L1894.87 726.504Z",
    fill: "#EEEEEE"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M1951.87 865.504L2013.97 841.022L2021.95 861.277L1959.85 885.759L1951.87 865.504Z",
    fill: "#6CDD59"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M1906.87 753.504L1971.9 727.867L1979.88 748.121L1914.85 773.759L1906.87 753.504Z",
    fill: "#EEEEEE"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M1961.87 893.504L2026.9 867.867L2034.88 888.121L1969.85 913.759L1961.87 893.504Z",
    fill: "#6CDD59"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.87 781.504L1981.9 755.867L1989.88 776.121L1924.85 801.759L1916.87 781.504Z",
    fill: "#6CDD59"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M1974.87 921.504L2039.9 895.867L2047.88 916.121L1982.85 941.759L1974.87 921.504Z",
    fill: "#EEEEEE"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M1497.87 560.078L1562.25 532.868L1570.73 552.923L1506.34 580.133L1497.87 560.078Z",
    fill: "#EEEEEE"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.87 588.078L1572.25 560.868L1580.73 580.923L1516.34 608.133L1507.87 588.078Z",
    fill: "#EEEEEE"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.87 730.078L1627.25 702.868L1635.73 722.923L1571.34 750.133L1562.87 730.078Z",
    fill: "#6CDD59"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M1584.87 786.078L1649.25 758.868L1657.73 778.923L1593.34 806.133L1584.87 786.078Z",
    fill: "#EEEEEE"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M1542.87 672.078L1607.25 644.868L1615.73 664.923L1551.34 692.133L1542.87 672.078Z",
    fill: "#6CDD59"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M1597.87 814.078L1662.25 786.868L1670.73 806.923L1606.34 834.133L1597.87 814.078Z",
    fill: "#6CDD59"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M1558.87 503.688L1622.99 475.869L1631.66 495.842L1567.53 523.661L1558.87 503.688Z",
    fill: "#6CDD59"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M1568.87 531.688L1632.99 503.869L1641.66 523.842L1577.53 551.661L1568.87 531.688Z",
    fill: "#6CDD59"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M1625.77 670.723L1690.61 644.607L1698.75 664.803L1633.91 690.918L1625.77 670.723Z",
    fill: "#6CDD59"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M1580.87 558.504L1645.9 532.867L1653.88 553.121L1588.85 578.759L1580.87 558.504Z",
    fill: "#EEEEEE"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M1637.87 699.504L1702.9 673.867L1710.88 694.121L1645.85 719.759L1637.87 699.504Z",
    fill: "#6CDD59"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M1592.87 586.504L1657.9 560.867L1665.88 581.121L1600.85 606.759L1592.87 586.504Z",
    fill: "#6CDD59"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M1602.87 614.504L1667.9 588.867L1675.88 609.121L1610.85 634.759L1602.87 614.504Z",
    fill: "#6CDD59"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.87 643.367L1679.87 617.367L1688.88 638.122L1622.87 662.367L1614.87 643.367Z",
    fill: "#6CDD59"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M1607.87 842.078L1673.33 814.412L1681.81 834.467L1616.34 862.133L1607.87 842.078Z",
    fill: "#D7D8D7"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M1665.87 981.078L1730.25 953.868L1738.73 973.923L1674.34 1001.13L1665.87 981.078Z",
    fill: "#6CDD59"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M1620.87 870.078L1685.25 842.868L1693.73 862.923L1629.34 890.133L1620.87 870.078Z",
    fill: "#6CDD59"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.87 1010.08L1743.25 982.868L1751.73 1002.92L1687.34 1030.13L1678.87 1010.08Z",
    fill: "#6CDD59"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M1632.87 898.078L1697.25 870.868L1705.73 890.923L1641.34 918.133L1632.87 898.078Z",
    fill: "#6CDD59"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M1642.87 926.078L1707.25 898.868L1715.73 918.923L1651.34 946.133L1642.87 926.078Z",
    fill: "#EEEEEE"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.87 1065.37L1763.87 1040.37L1771.73 1059.92L1709.23 1086.33L1700.87 1065.37Z",
    fill: "#EEEEEE"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M1681.87 810.66L1746.83 784.865L1754.87 805.101L1689.9 830.896L1681.87 810.66Z",
    fill: "#EEEEEE"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M1738.87 952.082L1803.67 925.868L1811.83 946.051L1747.03 972.265L1738.87 952.082Z",
    fill: "#EEEEEE"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.87 839.707L1758.41 812.866L1766.77 832.969L1702.23 859.81L1693.87 839.707Z",
    fill: "#6CDD59"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M1749.87 979.504L1814.9 953.867L1822.88 974.121L1757.85 999.759L1749.87 979.504Z",
    fill: "#EEEEEE"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M1704.45 868.062L1770.9 841.865L1778.88 862.12L1712.43 888.317L1704.45 868.062Z",
    fill: "#EEEEEE"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M1760.87 1007.5L1826.61 981.585L1834.55 1001.72L1768.8 1027.64L1760.87 1007.5Z",
    fill: "#6CDD59"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.87 895.504L1780.9 869.867L1788.88 890.121L1723.85 915.759L1715.87 895.504Z",
    fill: "#EEEEEE"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M1772.86 1036.37L1837.9 1009.87L1845.58 1029.36L1780.86 1055.37L1772.86 1036.37Z",
    fill: "#6CDD59"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M1727.87 923.504L1792.9 897.867L1800.88 918.121L1735.85 943.759L1727.87 923.504Z",
    fill: "#6CDD59"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M1783.87 1063.5L1848.9 1037.87L1856.88 1058.12L1791.85 1083.76L1783.87 1063.5Z",
    fill: "#EEEEEE"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.88 700.945L1374.38 674.533L1382.86 694.588L1320.36 721L1311.88 700.945Z",
    fill: "#EEEEEE"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.33 726.934L1385.87 702.522L1393.9 722.76L1332.35 747.172L1324.33 726.934Z",
    fill: "#FF1717"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.71 868.906L1445.15 842.998L1453.38 863.154L1389.94 889.062L1381.71 868.906Z",
    fill: "#6CDD59"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.91 924.168L1465.3 899.618L1473.38 919.833L1412 944.383L1403.91 924.168Z",
    fill: "#FF1717"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.08 812.809L1420.66 787.868L1428.5 807.237L1366.93 832.178L1359.08 812.809Z",
    fill: "#6CDD59"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M1415.87 953.866L1476.87 928.866L1484.32 948.031L1423.37 972.366L1415.87 953.866Z",
    fill: "#6CDD59"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M1382.87 671.5L1446.3 646.501L1454.28 666.757L1390.85 691.756L1382.87 671.5Z",
    fill: "#6CDD59"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.73 811.156L1503.36 786.668L1511.18 806.987L1447.55 831.475L1439.73 811.156Z",
    fill: "#6CDD59"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.87 699.504L1457.08 674.978L1465.06 695.233L1402.85 719.759L1394.87 699.504Z",
    fill: "#EEEEEE"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.87 840.504L1514.9 814.867L1522.88 835.121L1457.85 860.759L1449.87 840.504Z",
    fill: "#6CDD59"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.87 727.504L1469.13 702.959L1477.11 723.213L1414.85 747.759L1406.87 727.504Z",
    fill: "#6CDD59"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.87 755.504L1479.83 730.681L1487.81 750.936L1424.85 775.759L1416.87 755.504Z",
    fill: "#6CDD59"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.87 783.504L1490.71 759.123L1498.69 779.378L1436.85 803.759L1428.87 783.504Z",
    fill: "#6CDD59"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M1483.37 1122.37L1547.3 1096.87L1555.66 1116.92L1492.1 1144.14L1483.37 1122.37Z",
    fill: "#6CDD59"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.32 1009.72L1498.84 984.145L1507.87 1004.37L1445.87 1029.37L1438.32 1009.72Z",
    fill: "#6CDD59"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M1493.87 1151.08L1555.52 1124.68L1563.87 1145.37L1502.23 1171.13L1493.87 1151.08Z",
    fill: "#6CDD59"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.87 1038.37L1511.26 1012.88L1519.73 1032.93L1457.36 1057.37L1449.87 1038.37Z",
    fill: "#6CDD59"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M1505.87 1177.87L1570 1152.87L1578.37 1172.92L1514.81 1200.13L1505.87 1177.87Z",
    fill: "#D7D8D7"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M1460.86 1066.37L1522.25 1040.87L1530.73 1060.92L1468.86 1085.37L1460.86 1066.37Z",
    fill: "#FF1717"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M1518.29 1208.08L1581.85 1180.87L1590.21 1200.92L1526.65 1228.13L1518.29 1208.08Z",
    fill: "#6CDD59"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.79 951.871L1559.16 926.457L1567.38 946.619L1505 972.034L1496.79 951.871Z",
    fill: "#6CDD59"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.72 1092.91L1616.66 1068.79L1624.34 1089.16L1560.4 1113.28L1552.72 1092.91Z",
    fill: "#EEEEEE"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.87 980.645L1570.72 955.867L1578.7 976.122L1515.85 1000.9L1507.87 980.645Z",
    fill: "#6CDD59"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.87 1122.5L1627.9 1096.87L1635.88 1117.12L1570.85 1142.76L1562.87 1122.5Z",
    fill: "#EEEEEE"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M1519.87 1009.52L1582.41 984.867L1590.39 1005.12L1527.85 1029.78L1519.87 1009.52Z",
    fill: "#6CDD59"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M1575.87 1149.5L1638.64 1124.75L1646.63 1145.01L1583.85 1169.76L1575.87 1149.5Z",
    fill: "#EEEEEE"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M1529.87 1037.5L1592.25 1012.91L1600.24 1033.16L1537.85 1057.76L1529.87 1037.5Z",
    fill: "#6CDD59"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.87 1177.5L1651.06 1152.59L1659.04 1172.85L1595.85 1197.76L1587.87 1177.5Z",
    fill: "#EEEEEE"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M1542.87 1065.5L1605.46 1040.83L1613.45 1061.08L1550.85 1085.76L1542.87 1065.5Z",
    fill: "#6CDD59"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M1597.87 1205.5L1662.9 1179.87L1670.88 1200.12L1605.85 1225.76L1597.87 1205.5Z",
    fill: "#EEEEEE"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.37 842.867L1187.86 817.367L1194.73 833.922L1131.04 860.837L1123.37 842.867Z",
    fill: "#FF1717"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.87 869.078L1198.25 841.868L1206.73 861.923L1142.34 889.133L1133.87 869.078Z",
    fill: "#EEEEEE"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.87 1009.45L1255.51 982.867L1263.79 1003L1199.15 1029.59L1190.87 1009.45Z",
    fill: "#6CDD59"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.87 1066.08L1278.25 1038.87L1286.73 1058.92L1222.34 1086.13L1213.87 1066.08Z",
    fill: "#FF1717"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.87 953.078L1233.25 925.868L1241.73 945.923L1177.34 973.133L1168.87 953.078Z",
    fill: "#6CDD59"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.87 1095.08L1289.25 1067.87L1297.73 1087.92L1233.34 1115.13L1224.87 1095.08Z",
    fill: "#6CDD59"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.86 811.515L1256.37 787.367L1264.37 806.367L1202.53 831.892L1194.86 811.515Z",
    fill: "#6CDD59"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.81 951.613L1312.17 926.707L1320.36 946.88L1259 971.787L1250.81 951.613Z",
    fill: "#6CDD59"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.87 839.504L1268.16 815.338L1276.15 835.593L1214.85 859.759L1206.87 839.504Z",
    fill: "#EEEEEE"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.87 980.504L1324.33 956.667L1332.31 976.922L1271.85 1000.76L1263.87 980.504Z",
    fill: "#6CDD59"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.87 867.504L1279.48 843.61L1287.46 863.864L1226.85 887.759L1218.87 867.504Z",
    fill: "#6CDD59"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.87 895.504L1289.87 871.454L1297.85 891.709L1236.85 915.759L1228.87 895.504Z",
    fill: "#6CDD59"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.87 923.504L1301.53 898.798L1309.52 919.053L1246.85 943.759L1238.87 923.504Z",
    fill: "#6CDD59"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M1291.87 1264.08L1356.25 1236.87L1364.73 1256.92L1300.34 1284.13L1291.87 1264.08Z",
    fill: "#6CDD59"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.8 1150.3L1311.75 1124.47L1319.8 1144.71L1254.84 1170.53L1246.8 1150.3Z",
    fill: "#6CDD59"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.87 1292.08L1369.25 1264.87L1377.73 1284.92L1313.34 1312.13L1304.87 1292.08Z",
    fill: "#6CDD59"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.87 1179.08L1323.25 1151.87L1331.73 1171.92L1267.34 1199.13L1258.87 1179.08Z",
    fill: "#6CDD59"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.87 1207.08L1335.25 1179.87L1343.73 1199.92L1279.34 1227.13L1270.87 1207.08Z",
    fill: "#FF1717"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.83 1348.65L1391.53 1322.19L1399.77 1342.35L1335.07 1368.8L1326.83 1348.65Z",
    fill: "#EEEEEE"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.87 1092.69L1368.04 1067.02L1377.27 1088.3L1318.1 1113.97L1308.87 1092.69Z",
    fill: "#EEEEEE"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.87 1234.69L1425.45 1208.4L1434.12 1228.38L1373.53 1254.66L1364.87 1234.69Z",
    fill: "#FF1717"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.87 1120.5L1380.63 1096.55L1388.62 1116.8L1327.85 1140.76L1319.87 1120.5Z",
    fill: "#6CDD59"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.87 1262.5L1437.38 1237.86L1445.36 1258.12L1382.85 1282.76L1374.87 1262.5Z",
    fill: "#EEEEEE"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.87 1148.5L1392.03 1124.79L1400.01 1145.04L1339.85 1168.76L1331.87 1148.5Z",
    fill: "#EEEEEE"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.87 1290.5L1448.26 1266.3L1456.25 1286.55L1394.85 1310.76L1386.87 1290.5Z",
    fill: "#6CDD59"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.87 1178.5L1404.46 1153.83L1412.44 1174.08L1349.85 1198.76L1341.87 1178.5Z",
    fill: "#EEEEEE"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.87 1318.5L1460.02 1293.61L1468.01 1313.86L1404.85 1338.76L1396.87 1318.5Z",
    fill: "#6CDD59"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.87 1205.5L1415.69 1181.13L1423.68 1201.39L1361.85 1225.76L1353.87 1205.5Z",
    fill: "#6CDD59"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.87 1346.5L1471.03 1322.39L1479.02 1342.64L1417.85 1366.76L1409.87 1346.5Z",
    fill: "#EEEEEE"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M946.365 1012.37L1009.37 985.366L1017.37 1004.87L954.34 1030.03L946.365 1012.37Z",
    fill: "#FF1717"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M958.001 1037.94L1020.5 1012.94L1028.36 1032.99L966.81 1059.01L958.001 1037.94Z",
    fill: "#EEEEEE"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.81 1180.47L1078.64 1154.33L1086.78 1174.52L1021.95 1200.66L1013.81 1180.47Z",
    fill: "#6CDD59"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.81 1236.41L1101.68 1210.38L1109.79 1230.59L1044.91 1256.62L1036.81 1236.41Z",
    fill: "#FF1717"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.23 1095.16L1124.87 1069.86L1132.76 1089.79L1087.21 1107.66C1085.66 1104.54 1078.78 1095.7 1063.89 1096.59L1063.23 1095.16Z",
    fill: "#6CDD59"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.87 1264.56L1112.47 1237.86L1120.78 1257.99L1056.18 1284.68L1047.87 1264.56Z",
    fill: "#6CDD59"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.88 982.581L1079.36 957.869L1086.9 976.807L1026.36 1001.37L1018.88 982.581Z",
    fill: "#6CDD59"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.85 954.378L1069.37 929.869L1075.76 948.979L1013.37 973.869L1005.85 954.378Z",
    fill: "#6CDD59"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.78 1123.71L1135.77 1098.57L1143.96 1118.75L1081.96 1143.89L1073.78 1123.71Z",
    fill: "#6CDD59"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.87 1009.5L1090.24 985.309L1098.22 1005.56L1036.85 1029.76L1028.87 1009.5Z",
    fill: "#EEEEEE"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.87 1151.14L1147.35 1125.79L1155.53 1145.97L1093.05 1171.31L1084.87 1151.14Z",
    fill: "#6CDD59"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.87 1038.5L1102.09 1014.37L1110.08 1034.62L1048.85 1058.76L1040.87 1038.5Z",
    fill: "#6CDD59"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.87 1066.5L1113.57 1042.57L1121.56 1062.83L1060.85 1086.76L1052.87 1066.5Z",
    fill: "#6CDD59"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.87 1432.66L1180.83 1406.86L1188.87 1427.1L1123.9 1452.9L1115.87 1432.66Z",
    fill: "#6CDD59"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.37 1320.86L1135.25 1293.86L1143.73 1313.92L1079.84 1340.92L1071.37 1320.86Z",
    fill: "#6CDD59"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.74 1462.28L1190.25 1435.86L1198.73 1455.92L1136.21 1482.34L1127.74 1462.28Z",
    fill: "#6CDD59"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.46 1348.98L1145.25 1322.86L1153.73 1342.92L1091.94 1369.03L1083.46 1348.98Z",
    fill: "#6CDD59"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.87 1377.07L1158.25 1349.86L1166.73 1369.92L1102.34 1397.13L1093.87 1377.07Z",
    fill: "#FF1717"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.01 1516.5L1212.7 1491.4L1220.79 1511.62L1158.1 1536.71L1150.01 1516.5Z",
    fill: "#ECECEF"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.78 1262.98L1191.91 1237.78L1200.21 1257.91L1139.08 1283.11L1130.78 1262.98Z",
    fill: "#ECECEF"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.87 1404.83L1249.61 1379.73L1257.69 1399.94L1194.95 1425.04L1186.87 1404.83Z",
    fill: "#ECECEF"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.87 1291.5L1204.78 1266.3L1212.77 1286.56L1148.85 1311.75L1140.87 1291.5Z",
    fill: "#6CDD59"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.87 1432.84L1260.61 1407.87L1268.77 1428.05L1207.03 1453.02L1198.87 1432.84Z",
    fill: "#ECECEF"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.87 1319.5L1215.75 1295.1L1223.74 1315.36L1161.85 1339.75L1153.87 1319.5Z",
    fill: "#ECECEF"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.87 1460.5L1272 1436.4L1279.98 1456.66L1218.85 1480.76L1210.87 1460.5Z",
    fill: "#6CDD59"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.87 1347.5L1225.91 1323.04L1233.89 1343.3L1171.85 1367.75L1163.87 1347.5Z",
    fill: "#ECECEF"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.87 1488.5L1283.68 1464.13L1291.67 1484.39L1229.85 1508.76L1221.87 1488.5Z",
    fill: "#6CDD59"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.87 1375.5L1237.77 1351.09L1245.76 1371.35L1183.85 1395.75L1175.87 1375.5Z",
    fill: "#6CDD59"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M1232.87 1516.5L1295.35 1491.87L1303.34 1512.13L1240.85 1536.76L1232.87 1516.5Z",
    fill: "#ECECEF"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M781.93 1207.2L844.254 1180.87L852.729 1200.92L790.405 1227.26L781.93 1207.2Z",
    fill: "#FF1717"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M793.583 1235.51L854.254 1209.87L862.729 1229.92L802.058 1255.56L793.583 1235.51Z",
    fill: "#EFEFEF"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M849.199 1376.67L910.254 1350.87L918.729 1370.92L857.674 1396.72L849.199 1376.67Z",
    fill: "#6CDD59"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M871.703 1430.7L932.784 1406.51L940.801 1426.75L879.72 1450.94L871.703 1430.7Z",
    fill: "#FF1717"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M826.829 1319.82L888.254 1293.87L896.729 1313.92L835.304 1339.88L826.829 1319.82Z",
    fill: "#6CDD59"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M883.553 1459.94L945.255 1433.87L953.73 1453.92L892.028 1480L883.553 1459.94Z",
    fill: "#6CDD59"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M851.865 1179.69L913.386 1153L922.05 1172.97L860.53 1199.66L851.865 1179.69Z",
    fill: "#6CDD59"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M837.865 1151.59L901.993 1123.77L910.865 1145.87L846.53 1171.56L837.865 1151.59Z",
    fill: "#6CDD59"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M831.948 1127.18L891.9 1101.18L899.481 1118.65L839.529 1144.66L831.948 1127.18Z",
    fill: "#6CDD59"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M769.865 1180.69L833.993 1152.87L842.658 1172.84L778.53 1200.66L769.865 1180.69Z",
    fill: "#6CDD59"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M908.365 1319.37L970.365 1293.87L978.365 1313.37L915.865 1338.37L908.365 1319.37Z",
    fill: "#6CDD59"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M862.865 1206.5L925.484 1181.82L933.469 1202.07L870.85 1226.76L862.865 1206.5Z",
    fill: "#EFEFEF"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M919.233 1346.96L981.268 1322.51L989.254 1342.76L927.219 1367.22L919.233 1346.96Z",
    fill: "#6CDD59"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M874.865 1235.5L937.239 1210.91L945.224 1231.17L882.85 1255.76L874.865 1235.5Z",
    fill: "#6CDD59"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M885.865 1263.5L947.934 1239.03L955.919 1259.29L893.85 1283.76L885.865 1263.5Z",
    fill: "#6CDD59"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M896.865 1291.5L959.058 1266.99L967.043 1287.24L904.85 1311.76L896.865 1291.5Z",
    fill: "#6CDD59"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M950.612 1628.49L1011.25 1602.87L1019.73 1622.92L959.087 1648.55L950.612 1628.49Z",
    fill: "#6CDD59"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M905.849 1516.72L967.254 1490.77L975.729 1510.82L914.324 1536.77L905.849 1516.72Z",
    fill: "#6CDD59"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M962.927 1656.36L1023.25 1630.87L1031.73 1650.92L971.402 1676.41L962.927 1656.36Z",
    fill: "#6CDD59"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M917.176 1545L979.254 1518.77L987.729 1538.82L925.651 1565.05L917.176 1545Z",
    fill: "#6CDD59"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M927.849 1572.72L989.254 1546.77L997.729 1566.82L936.324 1592.77L927.849 1572.72Z",
    fill: "#6CDD59"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M984.556 1711.7L1045.62 1686.87L1053.82 1707.04L992.757 1731.87L984.556 1711.7Z",
    fill: "#6CDD59"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M964.865 1460.37L1026.76 1434.4L1035.43 1454.37L972.365 1478.87L964.865 1460.37Z",
    fill: "#EFEFEF"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.87 1600.69L1083.37 1573.87L1091.37 1594.37L1028.53 1620.66L1019.87 1600.69Z",
    fill: "#EFEFEF"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M975.865 1488.41L1038.31 1463.79L1046.3 1484.04L983.85 1508.66L975.865 1488.41Z",
    fill: "#6CDD59"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.87 1628.5L1095.11 1603.57L1103.1 1623.82L1039.85 1648.76L1031.87 1628.5Z",
    fill: "#EFEFEF"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M987.865 1516.41L1049.87 1491.37L1057.87 1510.87L995.85 1536.66L987.865 1516.41Z",
    fill: "#EFEFEF"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.87 1655.5L1105.85 1630.67L1113.83 1650.93L1050.85 1675.76L1042.87 1655.5Z",
    fill: "#6CDD59"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M997.865 1544.41L1061.1 1519.48L1069.08 1539.73L1005.85 1564.66L997.865 1544.41Z",
    fill: "#EFEFEF"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.87 1683.5L1116.79 1658.3L1124.77 1678.56L1060.85 1703.76L1052.87 1683.5Z",
    fill: "#6CDD59"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.86 1572.51L1071.36 1547.37L1079.86 1568.37L1017.85 1592.76L1009.86 1572.51Z",
    fill: "#6CDD59"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.87 1712.5L1128.49 1687.82L1136.47 1708.07L1073.85 1732.76L1065.87 1712.5Z",
    fill: "#FF1717"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M657.865 1517.95L722.72 1491.87L730.843 1512.07L665.988 1538.15L657.865 1517.95Z",
    fill: "#FF1717"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M667.865 1546.91L732.737 1520.87L740.847 1541.07L675.975 1567.11L667.865 1546.91Z",
    fill: "#EEEEEE"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M724.865 1687.08L789.254 1659.87L797.729 1679.92L733.34 1707.13L724.865 1687.08Z",
    fill: "#6CDD59"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M746.865 1742.95L811.719 1716.87L819.843 1737.07L754.989 1763.15L746.865 1742.95Z",
    fill: "#FF1717"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M703.865 1631.08L768.254 1603.87L776.729 1623.92L712.34 1651.13L703.865 1631.08Z",
    fill: "#6CDD59"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M757.865 1771.98L822.254 1744.77L830.729 1764.82L766.34 1792.04L757.865 1771.98Z",
    fill: "#6CDD59"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M729.865 1489.55L794.88 1463.87L802.878 1484.12L737.864 1509.8L729.865 1489.55Z",
    fill: "#6CDD59"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M717.783 1460.8L782.026 1434.79L790.197 1454.97L725.955 1480.98L717.783 1460.8Z",
    fill: "#6CDD59"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M707.879 1433.45L770.344 1408.69L778.366 1428.93L715.901 1453.69L707.879 1433.45Z",
    fill: "#6CDD59"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M644.813 1488.98L709.459 1462.39L718.445 1484.23L653.8 1510.83L644.813 1488.98Z",
    fill: "#6CDD59"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M784.779 1629.78L849.578 1603.56L857.744 1623.75L792.945 1649.96L784.779 1629.78Z",
    fill: "#6CDD59"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M741.865 1517.5L806.896 1491.87L814.881 1512.12L749.85 1537.76L741.865 1517.5Z",
    fill: "#EEEEEE"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M795.865 1658.41L860.896 1632.77L868.881 1653.02L803.85 1678.66L795.865 1658.41Z",
    fill: "#6CDD59"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M752.865 1544.41L817.896 1518.77L825.881 1539.02L760.85 1564.66L752.865 1544.41Z",
    fill: "#6CDD59"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M763.865 1574.5L828.896 1548.87L836.881 1569.12L771.85 1594.76L763.865 1574.5Z",
    fill: "#6CDD59"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M774.865 1601.5L839.896 1575.87L847.881 1596.12L782.85 1621.76L774.865 1601.5Z",
    fill: "#6CDD59"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M825.865 1938.98L890.254 1911.77L898.729 1931.82L834.34 1959.04L825.865 1938.98Z",
    fill: "#6CDD59"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M781.865 1827.08L846.254 1799.87L854.729 1819.92L790.34 1847.13L781.865 1827.08Z",
    fill: "#6CDD59"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M837.865 1968.08L902.254 1940.87L910.729 1960.92L846.34 1988.13L837.865 1968.08Z",
    fill: "#6CDD59"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M793.83 1853.7L858.501 1827.16L866.765 1847.31L802.094 1873.84L793.83 1853.7Z",
    fill: "#6CDD59"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M804.865 1883.08L869.254 1855.87L877.729 1875.92L813.34 1903.13L804.865 1883.08Z",
    fill: "#EEEEEE"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M859.865 2024.08L924.254 1996.87L932.729 2016.92L868.34 2044.13L859.865 2024.08Z",
    fill: "#EEEEEE"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M841.865 1769.55L906.879 1743.87L914.878 1764.12L849.864 1789.8L841.865 1769.55Z",
    fill: "#EFEFEF"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M898.771 1910.58L963.647 1884.55L971.753 1904.76L906.877 1930.78L898.771 1910.58Z",
    fill: "#EEEEEE"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M853.865 1797.5L918.896 1771.87L926.881 1792.12L861.85 1817.76L853.865 1797.5Z",
    fill: "#6CDD59"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M908.865 1937.41L973.896 1911.77L981.881 1932.03L916.85 1957.67L908.865 1937.41Z",
    fill: "#6CDD59"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M864.865 1825.5L929.896 1799.87L937.881 1820.12L872.85 1845.76L864.865 1825.5Z",
    fill: "#EEEEEE"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M920.865 1965.41L985.896 1939.77L993.881 1960.03L928.85 1985.67L920.865 1965.41Z",
    fill: "#6CDD59"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M875.865 1853.5L940.896 1827.87L948.881 1848.12L883.85 1873.76L875.865 1853.5Z",
    fill: "#EEEEEE"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M930.865 1993.41L995.896 1967.77L1003.88 1988.03L938.85 2013.67L930.865 1993.41Z",
    fill: "#6CDD59"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M887.865 1881.5L952.896 1855.87L960.881 1876.12L895.85 1901.76L887.865 1881.5Z",
    fill: "#6CDD59"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M507.865 1745.87L569.365 1721.37L576.834 1739.83L515.865 1764.37L507.865 1745.87Z",
    fill: "#EFEFEF"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M518.258 1772.15L580.867 1747.61L588.811 1767.89L526.201 1792.42L518.258 1772.15Z",
    fill: "#EFEFEF"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M574.57 1912.93L636.254 1886.87L644.729 1906.92L583.045 1932.99L574.57 1912.93Z",
    fill: "#6CDD59"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M597.401 1968.08L658.604 1943.29L666.778 1963.47L605.576 1988.26L597.401 1968.08Z",
    fill: "#EFEFEF"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M552.321 1857.46L615.254 1830.87L623.729 1850.92L560.796 1877.52L552.321 1857.46Z",
    fill: "#6CDD59"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M607.901 1996.13L670.311 1969.94L678.738 1990.01L616.328 2016.21L607.901 1996.13Z",
    fill: "#6CDD59"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M577.994 1717.29L639.661 1691.98L647.928 1712.12L586.261 1737.43L577.994 1717.29Z",
    fill: "#6CDD59"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M564.865 1689.58L628.202 1662.11L637.365 1683.87L573.53 1709.56L564.865 1689.58Z",
    fill: "#6CDD59"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M555.115 1656.49L616.695 1630.94L626.805 1655.3L565.226 1680.85L555.115 1656.49Z",
    fill: "#6CDD59"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M494.865 1718.37L558.487 1691.95L567.152 1711.93L504.484 1739.11L494.865 1718.37Z",
    fill: "#6CDD59"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M631.735 1856.2L696.948 1831.02L704.788 1851.33L639.576 1876.51L631.735 1856.2Z",
    fill: "#6CDD59"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M588.865 1744.5L651.401 1719.85L659.386 1740.11L596.85 1764.76L588.865 1744.5Z",
    fill: "#EFEFEF"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M644.865 1884.5L707.881 1859.66L715.866 1879.92L652.85 1904.76L644.865 1884.5Z",
    fill: "#6CDD59"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M598.865 1771.5L662.213 1746.53L670.198 1766.79L606.85 1791.76L598.865 1771.5Z",
    fill: "#6CDD59"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M610.865 1799.5L673.168 1774.94L681.153 1795.2L618.85 1819.76L610.865 1799.5Z",
    fill: "#6CDD59"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M622.865 1828.5L685.329 1803.88L693.315 1824.13L630.85 1848.76L622.865 1828.5Z",
    fill: "#6CDD59"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M408.203 2110.86L471.532 2084.87L479.799 2105.01L416.47 2131L408.203 2110.86Z",
    fill: "#6CDD59"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M630.865 2051.41L695.532 2024.87L703.799 2045.01L639.132 2071.55L630.865 2051.41Z",
    fill: "#6CDD59"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M386.832 2057.6L449.532 2031.87L457.799 2052.01L395.099 2077.74L386.832 2057.6Z",
    fill: "#6CDD59"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M418.733 2136.93L481.078 2112.87L488.918 2133.18L426.574 2157.25L418.733 2136.93Z",
    fill: "#6CDD59"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M640.865 2078.04L706.078 2052.87L713.918 2073.18L648.705 2098.35L640.865 2078.04Z",
    fill: "#6CDD59"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M430.518 2165.27L494.406 2139.87L502.45 2160.1L438.561 2185.5L430.518 2165.27Z",
    fill: "#EFEFEF"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M652.865 2107.08L717.254 2079.87L725.729 2099.92L661.34 2127.13L652.865 2107.08Z",
    fill: "#EFEFEF"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M466.865 2054.11L530.481 2028.34L538.655 2048.52L475.04 2074.29L466.865 2054.11Z",
    fill: "#FF1717"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M688.865 1995.11L751.763 1969.63L759.938 1989.81L697.04 2015.29L688.865 1995.11Z",
    fill: "#FF1717"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M445.614 1998.49L508.344 1973.08L517.061 1994.6L454.331 2020.01L445.614 1998.49Z",
    fill: "#FE763B"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M477.865 2081.91L541.962 2056.18L550.073 2076.38L485.977 2102.11L477.865 2081.91Z",
    fill: "#6CDD59"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M699.865 2022.91L762.621 1997.72L770.732 2017.92L707.977 2043.11L699.865 2022.91Z",
    fill: "#6CDD59"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M455.865 2028.91L520.735 2002.87L528.846 2023.07L463.977 2049.11L455.865 2028.91Z",
    fill: "#6CDD59"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M489.865 2110.5L553.864 2085.27L561.849 2105.53L497.85 2130.76L489.865 2110.5Z",
    fill: "#EFEFEF"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M710.865 2050.3L772.849 2025.87L780.834 2046.12L718.85 2070.56L710.865 2050.3Z",
    fill: "#EFEFEF"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M499.865 2137.5L564.37 2112.07L572.355 2132.33L507.85 2157.76L499.865 2137.5Z",
    fill: "#EFEFEF"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M722.865 2077.5L784.685 2053.13L792.67 2073.39L730.85 2097.76L722.865 2077.5Z",
    fill: "#EFEFEF"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M510.865 2165.5L575.379 2140.07L583.364 2160.33L518.85 2185.76L510.865 2165.5Z",
    fill: "#6CDD59"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M2113.87 867.07L2178.25 839.86L2186.73 859.915L2122.34 887.125L2113.87 867.07Z",
    fill: "#EEEEEE"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M2168.87 1009.07L2233.25 981.86L2241.73 1001.91L2177.34 1029.13L2168.87 1009.07Z",
    fill: "#6CDD59"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M2124.73 894.703L2188.25 867.858L2196.37 888.863L2133.21 914.758L2124.73 894.703Z",
    fill: "#EEEEEE"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M2178.87 1037.07L2243.25 1009.86L2251.73 1029.91L2187.34 1057.13L2178.87 1037.07Z",
    fill: "#FF1717"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M2135.87 923.07L2200.37 897.869L2207.87 917.369L2144.34 943.125L2135.87 923.07Z",
    fill: "#FE763B"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M2190.87 1065.07L2255.25 1037.86L2263.73 1057.91L2199.34 1085.13L2190.87 1065.07Z",
    fill: "#6CDD59"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M2145.87 951.07L2210.25 923.86L2218.73 943.915L2154.34 971.125L2145.87 951.07Z",
    fill: "#6CDD59"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M2200.87 1093.07L2265.25 1065.86L2273.73 1085.91L2209.34 1113.13L2200.87 1093.07Z",
    fill: "#6CDD59"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M2158.87 979.07L2223.25 951.86L2231.73 971.915L2167.34 999.125L2158.87 979.07Z",
    fill: "#FE763B"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M2213.87 1121.07L2278.25 1093.86L2286.73 1113.91L2222.34 1141.13L2213.87 1121.07Z",
    fill: "#FF1717"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M2185.87 837.688L2248.25 810.627L2256.87 831.869L2194.53 857.661L2185.87 837.688Z",
    fill: "#EEEEEE"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M2242.87 978.688L2304.63 951.894L2313.29 971.867L2251.53 998.661L2242.87 978.688Z",
    fill: "#6CDD59"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M2196.87 865.496L2260.04 840.591L2268.02 860.846L2204.85 885.751L2196.87 865.496Z",
    fill: "#6CDD59"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M2251.87 1007.5L2316.9 981.859L2324.88 1002.11L2259.85 1027.75L2251.87 1007.5Z",
    fill: "#6CDD59"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M2208.87 893.496L2271.61 868.759L2279.6 889.014L2216.85 913.751L2208.87 893.496Z",
    fill: "#6CDD59"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M2263.87 1035.5L2328.9 1009.86L2336.88 1030.11L2271.85 1055.75L2263.87 1035.5Z",
    fill: "#EEEEEE"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M2218.87 921.496L2283.9 895.859L2291.88 916.114L2226.85 941.751L2218.87 921.496Z",
    fill: "#EEEEEE"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M2273.87 1063.5L2338.9 1037.86L2346.88 1058.11L2281.85 1083.75L2273.87 1063.5Z",
    fill: "#EEEEEE"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M2231.87 949.496L2296.9 923.859L2304.88 944.114L2239.85 969.751L2231.87 949.496Z",
    fill: "#6CDD59"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M2286.87 1091.5L2351.9 1065.86L2359.88 1086.11L2294.85 1111.75L2286.87 1091.5Z",
    fill: "#6CDD59"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M2226.87 1146.07L2291.25 1118.86L2299.73 1138.91L2235.34 1166.13L2226.87 1146.07Z",
    fill: "#6CDD59"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M2236.87 1174.07L2301.25 1146.86L2309.73 1166.91L2245.34 1194.13L2236.87 1174.07Z",
    fill: "#6CDD59"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M2248.87 1202.07L2313.25 1174.86L2321.73 1194.91L2257.34 1222.13L2248.87 1202.07Z",
    fill: "#6CDD59"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M2326.87 1400.07L2391.25 1372.86L2399.73 1392.91L2335.34 1420.13L2326.87 1400.07Z",
    fill: "#FF1717"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M2299.87 1118.68L2363.99 1090.86L2372.66 1110.83L2308.53 1138.65L2299.87 1118.68Z",
    fill: "#6CDD59"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M2309.87 1144.5L2374.9 1118.86L2382.88 1139.11L2317.85 1164.75L2309.87 1144.5Z",
    fill: "#6CDD59"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M2364.87 1286.5L2429.9 1260.86L2437.88 1281.11L2372.85 1306.75L2364.87 1286.5Z",
    fill: "#6CDD59"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M2321.87 1172.5L2386.9 1146.86L2394.88 1167.11L2329.85 1192.75L2321.87 1172.5Z",
    fill: "#6CDD59"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M2331.87 1200.5L2396.9 1174.86L2404.88 1195.11L2339.85 1220.75L2331.87 1200.5Z",
    fill: "#FF1717"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M2386.87 1342.5L2451.9 1316.86L2459.88 1337.11L2394.85 1362.75L2386.87 1342.5Z",
    fill: "#6CDD59"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M2344.87 1228.5L2409.9 1202.86L2417.88 1223.11L2352.85 1248.75L2344.87 1228.5Z",
    fill: "#6CDD59"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M2409.87 1399.5L2474.9 1373.86L2482.88 1394.11L2417.85 1419.75L2409.87 1399.5Z",
    fill: "#6CDD59"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.87 979.078L1979.25 951.868L1987.73 971.923L1923.34 999.133L1914.87 979.078Z",
    fill: "#6CDD59"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M1969.87 1121.08L2034.25 1093.87L2042.73 1113.92L1978.34 1141.13L1969.87 1121.08Z",
    fill: "#6CDD59"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M1924.87 1007.08L1989.25 979.868L1997.73 999.923L1933.34 1027.13L1924.87 1007.08Z",
    fill: "#6CDD59"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M1979.87 1149.08L2044.25 1121.87L2052.73 1141.92L1988.34 1169.13L1979.87 1149.08Z",
    fill: "#6CDD59"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M1936.87 1035.08L2001.25 1007.87L2009.73 1027.92L1945.34 1055.13L1936.87 1035.08Z",
    fill: "#FE763B"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M1991.87 1177.08L2056.25 1149.87L2064.73 1169.92L2000.34 1197.13L1991.87 1177.08Z",
    fill: "#EBECEE"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M1946.87 1063.08L2011.25 1035.87L2019.73 1055.92L1955.34 1083.13L1946.87 1063.08Z",
    fill: "#6CDD59"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M2001.87 1205.08L2066.25 1177.87L2074.73 1197.92L2010.34 1225.13L2001.87 1205.08Z",
    fill: "#6CDD59"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M1959.87 1091.08L2024.25 1063.87L2032.73 1083.92L1968.34 1111.13L1959.87 1091.08Z",
    fill: "#EBECEE"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M2014.87 1233.08L2079.25 1205.87L2087.73 1225.92L2023.34 1253.13L2014.87 1233.08Z",
    fill: "#6CDD59"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M1986.75 949.363L2051.84 923.885L2059.78 944.16L1994.68 969.638L1986.75 949.363Z",
    fill: "#6CDD59"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M2042.87 1090.76L2107.39 1063.87L2115.76 1083.96L2051.24 1110.85L2042.87 1090.76Z",
    fill: "#6CDD59"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M1997.87 977.504L2059.34 953.269L2067.32 973.524L2005.85 997.759L1997.87 977.504Z",
    fill: "#6CDD59"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M2052.87 1119.5L2117.9 1093.87L2125.88 1114.12L2060.85 1139.76L2052.87 1119.5Z",
    fill: "#6CDD59"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M2007.87 1005.5L2072.9 979.867L2080.88 1000.12L2015.85 1025.76L2007.87 1005.5Z",
    fill: "#6CDD59"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M2064.87 1147.5L2127.85 1121.87L2135.59 1142.12L2072.6 1167.76L2064.87 1147.5Z",
    fill: "#6CDD59"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M2019.87 1033.5L2082.52 1008.8L2090.5 1029.06L2027.85 1053.76L2019.87 1033.5Z",
    fill: "#6CDD59"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M2074.55 1175.5L2137.54 1149.87L2145.27 1170.12L2082.29 1195.76L2074.55 1175.5Z",
    fill: "#6CDD59"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M2029.87 1062.5L2094.9 1036.87L2102.88 1057.12L2037.85 1082.76L2029.87 1062.5Z",
    fill: "#6CDD59"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M2087.14 1203.5L2150.13 1177.87L2157.87 1198.12L2094.88 1223.76L2087.14 1203.5Z",
    fill: "#6CDD59"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M2024.87 1260.46L2089.91 1234.87L2097.89 1255.13L2032.84 1280.72L2024.87 1260.46Z",
    fill: "#6CDD59"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M2036.87 1288.75L2101.8 1262.87L2109.86 1283.09L2044.93 1308.98L2036.87 1288.75Z",
    fill: "#6CDD59"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M2047.87 1317.08L2112.25 1289.87L2120.73 1309.92L2056.34 1337.13L2047.87 1317.08Z",
    fill: "#FE763B"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M2128.87 1512.87L2194.25 1487.87L2202.73 1507.92L2138.34 1535.13L2128.87 1512.87Z",
    fill: "#6CDD59"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.87 1232.08L2161.67 1205.87L2169.83 1226.05L2105.03 1252.27L2096.87 1232.08Z",
    fill: "#6CDD59"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M2109.87 1259.5L2174.9 1233.87L2182.88 1254.12L2117.85 1279.76L2109.87 1259.5Z",
    fill: "#6CDD59"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M2165.87 1399.5L2230.9 1373.87L2238.88 1394.12L2173.85 1419.76L2165.87 1399.5Z",
    fill: "#6CDD59"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M2120.87 1288.5L2185.9 1262.87L2193.88 1283.12L2128.85 1308.76L2120.87 1288.5Z",
    fill: "#6CDD59"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M2132.87 1316.5L2197.9 1290.87L2205.88 1311.12L2140.85 1336.76L2132.87 1316.5Z",
    fill: "#6CDD59"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M2188.87 1456.28L2253.59 1429.87L2261.81 1450.02L2197.09 1476.44L2188.87 1456.28Z",
    fill: "#6CDD59"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M2143.87 1343.5L2208.9 1317.87L2216.88 1338.12L2151.85 1363.76L2143.87 1343.5Z",
    fill: "#6CDD59"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M1724.87 1123.08L1789.25 1095.87L1797.73 1115.92L1733.34 1143.13L1724.87 1123.08Z",
    fill: "#FF1717"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M1778.87 1263.08L1843.25 1235.87L1851.73 1255.92L1787.34 1283.13L1778.87 1263.08Z",
    fill: "#6CDD59"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M1733.87 1151.08L1798.25 1123.87L1806.73 1143.92L1742.34 1171.13L1733.87 1151.08Z",
    fill: "#6CDD59"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.87 1291.08L1854.25 1263.87L1862.73 1283.92L1798.34 1311.13L1789.87 1291.08Z",
    fill: "#EEEEEE"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.87 1179.08L1809.25 1151.87L1817.73 1171.92L1753.34 1199.13L1744.87 1179.08Z",
    fill: "#FE763B"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M1800.87 1320.08L1865.25 1292.87L1873.73 1312.92L1809.34 1340.13L1800.87 1320.08Z",
    fill: "#EEEEEE"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M1755.87 1207.08L1820.25 1179.87L1828.73 1199.92L1764.34 1227.13L1755.87 1207.08Z",
    fill: "#6CDD59"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M1812.87 1348.08L1877.25 1320.87L1885.73 1340.92L1821.34 1368.13L1812.87 1348.08Z",
    fill: "#6CDD59"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M1767.87 1234.08L1832.25 1206.87L1840.73 1226.92L1776.34 1254.13L1767.87 1234.08Z",
    fill: "#EEEEEE"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M1823.87 1376.08L1888.25 1348.87L1896.73 1368.92L1832.34 1396.13L1823.87 1376.08Z",
    fill: "#EEEEEE"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M1795.87 1093.69L1859.99 1065.87L1868.66 1085.84L1804.53 1113.66L1795.87 1093.69Z",
    fill: "#EEEEEE"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M1851.87 1233.69L1915.99 1205.87L1924.66 1225.84L1860.53 1253.66L1851.87 1233.69Z",
    fill: "#6CDD59"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M1806.87 1119.5L1871.9 1093.87L1879.88 1114.12L1814.85 1139.76L1806.87 1119.5Z",
    fill: "#6CDD59"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M1862.87 1261.5L1927.9 1235.87L1935.88 1256.12L1870.85 1281.76L1862.87 1261.5Z",
    fill: "#6CDD59"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M1816.87 1148.5L1881.9 1122.87L1889.88 1143.12L1824.85 1168.76L1816.87 1148.5Z",
    fill: "#6CDD59"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M1873.87 1289.5L1938.9 1263.87L1946.88 1284.12L1881.85 1309.76L1873.87 1289.5Z",
    fill: "#EEEEEE"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M1828.87 1176.5L1893.9 1150.87L1901.88 1171.12L1836.85 1196.76L1828.87 1176.5Z",
    fill: "#FF1717"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M1885.87 1317.5L1950.9 1291.87L1958.88 1312.12L1893.85 1337.76L1885.87 1317.5Z",
    fill: "#6CDD59"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M1840.87 1204.5L1905.9 1178.87L1913.88 1199.12L1848.85 1224.76L1840.87 1204.5Z",
    fill: "#6CDD59"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M1896.87 1345.5L1961.9 1319.87L1969.88 1340.12L1904.85 1365.76L1896.87 1345.5Z",
    fill: "#6CDD59"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M1835.87 1403.08L1900.25 1375.87L1908.73 1395.92L1844.34 1423.13L1835.87 1403.08Z",
    fill: "#6CDD59"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M1845.87 1432.08L1910.25 1404.87L1918.73 1424.92L1854.34 1452.13L1845.87 1432.08Z",
    fill: "#6CDD59"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M1858.83 1457.71L1921.57 1431.94L1929.84 1452.07L1867.11 1477.85L1858.83 1457.71Z",
    fill: "#FE763B"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M1907.87 1373.31L1972.57 1346.87L1980.81 1367.02L1916.1 1393.46L1907.87 1373.31Z",
    fill: "#6CDD59"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M1918.87 1401.5L1983.9 1375.87L1991.88 1396.12L1926.85 1421.76L1918.87 1401.5Z",
    fill: "#6CDD59"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M1975.87 1541.5L2040.9 1515.87L2048.88 1536.12L1983.85 1561.76L1975.87 1541.5Z",
    fill: "#6CDD59"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M1929.87 1429.5L1994.9 1403.87L2002.88 1424.12L1937.85 1449.76L1929.87 1429.5Z",
    fill: "#6CDD59"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M1941.87 1457.5L2006.9 1431.87L2014.88 1452.12L1949.85 1477.76L1941.87 1457.5Z",
    fill: "#6CDD59"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M1953.87 1485.5L2018.9 1459.87L2026.88 1480.12L1961.85 1505.76L1953.87 1485.5Z",
    fill: "#6CDD59"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M1540.99 1264.08L1604.55 1236.87L1612.92 1256.92L1549.36 1284.13L1540.99 1264.08Z",
    fill: "#6CDD59"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M1596.27 1405.08L1659.83 1377.87L1668.2 1397.92L1604.64 1425.13L1596.27 1405.08Z",
    fill: "#6CDD59"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.86 1293.08L1614.42 1265.87L1622.79 1285.92L1559.23 1313.13L1550.86 1293.08Z",
    fill: "#FF1717"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M1606.14 1433.08L1669.7 1405.87L1678.07 1425.92L1614.51 1453.13L1606.14 1433.08Z",
    fill: "#EDEDEE"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.71 1321.08L1626.27 1293.87L1634.63 1313.92L1571.07 1341.13L1562.71 1321.08Z",
    fill: "#EDEDEE"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M1617.99 1461.08L1681.55 1433.87L1689.91 1453.92L1626.35 1481.13L1617.99 1461.08Z",
    fill: "#FE763B"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M1573.57 1349.08L1637.13 1321.87L1645.49 1341.92L1581.93 1369.13L1573.57 1349.08Z",
    fill: "#6CDD59"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M1629.83 1490.08L1693.39 1462.87L1701.76 1482.92L1638.2 1510.13L1629.83 1490.08Z",
    fill: "#6CDD59"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M1584.42 1377.08L1647.98 1349.87L1656.35 1369.92L1592.79 1397.13L1584.42 1377.08Z",
    fill: "#EEEEEE"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M1640.69 1518.08L1704.25 1490.87L1712.62 1510.92L1649.06 1538.13L1640.69 1518.08Z",
    fill: "#EDEDEE"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.87 1235.03L1673.1 1209.91L1681.25 1230.1L1619.01 1255.22L1610.87 1235.03Z",
    fill: "#EEEEEE"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M1666.87 1376.69L1728.07 1350.14L1736.73 1370.11L1675.53 1396.66L1666.87 1376.69Z",
    fill: "#6CDD59"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M1620.87 1262.5L1683.34 1237.88L1691.32 1258.13L1628.85 1282.76L1620.87 1262.5Z",
    fill: "#6CDD59"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M1676.87 1402.5L1740.31 1377.49L1748.29 1397.75L1684.85 1422.76L1676.87 1402.5Z",
    fill: "#6CDD59"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M1632.87 1289.5L1694.23 1265.31L1702.22 1285.57L1640.85 1309.76L1632.87 1289.5Z",
    fill: "#6CDD59"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M1688.87 1430.5L1751.81 1405.69L1759.8 1425.94L1696.85 1450.76L1688.87 1430.5Z",
    fill: "#EDEDEE"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M1642.87 1319.5L1707.9 1293.87L1715.88 1314.12L1650.85 1339.76L1642.87 1319.5Z",
    fill: "#EDEDEE"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.87 1459.5L1763.74 1434.72L1771.73 1454.97L1708.85 1479.76L1700.87 1459.5Z",
    fill: "#FF1717"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M1655.87 1346.5L1718.22 1321.92L1726.21 1342.18L1663.85 1366.76L1655.87 1346.5Z",
    fill: "#6CDD59"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M1710.87 1487.5L1773.97 1462.62L1781.96 1482.88L1718.85 1507.76L1710.87 1487.5Z",
    fill: "#6CDD59"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M1652.54 1546.08L1716.1 1518.87L1724.46 1538.92L1660.9 1566.13L1652.54 1546.08Z",
    fill: "#6CDD59"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M1663.39 1575.08L1726.95 1547.87L1735.32 1567.92L1671.76 1595.13L1663.39 1575.08Z",
    fill: "#6CDD59"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M1674.25 1602.08L1737.81 1574.87L1746.18 1594.92L1682.62 1622.13L1674.25 1602.08Z",
    fill: "#FE763B"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M1723.87 1516.12L1786.39 1491.89L1794.26 1512.2L1731.73 1536.42L1723.87 1516.12Z",
    fill: "#6CDD59"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M1733.87 1544.5L1796.02 1520L1804.01 1540.25L1741.85 1564.76L1733.87 1544.5Z",
    fill: "#6CDD59"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M1745.87 1571.5L1808.69 1546.74L1816.68 1566.99L1753.85 1591.76L1745.87 1571.5Z",
    fill: "#6CDD59"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M1755.87 1601.5L1820.9 1575.87L1828.88 1596.12L1763.85 1621.76L1755.87 1601.5Z",
    fill: "#FF1717"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M1768.87 1628.5L1831.68 1603.74L1839.66 1624L1776.85 1648.76L1768.87 1628.5Z",
    fill: "#6CDD59"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M1349.87 1404.08L1414.25 1376.87L1422.73 1396.92L1358.34 1424.13L1349.87 1404.08Z",
    fill: "#EEEEEE"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.87 1546.08L1471.25 1518.87L1479.73 1538.92L1415.34 1566.13L1406.87 1546.08Z",
    fill: "#6CDD59"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.87 1433.08L1425.25 1405.87L1433.73 1425.92L1369.34 1453.13L1360.87 1433.08Z",
    fill: "#EEEEEE"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.87 1574.08L1482.25 1546.87L1490.73 1566.92L1426.34 1594.13L1417.87 1574.08Z",
    fill: "#EEEEEE"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.87 1461.08L1436.25 1433.87L1444.73 1453.92L1380.34 1481.13L1371.87 1461.08Z",
    fill: "#FE763B"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.87 1602.08L1493.25 1574.87L1501.73 1594.92L1437.34 1622.13L1428.87 1602.08Z",
    fill: "#EEEEEE"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.8 1487.39L1448.69 1461.4L1456.79 1481.61L1391.9 1507.6L1383.8 1487.39Z",
    fill: "#6CDD59"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.87 1630.08L1505.25 1602.87L1513.73 1622.92L1449.34 1650.13L1440.87 1630.08Z",
    fill: "#6CDD59"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M1394.87 1517.08L1459.25 1489.87L1467.73 1509.92L1403.34 1537.13L1394.87 1517.08Z",
    fill: "#FE763B"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.87 1658.08L1516.25 1630.87L1524.73 1650.92L1460.34 1678.13L1451.87 1658.08Z",
    fill: "#EEEEEE"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M1422.87 1373.75L1483.97 1350.48L1491.72 1370.82L1430.61 1394.09L1422.87 1373.75Z",
    fill: "#EEEEEE"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M1478.87 1516.69L1538.71 1490.73L1547.37 1510.7L1487.53 1536.66L1478.87 1516.69Z",
    fill: "#6CDD59"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.87 1402.38L1496.03 1377.87L1504.01 1398.12L1441.85 1422.63L1433.87 1402.38Z",
    fill: "#6CDD59"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.87 1544.5L1551.91 1520.44L1559.89 1540.69L1498.85 1564.76L1490.87 1544.5Z",
    fill: "#6CDD59"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.87 1430.5L1504.8 1406.88L1512.78 1427.13L1452.85 1450.76L1444.87 1430.5Z",
    fill: "#6CDD59"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M1501.87 1572.5L1563.11 1548.36L1571.09 1568.61L1509.85 1592.76L1501.87 1572.5Z",
    fill: "#EEEEEE"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M1456.87 1459.5L1517.03 1435.78L1525.02 1456.04L1464.85 1479.76L1456.87 1459.5Z",
    fill: "#EEEEEE"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.87 1600.5L1573.49 1575.82L1581.48 1596.07L1518.85 1620.76L1510.87 1600.5Z",
    fill: "#EEEEEE"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M1467.87 1486.5L1526.85 1463.25L1534.84 1483.5L1475.85 1506.76L1467.87 1486.5Z",
    fill: "#6CDD59"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M1524.87 1628.5L1585.24 1604.29L1593.09 1624.54L1532.71 1648.76L1524.87 1628.5Z",
    fill: "#6CDD59"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.87 1687.08L1527.25 1659.87L1535.73 1679.92L1471.34 1707.13L1462.87 1687.08Z",
    fill: "#6CDD59"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.87 1714.08L1538.25 1686.87L1546.73 1706.92L1482.34 1734.13L1473.87 1714.08Z",
    fill: "#6CDD59"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.87 1743.08L1550.25 1715.87L1558.73 1735.92L1494.34 1763.13L1485.87 1743.08Z",
    fill: "#FE763B"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.68 1657.69L1594.96 1631.52L1603.48 1651.5L1544.19 1677.66L1535.68 1657.69Z",
    fill: "#6CDD59"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M1546.49 1684.5L1607.33 1660.1L1615.18 1680.36L1554.34 1704.76L1546.49 1684.5Z",
    fill: "#6CDD59"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M1558.28 1712.5L1618.75 1688.25L1626.6 1708.51L1566.13 1732.76L1558.28 1712.5Z",
    fill: "#6CDD59"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M1569.1 1741.5L1630.23 1716.98L1638.08 1737.24L1576.95 1761.76L1569.1 1741.5Z",
    fill: "#FF1717"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.8 1574.3L1237.88 1548.82L1245.92 1569.05L1181.84 1594.53L1173.8 1574.3Z",
    fill: "#ECECEF"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.16 1715.11L1292.25 1688.87L1300.73 1708.92L1238.64 1735.16L1230.16 1715.11Z",
    fill: "#ECECEF"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.87 1603.08L1248.25 1575.87L1256.73 1595.92L1192.34 1623.13L1183.87 1603.08Z",
    fill: "#ECECEF"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.1 1742.5L1303.53 1716.87L1311.8 1737.01L1249.37 1762.64L1241.1 1742.5Z",
    fill: "#FF1717"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.81 1630.5L1259.57 1604.74L1267.73 1624.92L1203.97 1650.69L1195.81 1630.5Z",
    fill: "#FE763B"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.04 1770.07L1315.58 1744.26L1323.78 1764.43L1260.24 1790.24L1252.04 1770.07Z",
    fill: "#6CDD59"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.54 1658.8L1270.25 1631.87L1278.73 1651.93L1215.01 1678.85L1206.54 1658.8Z",
    fill: "#6CDD59"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.92 1798.8L1326.86 1773.87L1334.87 1794.11L1271.94 1819.04L1263.92 1798.8Z",
    fill: "#6CDD59"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.81 1686.48L1282.35 1660.85L1290.5 1681.04L1226.96 1706.67L1218.81 1686.48Z",
    fill: "#FE763B"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.38 1827.63L1338.78 1802.51L1346.8 1822.75L1283.4 1847.87L1275.38 1827.63Z",
    fill: "#FF1717"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.87 1544.9L1306.04 1520.35L1314.24 1540.8L1253.07 1565.35L1244.87 1544.9Z",
    fill: "#ECECEF"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.87 1686.69L1362.11 1660.12L1370.77 1680.09L1309.53 1706.66L1300.87 1686.69Z",
    fill: "#6CDD59"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.87 1573.5L1317.52 1549.2L1325.51 1569.45L1263.85 1593.76L1255.87 1573.5Z",
    fill: "#6CDD59"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.87 1714.11L1374.48 1689.82L1382.47 1710.07L1320.85 1734.36L1312.87 1714.11Z",
    fill: "#6CDD59"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.87 1600.5L1328.11 1576.36L1336.1 1596.61L1274.85 1620.76L1266.87 1600.5Z",
    fill: "#6CDD59"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.87 1742.38L1385.59 1717.08L1393.84 1737.22L1332.12 1762.53L1323.87 1742.38Z",
    fill: "#FF1717"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.87 1629.51L1340.02 1605.4L1348.01 1625.65L1286.85 1649.76L1278.87 1629.51Z",
    fill: "#ECECEF"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.87 1769.5L1396.09 1745.37L1404.07 1765.62L1342.85 1789.76L1334.87 1769.5Z",
    fill: "#ECECEF"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.87 1657.5L1352.05 1632.99L1360.04 1653.24L1297.85 1677.76L1289.87 1657.5Z",
    fill: "#6CDD59"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.87 1798.5L1407.56 1774.58L1415.54 1794.83L1354.85 1818.76L1346.87 1798.5Z",
    fill: "#6CDD59"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.87 1855.49L1350.5 1828.87L1358.79 1849L1294.16 1875.62L1285.87 1855.49Z",
    fill: "#6CDD59"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.77 1825.7L1418.41 1801.33L1426.53 1821.53L1365.89 1845.9L1357.77 1825.7Z",
    fill: "#6CDD59"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.6 1768.92L1069.25 1742.87L1077.73 1762.92L1016.07 1788.98L1007.6 1768.92Z",
    fill: "#6CDD59"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.77 1909.27L1126.25 1882.87L1134.73 1902.92L1072.24 1929.33L1063.77 1909.27Z",
    fill: "#6CDD59"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.86 1796.88L1080.88 1772.63L1088.81 1792.91L1026.79 1817.16L1018.86 1796.88Z",
    fill: "#6CDD59"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.46 1936.2L1136.78 1911.51L1144.8 1931.75L1082.48 1956.44L1074.46 1936.2Z",
    fill: "#FF1717"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.78 1824.89L1091.63 1800.32L1099.78 1820.5L1038.93 1845.08L1030.78 1824.89Z",
    fill: "#FE763B"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.81 1852.83L1102.25 1826.87L1110.73 1846.92L1049.29 1872.89L1040.81 1852.83Z",
    fill: "#6CDD59"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.19 1881.09L1114.25 1854.87L1122.73 1874.92L1060.66 1901.15L1052.19 1881.09Z",
    fill: "#EFEFEF"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.77 1739.7L1139.44 1714.51L1147.55 1734.71L1084.89 1759.9L1076.77 1739.7Z",
    fill: "#EFEFEF"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.81 1881.11L1194.99 1855.29L1203.34 1875.4L1141.16 1901.22L1132.81 1881.11Z",
    fill: "#6CDD59"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.87 1768.5L1150.68 1743.74L1158.67 1763.99L1095.85 1788.76L1087.87 1768.5Z",
    fill: "#6CDD59"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.87 1908.5L1206.97 1883.63L1214.96 1903.88L1151.85 1928.76L1143.87 1908.5Z",
    fill: "#6CDD59"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.87 1796.5L1162.6 1771.77L1170.58 1792.03L1107.85 1816.76L1099.87 1796.5Z",
    fill: "#6CDD59"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.87 1824.5L1172.98 1799.62L1180.96 1819.88L1117.85 1844.76L1109.87 1824.5Z",
    fill: "#EFEFEF"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.87 1852.5L1184.9 1828.05L1192.88 1848.3L1130.85 1872.76L1122.87 1852.5Z",
    fill: "#6CDD59"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.87 2134.98L1215.25 2107.77L1223.73 2127.83L1159.34 2155.04L1150.87 2134.98Z",
    fill: "#C6C7C6"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.87 924.867L1046.87 896.867L992.365 948.367L993.365 949.367L1056.87 924.867Z",
    fill: "#6CDD59"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1047.08 895.977L1057.5 925.157L993.242 949.95L991.648 948.356L1047.08 895.977ZM993.083 948.376L993.489 948.782L1056.23 924.575L1046.65 897.755L993.083 948.376Z",
    fill: "#6CDD59"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.43 1111.03C1095.25 1123.03 1089.43 1136.67 1077.44 1141.49C1065.44 1146.32 1051.8 1140.5 1046.98 1128.5C1042.15 1116.5 1047.97 1102.86 1059.97 1098.04C1071.97 1093.22 1085.61 1099.04 1090.43 1111.03Z",
    fill: "white"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1074.08 1133.14C1081.47 1130.17 1085.05 1121.78 1082.08 1114.39C1079.11 1107 1070.71 1103.42 1063.33 1106.39C1055.94 1109.36 1052.36 1117.76 1055.33 1125.14C1058.3 1132.53 1066.69 1136.11 1074.08 1133.14ZM1077.44 1141.49C1089.43 1136.67 1095.25 1123.03 1090.43 1111.03C1085.61 1099.04 1071.97 1093.22 1059.97 1098.04C1047.97 1102.86 1042.15 1116.5 1046.98 1128.5C1051.8 1140.5 1065.44 1146.32 1077.44 1141.49Z",
    fill: "#A2A2A2"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M2177.87 222.867L2112.87 248.867L2120.37 266.867L2185.37 241.867L2177.87 222.867Z",
    fill: "#6CDD59"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2178.15 222.215L2186.02 242.151L2120.09 267.507L2112.21 248.59L2178.15 222.215ZM2113.52 249.141L2120.64 266.224L2184.72 241.58L2177.58 223.516L2113.52 249.141Z",
    fill: "#6CDD59"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M2358.87 671.867L2294.87 697.867L2302.37 717.367L2366.87 691.867L2358.87 671.867Z",
    fill: "#6CDD59"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2359.14 671.215L2367.52 692.148L2302.08 718.018L2294.22 697.589L2359.14 671.215ZM2295.51 698.146L2302.65 716.717L2366.21 691.587L2358.59 672.52L2295.51 698.146Z",
    fill: "#6CDD59"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M2187.87 249.867L2124.37 276.867L2131.37 294.867L2195.87 268.867L2187.87 249.867Z",
    fill: "#6CDD59"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2188.13 249.211L2196.52 269.141L2131.08 295.52L2123.72 276.597L2188.13 249.211ZM2125.01 277.138L2131.65 294.214L2195.21 268.593L2187.6 250.524L2125.01 277.138Z",
    fill: "#6CDD59"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M2381.37 728.367L2317.87 755.367L2324.87 773.367L2389.37 747.367L2381.37 728.367Z",
    fill: "#EEEEEE"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2381.63 727.711L2390.02 747.641L2324.58 774.02L2317.22 755.097L2381.63 727.711ZM2318.51 755.638L2325.15 772.714L2388.71 747.093L2381.1 729.024L2318.51 755.638Z",
    fill: "#6CDD59"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M2199.87 278.867L2133.87 303.867L2143.37 324.867L2207.37 297.867L2199.87 278.867Z",
    fill: "#FF1717"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2200.15 278.223L2208.01 298.136L2143.11 325.515L2133.19 303.586L2200.15 278.223ZM2134.54 304.144L2143.62 324.215L2206.72 297.594L2199.58 279.507L2134.54 304.144Z",
    fill: "#6CDD59"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M2404.37 785.367L2338.37 810.367L2347.87 831.367L2411.87 804.367L2404.37 785.367Z",
    fill: "#FE763B"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M2427.37 841.367L2361.37 866.367L2370.87 887.367L2434.87 860.367L2427.37 841.367Z",
    fill: "#FF1717"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2427.65 840.723L2435.51 860.636L2370.61 888.015L2360.69 866.086L2427.65 840.723ZM2362.04 866.644L2371.12 886.715L2434.22 860.094L2427.08 842.007L2362.04 866.644Z",
    fill: "#6CDD59"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M2244.87 391.867L2178.87 416.867L2188.37 437.867L2252.37 410.867L2244.87 391.867Z",
    fill: "#6CDD59"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M2450.37 898.367L2384.37 923.367L2393.87 944.367L2457.87 917.367L2450.37 898.367Z",
    fill: "#6CDD59"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2450.65 897.727L2458.51 917.64L2393.61 945.019L2383.69 923.09L2450.65 897.727ZM2385.04 923.648L2394.12 943.719L2457.22 917.098L2450.08 899.011L2385.04 923.648Z",
    fill: "#6CDD59"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M2267.87 447.867L2203.37 473.867L2211.37 493.867L2275.37 466.867L2267.87 447.867Z",
    fill: "#6CDD59"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2268.15 447.215L2276.01 467.138L2211.09 494.526L2202.72 473.59L2268.15 447.215ZM2204.01 474.144L2211.64 493.208L2274.72 466.596L2267.59 448.519L2204.01 474.144Z",
    fill: "#6CDD59"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M2572.37 1207.87L2508.37 1234.37L2515.87 1253.87L2579.87 1226.87L2572.37 1207.87Z",
    fill: "#6CDD59"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2572.64 1207.21L2580.51 1227.14L2515.58 1254.53L2507.72 1234.09L2572.64 1207.21ZM2509.01 1234.64L2516.15 1253.21L2579.22 1226.6L2572.09 1208.52L2509.01 1234.64Z",
    fill: "#6CDD59"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M2290.87 503.867L2225.87 529.867L2234.37 549.867L2298.37 522.867L2290.87 503.867Z",
    fill: "#FE763B"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M2484.37 982.367L2419.37 1008.37L2427.87 1028.37L2491.87 1001.37L2484.37 982.367Z",
    fill: "#6CDD59"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2484.65 981.715L2492.51 1001.64L2427.6 1029.02L2418.71 1008.09L2484.65 981.715ZM2420.02 1008.64L2428.13 1027.71L2491.22 1001.09L2484.08 983.016L2420.02 1008.64Z",
    fill: "#6CDD59"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M2301.87 531.867L2237.37 558.367L2245.37 577.867L2309.37 550.867L2301.87 531.867Z",
    fill: "#6CDD59"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2302.14 531.211L2310.01 551.137L2245.09 578.523L2236.71 558.094L2302.14 531.211ZM2238.02 558.639L2245.64 577.209L2308.72 550.595L2301.59 532.521L2238.02 558.639Z",
    fill: "#6CDD59"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M2313.31 560.867L2248.37 586.867L2255.87 605.367L2320.37 578.867L2313.31 560.867Z",
    fill: "#6CDD59"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2313.6 560.215L2321.01 579.142L2255.59 606.02L2247.71 586.589L2313.6 560.215ZM2249.02 587.144L2256.14 604.713L2319.72 578.591L2313.03 561.518L2249.02 587.144Z",
    fill: "#6CDD59"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M2324.31 587.867L2259.87 614.867L2267.37 632.867L2331.87 606.867L2324.31 587.867Z",
    fill: "#EBEDEE"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2324.59 587.207L2332.51 607.143L2267.09 633.514L2259.21 614.597L2324.59 587.207ZM2260.52 615.133L2267.64 632.216L2331.22 606.587L2324.04 588.523L2260.52 615.133Z",
    fill: "#6CDD59"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M2517.81 1066.37L2453.37 1093.37L2460.87 1111.37L2525.37 1085.37L2517.81 1066.37Z",
    fill: "#6CDD59"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2518.09 1065.71L2526.01 1085.64L2460.59 1112.01L2452.71 1093.1L2518.09 1065.71ZM2454.02 1093.63L2461.14 1110.72L2524.72 1085.09L2517.54 1067.02L2454.02 1093.63Z",
    fill: "#6CDD59"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M2618.31 1319.87L2553.87 1345.87L2561.37 1364.87L2625.87 1338.87L2618.31 1319.87Z",
    fill: "#6CDD59"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2618.59 1319.21L2626.51 1339.14L2561.08 1365.52L2553.22 1345.59L2618.59 1319.21ZM2554.51 1346.14L2561.65 1364.21L2625.22 1338.59L2618.04 1320.52L2554.51 1346.14Z",
    fill: "#6CDD59"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M2335.31 616.867L2271.37 642.367L2278.37 660.867L2342.87 635.867L2335.31 616.867Z",
    fill: "#6CDD59"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2335.59 616.219L2343.52 636.153L2278.08 661.517L2270.72 642.086L2335.59 616.219ZM2272.01 642.651L2278.65 660.22L2342.21 635.585L2335.03 617.518L2272.01 642.651Z",
    fill: "#6CDD59"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M2528.81 1095.37L2464.87 1120.87L2471.87 1139.37L2536.37 1114.37L2528.81 1095.37Z",
    fill: "#FE763B"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M2640.81 1376.87L2576.87 1402.37L2583.87 1420.87L2648.37 1395.87L2640.81 1376.87Z",
    fill: "#6CDD59"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2641.09 1376.22L2649.02 1396.15L2583.58 1421.52L2576.22 1402.09L2641.09 1376.22ZM2577.51 1402.65L2584.15 1420.22L2647.71 1395.58L2640.53 1377.52L2577.51 1402.65Z",
    fill: "#6CDD59"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M2594.79 1510.3L2573.32 1456.86L2554.37 1464.66L2575.84 1518.16L2594.79 1510.3Z",
    fill: "#6CDD59"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2595.44 1510.58L2575.56 1518.82L2553.72 1464.39L2573.59 1456.21L2595.44 1510.58ZM2573.04 1457.52L2555.02 1464.94L2576.12 1517.51L2594.14 1510.03L2573.04 1457.52Z",
    fill: "#6CDD59"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M2450.58 1570.96L2428.2 1515.91L2406.21 1522.96L2428.58 1578.08L2450.58 1570.96Z",
    fill: "#6CDD59"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2451.24 1571.27L2428.29 1578.69L2405.55 1522.65L2428.49 1515.29L2451.24 1571.27ZM2427.92 1516.52L2406.88 1523.27L2428.87 1577.46L2449.91 1570.65L2427.92 1516.52Z",
    fill: "#6CDD59"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M2314.34 1624.45L2292.87 1571.01L2273.92 1578.81L2295.39 1632.31L2314.34 1624.45Z",
    fill: "#6CDD59"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2314.99 1624.72L2295.11 1632.96L2273.27 1578.54L2293.14 1570.35L2314.99 1624.72ZM2292.59 1571.66L2274.56 1579.08L2295.66 1631.65L2313.69 1624.18L2292.59 1571.66Z",
    fill: "#6CDD59"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M2227.34 1660.45L2205.87 1607.01L2186.92 1614.81L2208.39 1668.31L2227.34 1660.45Z",
    fill: "#6CDD59"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2227.99 1660.72L2208.11 1668.96L2186.27 1614.54L2206.14 1606.35L2227.99 1660.72ZM2205.59 1607.66L2187.56 1615.08L2208.66 1667.65L2226.69 1660.18L2205.59 1607.66Z",
    fill: "#6CDD59"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M1821.74 1823.11L1800.27 1769.67L1781.32 1777.47L1802.79 1830.97L1821.74 1823.11Z",
    fill: "#6CDD59"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1822.39 1823.39L1802.52 1831.63L1780.67 1777.2L1800.55 1769.02L1822.39 1823.39ZM1799.99 1770.32L1781.97 1777.75L1803.07 1830.31L1821.09 1822.84L1799.99 1770.32Z",
    fill: "#6CDD59"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M1708.12 1869.63L1686.13 1815.1L1666.17 1822.84L1688.16 1877.43L1708.12 1869.63Z",
    fill: "#6CDD59"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1708.77 1869.91L1687.88 1878.07L1665.52 1822.56L1686.41 1814.45L1708.77 1869.91ZM1685.85 1815.74L1666.82 1823.12L1688.43 1876.78L1707.46 1869.35L1685.85 1815.74Z",
    fill: "#6CDD59"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M1567.86 1925.37L1545.86 1870.37L1524.36 1878.87L1546.36 1933.87L1567.86 1925.37Z",
    fill: "#6CDD59"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1568.52 1925.65L1546.09 1934.51L1523.71 1878.59L1546.14 1869.72L1568.52 1925.65ZM1545.59 1871.01L1525.02 1879.15L1546.64 1933.22L1567.21 1925.09L1545.59 1871.01Z",
    fill: "#6CDD59"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.87 2013.87L1346.87 1949.87L1329 1957.53L1354.87 2020.87L1371.87 2013.87Z",
    fill: "#6CDD59"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1372.51 2014.14L1354.59 2021.52L1328.35 1957.26L1347.14 1949.21L1372.51 2014.14ZM1346.59 1950.53L1329.65 1957.79L1355.14 2020.22L1371.22 2013.59L1346.59 1950.53Z",
    fill: "#6CDD59"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.43 2070.18L1207.87 2006.37L1187.35 2013.36L1212.87 2076.87L1234.43 2070.18Z",
    fill: "#6CDD59"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1235.11 2070.49L1212.57 2077.48L1186.69 2013.06L1208.15 2005.74L1235.11 2070.49ZM1207.58 2006.99L1188.01 2013.67L1213.16 2076.25L1233.76 2069.86L1207.58 2006.99Z",
    fill: "#6CDD59"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M822.865 2235.37L798.373 2172.51L779.424 2180.32L804.365 2243.37L822.865 2235.37Z",
    fill: "#6CDD59"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.506 2235.63L804.09 2244.03L778.777 2180.04L798.654 2171.86L823.506 2235.63ZM798.092 2173.17L780.07 2180.59L804.64 2242.7L822.224 2235.1L798.092 2173.17Z",
    fill: "#6CDD59"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M571.865 2338.37L545.853 2274.41L526.904 2282.21L552.916 2346.22L571.865 2338.37Z",
    fill: "#6CDD59"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M572.516 2338.64L552.643 2346.88L526.253 2281.94L546.127 2273.76L572.516 2338.64ZM545.579 2275.06L527.555 2282.49L553.19 2345.57L571.215 2338.1L545.579 2275.06Z",
    fill: "#6CDD59"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M515.814 2360.01L489.744 2297.35L470.795 2305.16L496.865 2367.87L515.814 2360.01Z",
    fill: "#6CDD59"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.469 2360.28L496.596 2368.52L470.141 2304.88L490.015 2296.7L516.469 2360.28ZM489.474 2298L471.45 2305.42L497.136 2367.21L515.161 2359.74L489.474 2298Z",
    fill: "#6CDD59"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M487.365 2371.87L461.683 2308.54L442.734 2316.34L468.416 2379.72L487.365 2371.87Z",
    fill: "#6CDD59"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.014 2372.14L468.141 2380.38L442.083 2316.07L461.957 2307.88L488.014 2372.14ZM461.408 2309.19L443.384 2316.61L468.69 2379.07L486.715 2371.59L461.408 2309.19Z",
    fill: "#6CDD59"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M347.814 2428.51L321.76 2365.04L302.811 2372.84L328.865 2436.37L347.814 2428.51Z",
    fill: "#6CDD59"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.465 2428.78L328.593 2437.02L302.159 2372.57L322.033 2364.39L348.465 2428.78ZM321.488 2365.69L303.463 2373.11L329.137 2435.71L347.162 2428.24L321.488 2365.69Z",
    fill: "#6CDD59"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M235.865 2474.37L209.446 2409.65L190.497 2417.45L216.916 2482.23L235.865 2474.37Z",
    fill: "#6CDD59"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.516 2474.64L216.643 2482.88L189.846 2417.18L209.72 2408.99L236.516 2474.64ZM209.173 2410.3L191.148 2417.72L217.189 2481.57L235.214 2474.1L209.173 2410.3Z",
    fill: "#6CDD59"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M147.438 2336.33L100.291 2314.29L91.9062 2332.99L139.348 2354.97L147.438 2336.33Z",
    fill: "#6CDD59"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.09 2336.08L139.602 2355.64L91.2479 2333.24L100.042 2313.62L148.09 2336.08ZM100.539 2314.96L92.5645 2332.75L139.093 2354.3L146.786 2336.58L100.539 2314.96Z",
    fill: "#6CDD59"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M225.537 2169.94L169.365 2142.87L160.98 2161.57L217.446 2188.58L225.537 2169.94Z",
    fill: "#6CDD59"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.187 2169.7L217.699 2189.26L160.325 2161.81L169.12 2142.19L226.187 2169.7ZM169.612 2143.54L161.637 2161.33L217.195 2187.91L224.887 2170.18L169.612 2143.54Z",
    fill: "#6CDD59"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M267.19 2088.74L211.25 2062.67L202.865 2081.37L259.099 2107.39L267.19 2088.74Z",
    fill: "#6CDD59"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.843 2088.49L259.355 2108.05L202.207 2081.61L211.002 2062L267.843 2088.49ZM211.499 2063.33L203.524 2081.12L258.845 2106.72L266.538 2088.99L211.499 2063.33Z",
    fill: "#6CDD59"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M279.381 2060.89L225.365 2034.37L216.981 2053.07L271.29 2079.53L279.381 2060.89Z",
    fill: "#6CDD59"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.029 2060.65L271.541 2080.21L216.326 2053.3L225.121 2033.69L280.029 2060.65ZM225.609 2035.04L217.635 2052.83L271.039 2078.85L278.732 2061.12L225.609 2035.04Z",
    fill: "#6CDD59"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M711.366 2281.37L686.366 2219.37L667.866 2227.37L692.366 2288.87L711.366 2281.37Z",
    fill: "#FE763B"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M1763.29 1847.85L1741.03 1792.05L1721.4 1800.19L1743.65 1856.05L1763.29 1847.85Z",
    fill: "#FE763B"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M2017.13 1745.07L1995.04 1688.95L1975.54 1697.15L1997.64 1753.32L2017.13 1745.07Z",
    fill: "#FE763B"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M2539.69 1533.19L2518.21 1478.9L2499.27 1486.82L2520.74 1541.17L2539.69 1533.19Z",
    fill: "#FE763B"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M1931.22 1778.92L1909.74 1725.47L1890.79 1733.28L1912.27 1786.77L1931.22 1778.92Z",
    fill: "#FF1717"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M1652.04 1892.16L1630.57 1838.71L1608.39 1847.37L1629.87 1900.87L1652.04 1892.16Z",
    fill: "#FF1717"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M1536.86 1937.87L1515.31 1882.86L1497.86 1889.87L1519.86 1944.87L1536.86 1937.87Z",
    fill: "#FF1717"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M962.866 2178.37L938.366 2117.87L918.691 2124.94L943.865 2186.37L962.866 2178.37Z",
    fill: "#FF1717"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M2392.97 1593.29L2371.5 1539.85L2352.55 1547.65L2374.02 1601.15L2392.97 1593.29Z",
    fill: "#FF1717"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M1616.37 322.367L1594.37 287.867L1613.87 277.367L1633.37 312.367L1616.37 322.367Z",
    fill: "#6CDD59"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1614.06 276.691L1634.04 312.549L1616.2 323.041L1593.65 287.68L1614.06 276.691ZM1595.08 288.05L1616.53 321.69L1632.69 312.182L1613.67 278.039L1595.08 288.05Z",
    fill: "#6CDD59"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.37 338.867L1566.87 304.367L1586.37 292.867L1607.87 327.867L1589.37 338.867Z",
    fill: "#6CDD59"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1586.53 292.188L1608.56 328.038L1589.21 339.543L1566.16 304.203L1586.53 292.188ZM1567.57 304.533L1589.52 338.193L1607.17 327.697L1586.2 293.548L1567.57 304.533Z",
    fill: "#FE763B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.0781,
    y: 2592.58,
    width: 454.149,
    height: 118,
    rx: 10,
    transform: "rotate(-20.9769 47.0781 2592.58)",
    fill: "#FE763B"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M129.923 2640.44L118.078 2609.93L126.361 2606.71L135.614 2630.55L147.949 2625.76L150.54 2632.43L129.923 2640.44Z",
    fill: "white"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M165.193 2627.22C162.71 2628.19 160.394 2628.52 158.244 2628.22C156.091 2627.92 154.199 2627.06 152.57 2625.66C150.936 2624.25 149.664 2622.37 148.754 2620.03C147.844 2617.68 147.518 2615.45 147.775 2613.31C148.028 2611.17 148.848 2609.26 150.234 2607.59C151.616 2605.91 153.549 2604.59 156.032 2603.63C158.515 2602.66 160.833 2602.33 162.986 2602.64C165.135 2602.94 167.027 2603.79 168.661 2605.2C170.29 2606.6 171.56 2608.48 172.47 2610.82C173.38 2613.17 173.708 2615.41 173.455 2617.55C173.198 2619.69 172.378 2621.59 170.996 2623.27C169.61 2624.94 167.675 2626.26 165.193 2627.22ZM162.893 2621.12C163.588 2620.85 164.098 2620.39 164.423 2619.72C164.749 2619.06 164.883 2618.24 164.825 2617.27C164.768 2616.3 164.508 2615.22 164.045 2614.02C163.579 2612.82 163.04 2611.85 162.431 2611.1C161.817 2610.35 161.167 2609.83 160.479 2609.56C159.791 2609.29 159.1 2609.29 158.405 2609.56C157.67 2609.85 157.13 2610.33 156.785 2611C156.439 2611.67 156.296 2612.49 156.353 2613.46C156.406 2614.42 156.666 2615.51 157.133 2616.71C157.596 2617.9 158.134 2618.87 158.747 2619.63C159.361 2620.38 160.021 2620.89 160.729 2621.16C161.436 2621.42 162.158 2621.41 162.893 2621.12Z",
    fill: "white"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M184.988 2592.73L187.301 2598.69L172.225 2604.54L169.912 2598.58L184.988 2592.73ZM170.704 2591.97L178.927 2588.77L187.081 2609.78C187.205 2610.1 187.363 2610.34 187.557 2610.52C187.748 2610.68 187.978 2610.78 188.249 2610.8C188.516 2610.81 188.828 2610.74 189.186 2610.61C189.434 2610.51 189.71 2610.37 190.015 2610.18C190.33 2609.99 190.559 2609.84 190.702 2609.74L194.138 2615.06C193.813 2615.31 193.338 2615.65 192.715 2616.08C192.101 2616.5 191.337 2616.91 190.423 2617.33C188.575 2618.16 186.915 2618.58 185.445 2618.59C183.971 2618.59 182.705 2618.18 181.647 2617.37C180.589 2616.56 179.76 2615.35 179.159 2613.74L170.704 2591.97Z",
    fill: "white"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M226.544 2580.98L218.143 2584.24C217.813 2583.57 217.409 2583 216.931 2582.54C216.463 2582.07 215.927 2581.72 215.322 2581.48C214.723 2581.24 214.068 2581.12 213.358 2581.15C212.643 2581.16 211.889 2581.32 211.094 2581.63C209.704 2582.17 208.658 2582.97 207.957 2584.02C207.266 2585.06 206.917 2586.31 206.91 2587.77C206.913 2589.22 207.258 2590.82 207.944 2592.59C208.669 2594.46 209.524 2595.93 210.511 2597C211.503 2598.05 212.599 2598.71 213.799 2598.98C214.996 2599.23 216.264 2599.1 217.605 2598.58C218.37 2598.28 219.018 2597.92 219.551 2597.5C220.079 2597.06 220.496 2596.58 220.8 2596.03C221.104 2595.49 221.295 2594.91 221.373 2594.29C221.457 2593.65 221.421 2592.98 221.266 2592.29L229.691 2589.09C230.093 2590.42 230.241 2591.87 230.136 2593.46C230.027 2595.03 229.616 2596.61 228.904 2598.19C228.197 2599.75 227.133 2601.2 225.711 2602.55C224.288 2603.89 222.46 2604.99 220.225 2605.86C217.425 2606.95 214.679 2607.32 211.988 2606.98C209.307 2606.64 206.867 2605.55 204.67 2603.72C202.483 2601.88 200.734 2599.28 199.423 2595.9C198.104 2592.5 197.649 2589.39 198.058 2586.56C198.463 2583.71 199.546 2581.26 201.308 2579.21C203.066 2577.14 205.316 2575.58 208.057 2574.51C209.984 2573.77 211.858 2573.34 213.682 2573.24C215.505 2573.14 217.224 2573.36 218.839 2573.89C220.45 2574.42 221.913 2575.28 223.228 2576.46C224.544 2577.64 225.649 2579.15 226.544 2580.98Z",
    fill: "white"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M246.062 2595.35L234.218 2564.84L247.386 2559.73C249.651 2558.85 251.805 2558.52 253.851 2558.76C255.896 2558.99 257.705 2559.74 259.277 2560.99C260.848 2562.24 262.055 2563.95 262.895 2566.12C263.743 2568.3 263.991 2570.38 263.639 2572.36C263.296 2574.33 262.419 2576.09 261.006 2577.63C259.604 2579.17 257.741 2580.39 255.417 2581.29L247.551 2584.35L245.053 2577.91L251.25 2575.51C252.223 2575.13 252.987 2574.64 253.541 2574.03C254.101 2573.42 254.442 2572.72 254.562 2571.94C254.693 2571.16 254.59 2570.33 254.255 2569.47C253.916 2568.6 253.438 2567.92 252.821 2567.46C252.211 2566.97 251.495 2566.7 250.672 2566.64C249.856 2566.57 248.961 2566.73 247.988 2567.1L245.068 2568.24L254.345 2592.13L246.062 2595.35Z",
    fill: "white"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M273.711 2584.61L264.827 2561.73L272.812 2558.63L274.501 2562.98L274.739 2562.89C274.532 2561.12 274.735 2559.68 275.35 2558.59C275.974 2557.49 276.897 2556.7 278.119 2556.23C278.476 2556.09 278.84 2555.98 279.211 2555.91C279.588 2555.82 279.959 2555.76 280.326 2555.73L283.05 2562.75C282.589 2562.77 282.047 2562.86 281.424 2563.02C280.801 2563.18 280.276 2563.34 279.849 2563.51C279.044 2563.82 278.391 2564.29 277.888 2564.91C277.391 2565.51 277.086 2566.21 276.973 2567.01C276.856 2567.8 276.968 2568.63 277.307 2569.5L281.934 2581.42L273.711 2584.61Z",
    fill: "white"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M301.715 2574.22C299.272 2575.17 296.985 2575.52 294.855 2575.27C292.731 2575.01 290.851 2574.19 289.215 2572.8C287.585 2571.4 286.292 2569.47 285.336 2567C284.418 2564.64 284.093 2562.39 284.36 2560.25C284.627 2558.11 285.439 2556.21 286.795 2554.56C288.151 2552.9 290.011 2551.61 292.375 2550.69C294.103 2550.02 295.771 2549.68 297.38 2549.68C298.988 2549.67 300.488 2549.98 301.878 2550.62C303.264 2551.25 304.507 2552.18 305.606 2553.43C306.706 2554.67 307.608 2556.2 308.314 2558.01L309.054 2559.92L288.615 2567.86L286.857 2563.33L299.728 2558.33C299.464 2557.68 299.071 2557.17 298.551 2556.8C298.036 2556.42 297.452 2556.19 296.798 2556.12C296.15 2556.05 295.483 2556.14 294.798 2556.4C294.132 2556.66 293.577 2557.04 293.133 2557.55C292.685 2558.04 292.388 2558.6 292.244 2559.23C292.109 2559.85 292.16 2560.5 292.399 2561.18L294.296 2566.06C294.581 2566.8 294.989 2567.39 295.521 2567.85C296.052 2568.31 296.67 2568.59 297.373 2568.69C298.076 2568.79 298.835 2568.69 299.65 2568.37C300.216 2568.15 300.701 2567.87 301.106 2567.53C301.521 2567.19 301.84 2566.8 302.062 2566.37C302.28 2565.93 302.386 2565.47 302.379 2564.98L309.887 2562.07C310.245 2563.76 310.17 2565.37 309.662 2566.92C309.15 2568.45 308.225 2569.85 306.886 2571.12C305.554 2572.36 303.83 2573.4 301.715 2574.22Z",
    fill: "white"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M320.932 2539.95L323.246 2545.91L307.932 2551.85L305.618 2545.89L320.932 2539.95ZM317.422 2567.64L308.284 2544.11C307.551 2542.22 307.282 2540.52 307.475 2539.02C307.668 2537.52 308.261 2536.22 309.254 2535.12C310.246 2534.03 311.577 2533.16 313.245 2532.51C314.288 2532.11 315.332 2531.79 316.376 2531.57C317.431 2531.34 318.22 2531.2 318.743 2531.13L319.842 2537.49C319.509 2537.52 319.134 2537.58 318.718 2537.69C318.298 2537.78 317.938 2537.89 317.64 2538C316.866 2538.31 316.408 2538.67 316.267 2539.1C316.126 2539.54 316.16 2540.02 316.368 2540.56L325.645 2564.45L317.422 2567.64Z",
    fill: "white"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M343.418 2558.03C340.975 2558.98 338.689 2559.33 336.559 2559.08C334.434 2558.82 332.554 2558 330.919 2556.61C329.289 2555.21 327.996 2553.28 327.04 2550.81C326.122 2548.45 325.797 2546.2 326.064 2544.06C326.331 2541.92 327.143 2540.02 328.499 2538.37C329.855 2536.71 331.715 2535.42 334.079 2534.5C335.807 2533.83 337.475 2533.49 339.083 2533.49C340.692 2533.48 342.191 2533.79 343.582 2534.43C344.968 2535.06 346.211 2535.99 347.31 2537.23C348.409 2538.48 349.312 2540.01 350.017 2541.82L350.758 2543.73L330.319 2551.66L328.561 2547.14L341.432 2542.14C341.167 2541.49 340.775 2540.98 340.254 2540.61C339.74 2540.22 339.156 2540 338.501 2539.93C337.853 2539.85 337.187 2539.95 336.501 2540.21C335.836 2540.47 335.281 2540.85 334.837 2541.36C334.389 2541.85 334.092 2542.41 333.947 2543.04C333.812 2543.66 333.864 2544.31 334.102 2544.98L335.999 2549.87C336.285 2550.61 336.693 2551.2 337.225 2551.66C337.756 2552.11 338.374 2552.39 339.077 2552.5C339.78 2552.6 340.539 2552.5 341.353 2552.18C341.919 2551.96 342.405 2551.68 342.81 2551.34C343.225 2551 343.543 2550.61 343.765 2550.18C343.984 2549.74 344.089 2549.28 344.082 2548.79L351.59 2545.88C351.949 2547.56 351.874 2549.18 351.366 2550.73C350.854 2552.26 349.928 2553.66 348.59 2554.93C347.258 2556.17 345.534 2557.21 343.418 2558.03Z",
    fill: "white"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M357.814 2551.96L348.931 2529.08L356.916 2525.98L358.605 2530.33L358.843 2530.24C358.635 2528.47 358.839 2527.03 359.453 2525.94C360.078 2524.84 361.001 2524.05 362.223 2523.58C362.58 2523.44 362.944 2523.33 363.315 2523.26C363.692 2523.17 364.063 2523.11 364.43 2523.08L367.154 2530.1C366.692 2530.12 366.15 2530.21 365.528 2530.37C364.905 2530.53 364.38 2530.69 363.953 2530.86C363.148 2531.17 362.495 2531.64 361.992 2532.25C361.495 2532.86 361.19 2533.56 361.077 2534.36C360.96 2535.15 361.071 2535.98 361.411 2536.85L366.037 2548.77L357.814 2551.96Z",
    fill: "white"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M376.003 2544.9L367.12 2522.02L375.105 2518.92L376.794 2523.27L377.032 2523.18C376.824 2521.4 377.028 2519.97 377.642 2518.88C378.267 2517.78 379.19 2516.99 380.412 2516.51C380.769 2516.38 381.133 2516.27 381.504 2516.19C381.881 2516.1 382.252 2516.05 382.619 2516.02L385.343 2523.03C384.881 2523.05 384.339 2523.14 383.717 2523.31C383.094 2523.47 382.569 2523.63 382.142 2523.8C381.337 2524.11 380.684 2524.57 380.181 2525.19C379.684 2525.8 379.379 2526.5 379.266 2527.3C379.149 2528.08 379.26 2528.92 379.6 2529.79L384.227 2541.71L376.003 2544.9Z",
    fill: "white"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M404.008 2534.51C401.564 2535.46 399.278 2535.81 397.148 2535.56C395.024 2535.3 393.144 2534.47 391.508 2533.09C389.878 2531.68 388.585 2529.75 387.629 2527.29C386.711 2524.93 386.386 2522.68 386.653 2520.54C386.92 2518.4 387.732 2516.5 389.088 2514.84C390.444 2513.19 392.304 2511.9 394.668 2510.98C396.396 2510.31 398.064 2509.97 399.673 2509.96C401.281 2509.96 402.781 2510.27 404.171 2510.91C405.557 2511.54 406.8 2512.47 407.899 2513.71C408.998 2514.95 409.901 2516.48 410.606 2518.3L411.347 2520.21L390.908 2528.14L389.15 2523.61L402.021 2518.62C401.757 2517.96 401.364 2517.45 400.844 2517.09C400.329 2516.7 399.745 2516.48 399.091 2516.41C398.443 2516.33 397.776 2516.42 397.091 2516.69C396.425 2516.95 395.87 2517.33 395.426 2517.83C394.978 2518.33 394.681 2518.89 394.536 2519.52C394.401 2520.14 394.453 2520.79 394.692 2521.46L396.589 2526.35C396.874 2527.08 397.282 2527.68 397.814 2528.14C398.345 2528.59 398.963 2528.87 399.666 2528.98C400.369 2529.08 401.128 2528.97 401.942 2528.66C402.508 2528.44 402.994 2528.16 403.399 2527.82C403.814 2527.47 404.133 2527.09 404.355 2526.66C404.573 2526.22 404.678 2525.76 404.671 2525.27L412.179 2522.35C412.538 2524.04 412.463 2525.66 411.955 2527.2C411.443 2528.74 410.517 2530.14 409.179 2531.4C407.847 2532.65 406.123 2533.69 404.008 2534.51Z",
    fill: "white"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M426.802 2525.52C425.173 2526.15 423.508 2526.31 421.806 2525.99C420.114 2525.66 418.518 2524.79 417.019 2523.37C415.53 2521.95 414.272 2519.92 413.247 2517.28C412.175 2514.51 411.731 2512.1 411.914 2510.04C412.107 2507.98 412.728 2506.28 413.776 2504.95C414.834 2503.61 416.118 2502.65 417.628 2502.07C418.76 2501.63 419.83 2501.44 420.838 2501.51C421.843 2501.56 422.76 2501.81 423.591 2502.24C424.417 2502.66 425.13 2503.2 425.729 2503.86L425.848 2503.81L421.337 2492.19L429.56 2489L441.404 2519.51L433.241 2522.68L431.783 2518.92L431.605 2518.99C431.588 2519.89 431.401 2520.76 431.044 2521.61C430.693 2522.44 430.165 2523.2 429.46 2523.89C428.76 2524.56 427.874 2525.1 426.802 2525.52ZM427.389 2518.02C428.143 2517.73 428.704 2517.26 429.071 2516.62C429.443 2515.96 429.618 2515.17 429.593 2514.25C429.575 2513.32 429.35 2512.3 428.918 2511.19C428.479 2510.06 427.954 2509.15 427.344 2508.46C426.739 2507.76 426.081 2507.3 425.369 2507.08C424.663 2506.85 423.933 2506.89 423.178 2507.18C422.424 2507.47 421.863 2507.94 421.496 2508.59C421.136 2509.22 420.969 2510 420.998 2510.92C421.032 2511.84 421.269 2512.86 421.708 2513.99C422.148 2515.12 422.665 2516.04 423.259 2516.75C423.859 2517.44 424.507 2517.9 425.203 2518.14C425.905 2518.35 426.634 2518.32 427.389 2518.02Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotC);
export default __webpack_public_path__ + "static/media/LotC.7973a83fc194165b31dc9715cd3a5315.svg";
export { ForwardRef as ReactComponent };